"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const helper_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/helper.utils");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const company_repository_1 = require("../../../../org-service/src/app/company/company.repository");
const constants_2 = require("../../../../service-lib/src/lib/constants");
const entities_1 = require("../../../../service-lib/src/lib/entities");
const opportunity_utils_1 = require("../../../../service-lib/src/lib/utils/opportunity.utils");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let OpportunityRepository = class OpportunityRepository {
    constructor(opportunityRepository, opportunityContactMapRepository, lookUpRepository, opportunityActivityMapRepository, opportunityActivityParticipantsRepository, dataValidationRepository, kdmMeetingRepository, handOverMeetRepository, activityRepository, mandateDetailsEntryRepository, rfpCoverDetailRepository, quoteRepo, opportunityQuoteRepo, quoteEntryDocumentMapRepo, quoteTaxRepo, quoteDocRepo, placementRepo, tpaRepo, installemnetRepo, insurerRepo, sharingRepo, cdRepo, coverRepo, companyContactMapRepo, opportunityRfpDetailsEntryRepository, entityService, scopeService) {
        this.opportunityRepository = opportunityRepository;
        this.opportunityContactMapRepository = opportunityContactMapRepository;
        this.lookUpRepository = lookUpRepository;
        this.opportunityActivityMapRepository = opportunityActivityMapRepository;
        this.opportunityActivityParticipantsRepository = opportunityActivityParticipantsRepository;
        this.dataValidationRepository = dataValidationRepository;
        this.kdmMeetingRepository = kdmMeetingRepository;
        this.handOverMeetRepository = handOverMeetRepository;
        this.activityRepository = activityRepository;
        this.mandateDetailsEntryRepository = mandateDetailsEntryRepository;
        this.rfpCoverDetailRepository = rfpCoverDetailRepository;
        this.quoteRepo = quoteRepo;
        this.opportunityQuoteRepo = opportunityQuoteRepo;
        this.quoteEntryDocumentMapRepo = quoteEntryDocumentMapRepo;
        this.quoteTaxRepo = quoteTaxRepo;
        this.quoteDocRepo = quoteDocRepo;
        this.placementRepo = placementRepo;
        this.tpaRepo = tpaRepo;
        this.installemnetRepo = installemnetRepo;
        this.insurerRepo = insurerRepo;
        this.sharingRepo = sharingRepo;
        this.cdRepo = cdRepo;
        this.coverRepo = coverRepo;
        this.companyContactMapRepo = companyContactMapRepo;
        this.opportunityRfpDetailsEntryRepository = opportunityRfpDetailsEntryRepository;
        this.entityService = entityService;
        this.scopeService = scopeService;
        this.transformPolicyResponse = (policy) => {
            if (!policy) {
                return null;
            }
            return {
                basicDetails: {
                    id: policy.id,
                    policyName: policy.policyName,
                    policyPeriod: `${policy.policyFrom} to ${policy.policyTo}`,
                    sumInsured: policy.sumInsured,
                    premiumAtInception: policy.premiumAtInception,
                    serviceTax: policy.serviceTax,
                    gst: policy.gst,
                    insurerPolicyNumber: policy.insurerPolicyNumber,
                    provisionalPolicyNo: policy.provisionalPolicyNo,
                    policyStatus: policy.policyStatus?.lookUpValue,
                    commissionOnTerrorism: policy.commissionTerrorism,
                    servicesLevel: policy.opportunity?.serviceLevel?.lookUpValue,
                    status: policy.policyStatus?.lookUpValue,
                    configurationStatus: policy.configurationStatus?.lookUpValue,
                    enrollmentStatus: policy.enrollmentStatus?.lookUpValue,
                },
                companyDetails: {
                    id: policy.company?.id,
                    companyName: policy.company?.companyName,
                    displayName: policy.company?.displayName,
                    priority: policy.company?.priority?.lookUpValue,
                    country: policy.company?.country?.name,
                    contacts: policy.company?.companyContactMaps?.map((contactMap) => ({
                        contactId: contactMap.contact?.id,
                        displayName: contactMap.contact?.displayName,
                        firstName: contactMap.contact?.firstName,
                        lastName: contactMap.contact?.lastName,
                        department: contactMap.contact?.department,
                        designation: contactMap.contact?.designation,
                    })),
                },
                opportunityInfo: {
                    opportunityId: policy.opportunity?.opportunityId,
                    currentStage: policy.opportunity?.stage?.lookUpValue,
                    currentlyAssignedTo: policy.opportunity?.assignedTo,
                    policyBdExecutive: policy.opportunity?.bdExecutive,
                    activitiesPerformed: policy.opportunity?.activities || [],
                },
                insurerTpaDetails: {
                    tpaDetails: policy.tpaMappings?.map((tpa) => ({
                        id: tpa.tpa.id,
                        tpaName: tpa.tpa?.tpaName,
                        tpaLocation: tpa.tpaBranch?.address1,
                        tpaBranch: tpa.tpaBranch?.cityId?.name,
                        phoneNumber: tpa.tpaBranch?.phoneNumber,
                        email: tpa.tpaBranch?.email,
                        supportNumber: tpa.tpaBranch?.supportNumber,
                    })),
                    insurerDetails: policy.insurerMappings?.map((insurer) => ({
                        id: insurer.insurer.id,
                        insurerName: insurer.insurer?.insurerName,
                        insurerLocation: insurer.insurerBranch?.address1,
                        insurerBranch: insurer.insurerBranch?.cityId?.name,
                        contactDetails: {
                            contactId: insurer.insurerContact?.id,
                            firstName: insurer.insurerContact?.firstName,
                            lastName: insurer.insurerContact?.lastName,
                            displayName: insurer.insurerContact?.displayName,
                            email: insurer.insurerContact?.email,
                            phoneNumber: insurer.insurerBranch?.phoneNumber,
                            supportNumber: insurer.insurerContact?.supportNumber,
                        },
                        insurerParticipationType: insurer.insurerParticipationType?.lookUpValue,
                    })),
                },
                covers: policy.coverMappings?.map((cover) => ({
                    id: cover.id,
                    coverName: cover.coverName,
                    coverResponse: cover.coverResponse,
                })),
                cdDetails: policy.cdMappings?.map((cd) => ({
                    id: cd.id,
                    cdNumber: cd.cdDetail?.chequeNumber,
                    bankName: cd.cdDetail?.bankName,
                    chequeAmount: cd.cdDetail?.chequeAmount,
                    chequeDate: cd.cdDetail?.chequeDate,
                })),
                installments: policy.premiumInstallments?.map((installment) => ({
                    id: installment.id,
                    installment1: installment.installment1,
                    installment2: installment.installment2,
                })),
            };
        };
    }
    // Retrieves a list of opportunities with filtering, sorting, and pagination.
    async getAllOpportunities(page, limit, searchArray, sort, searchBy, userId, field, fromDate, toDate, period) {
        try {
            let periodStartAndEndDate;
            if (period) {
                try {
                    const fromToDate = (0, helper_utils_1.getDurationDates)(period);
                    periodStartAndEndDate = {
                        field: "createdAt",
                        from: fromToDate.startDate,
                        to: fromToDate.endDate,
                    };
                }
                catch (error) {
                    throw new common_1.BadRequestException(error.message);
                }
            }
            let dateFilter;
            if (fromDate && field) {
                dateFilter = {
                    field: field,
                    from: fromDate,
                    to: toDate,
                };
            }
            const relations = [
                "company",
                "contact",
                "policyType",
                "policyStatus",
                "serviceLevel",
                "stage",
                "opportunityType",
                "opportunityContactMap",
                "opportunityContactMap.contact",
                "company.priority",
                "company.industrySegment",
                "owner",
                "opportunityRiskLocations",
                "opportunityRiskLocations.address",
                "opportunityRiskLocations.address.cityId",
            ];
            const { data, count } = await this.scopeService.validateScope({
                entity: "Opportunity", // Replace with the actual entity name
                page: page,
                limit: limit,
                sort: sort,
                relations: relations,
                where: undefined,
                select: undefined,
                searchArray: searchArray,
                userFilter: undefined,
                searchString: searchBy,
                searchOn: constants_2.opportunitySearchObject,
                dateFilter: dateFilter && Object.keys(dateFilter).length > 0
                    ? dateFilter
                    : undefined,
                period: periodStartAndEndDate,
            }, userId, "opportunity");
            // const { data, count } = await this.entityService.fetchEntityList(
            //   "Opportunity", // Replace with the actual entity name
            //   page,
            //   limit,
            //   sort,
            //   relations,
            //   { createdBy: userId },
            //   undefined,
            //   searchArray,
            //   undefined,
            //   searchBy,
            //   opportunitySearchObject,
            //   dateFilter && Object.keys(dateFilter).length > 0
            //     ? (dateFilter as { field: string; from: Date; to: Date })
            //     : undefined,
            //   periodStartAndEndDate,
            //   true
            // );
            if (!data || data.length === 0) {
                return {
                    data: [],
                    count: 0,
                    opportunityLeads: 0,
                    opportunityProspects: 0,
                    opportunityQcr: 0,
                    opportunityClients: 0,
                    salesOpportunityCount: 0,
                    renewalOpportunityCount: 0,
                };
            }
            const transformOpportunityData = (data) => {
                return data.map((opportunity) => ({
                    opportunityId: opportunity.opportunityId,
                    companyId: opportunity.company?.id ?? null,
                    companyName: opportunity.company?.companyName ?? null,
                    policyType: opportunity.policyType?.lookUpValue ?? null,
                    activityName: null,
                    stage: opportunity.stage?.lookUpValue ?? null,
                    priority: opportunity.company?.priority?.lookUpValue ?? null,
                    opportunityCreationDate: opportunity.createdAt instanceof Date
                        ? opportunity.createdAt.toISOString().split("T")[0]
                        : null,
                    assignedTo: opportunity.owner?.firstName || opportunity.owner?.lastName
                        ? `${opportunity.owner.firstName} ${opportunity.owner.lastName}`
                        : null,
                    branch: null,
                    expectedCloseDate: opportunity.soExpireDate ?? null,
                    premium: opportunity.premiumPaid ?? null,
                    sumInsured: opportunity.sumInsured ?? null,
                    industrySegment: opportunity.company?.industrySegment?.lookUpValue ?? null,
                    contacts: opportunity.opportunityContactMap.map((contact) => ({
                        id: contact.contact.id,
                        displayName: contact.contact.displayName,
                    })),
                }));
            };
            const transformedData = transformOpportunityData(data);
            const kpiCounts = await this.getOpportunityKpis(userId, searchArray, relations);
            const selectedFields = [
                "companyId",
                "opportunityId",
                "sumInsured",
                "premiumPaid",
            ];
            // Fetch overall data without relations and with specific fields
            const { data: overallData } = await this.entityService.fetchEntityList("Opportunity", 1, count, [], relations, { createdBy: userId }, selectedFields, searchArray, undefined, searchBy, undefined, dateFilter && Object.keys(dateFilter).length > 0
                ? dateFilter
                : undefined, periodStartAndEndDate, false);
            // Calculate totals
            const totalUniqueCompanies = new Set(overallData.map((opportunity) => opportunity.companyId)).size;
            const totalOpportunities = overallData.length;
            const totalPremium = overallData.reduce((sum, opportunity) => sum + (opportunity.premiumPaid || 0), 0);
            const totalSumInsured = overallData.reduce((sum, opportunity) => sum + (opportunity.sumInsured || 0), 0);
            return {
                data: transformedData,
                count,
                opportunityLeads: totalOpportunities,
                opportunityProspects: totalUniqueCompanies,
                opportunityQcr: totalPremium,
                opportunityClients: totalSumInsured,
                salesOpportunityCount: kpiCounts?.find((item) => item.optyTypeKey === constants_1.OPPORTUNITY_TYPES[0])
                    ?.count ?? 0,
                renewalOpportunityCount: kpiCounts?.find((item) => item.optyTypeKey === constants_1.OPPORTUNITY_TYPES[1])
                    ?.count ?? 0,
            };
        }
        catch (error) {
            throw new Error(`Failed to retrieve opportunities: ${error.message}`);
        }
    }
    // Creates a new opportunity.
    async createOpportunity(entityManager, opportunityData) {
        try {
            // Check if the company exists
            const companyRepository = new company_repository_1.CompanyRepository(entityManager.getRepository(entities_1.Company), this.entityService, entityManager.connection);
            if (!opportunityData.companyId) {
                throw new Error("Company ID is required.");
            }
            const companyExists = await companyRepository.fetchByCompanyId(opportunityData.companyId);
            if (!companyExists) {
                throw new common_1.NotFoundException(`Company with ID ${opportunityData.companyId} does not exist`);
            }
            //set the opportunity status to open after creation
            const taskType = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_2.OPPORTUNITY_STATUS_OPEN },
            });
            if (!taskType) {
                throw new common_1.NotFoundException(`Task type with key ${constants_2.OPPORTUNITY_STATUS_OPEN} not found`);
            }
            const opportunity = entityManager.create(entities_1.Opportunity, {
                ...opportunityData,
                ownerId: opportunityData.ownerId ?? opportunityData.createdBy,
                statusLid: taskType.id,
            });
            return await entityManager.save(opportunity);
        }
        catch (error) {
            throw new Error(`Failed to create opportunity: ${error.message}`);
        }
    }
    async createRiskLocation(entityManager, riskLocation) {
        try {
            const riskLocationData = entityManager.create(entities_1.OpportunityRiskLocations, riskLocation);
            return await entityManager.save(riskLocationData);
        }
        catch (error) {
            throw new Error(`Failed to create opportunity risk location: ${error.message}`);
        }
    }
    async createPreviousPlacementDetails(entityManager, previousPlacementDetails) {
        try {
            const placementDetailsData = entityManager.create(entities_1.OpportunityPreviousPlacementDetails, previousPlacementDetails);
            return await entityManager.save(placementDetailsData);
        }
        catch (error) {
            throw new Error(`Failed to create opportunity previous placement details: ${error.message}`);
        }
    }
    async createPreviousMediatorDetails(entityManager, previousMediatorDetails) {
        try {
            const companyRepository = new company_repository_1.CompanyRepository(entityManager.getRepository(entities_1.Company), this.entityService, entityManager.connection);
            if (!previousMediatorDetails.companyId) {
                throw new common_1.BadRequestException(`Company ID is required.`);
            }
            const companyExists = await companyRepository.fetchByCompanyId(previousMediatorDetails.companyId);
            if (!companyExists) {
                throw new common_1.NotFoundException(`Company with ID ${previousMediatorDetails.companyId} does not exist`);
            }
            if (!previousMediatorDetails.locationId) {
                throw new common_1.BadRequestException(`Location ID is required.`);
            }
            if (!previousMediatorDetails.branchId) {
                throw new common_1.BadRequestException(`Branch ID is required.`);
            }
            if (!previousMediatorDetails.mediatorTypeId) {
                throw new common_1.BadRequestException(`Mediator Type ID is required.`);
            }
            if (previousMediatorDetails.mediatorTypeId !== constants_1.TPA_MEDIATOR_TYPE &&
                previousMediatorDetails.mediatorTypeId !== constants_1.INSURER_MEDIATOR_TYPE) {
                throw new common_1.BadRequestException(`Invalid Mediator Type ID.`);
            }
            const mediatorDetailsData = entityManager.create(entities_1.OpportunityPreviousMediatorDetails, previousMediatorDetails);
            return await entityManager.save(mediatorDetailsData);
        }
        catch (error) {
            throw new Error(`Failed to create opportunity previous mediator details: ${error.message}`);
        }
    }
    async createContactMap(entityManager, contactMap) {
        try {
            const existingContact = await this.opportunityRepository.manager.findOne(entities_1.OpportunityContactMap, {
                where: {
                    contactId: contactMap.contactId,
                    opportunityId: contactMap.opportunityId,
                },
            });
            if (existingContact) {
                throw new common_1.BadRequestException(`Contact with ID ${contactMap.contactId} already exists for this opportunity`);
            }
            const contactExists = await this.fetchByCompanyContactId(contactMap.companyId, contactMap.contactId);
            if (!contactExists) {
                throw new common_1.NotFoundException(`Contact with ID ${contactMap.contactId} does not belong to the company with ID ${contactMap.companyId}`);
            }
            const contactMapData = entityManager.create(entities_1.OpportunityContactMap, contactMap);
            return await entityManager.save(contactMapData);
        }
        catch (error) {
            throw new Error(`Failed to create opportunity contact map: ${error.message}`);
        }
    }
    async createClaimExperience(entityManager, claimExperience) {
        try {
            const claimExperienceData = entityManager.create(entities_1.OpportunityClaimExperiences, claimExperience);
            return await entityManager.save(claimExperienceData);
        }
        catch (error) {
            throw new Error(`Failed to create opportunity claim experience: ${error.message}`);
        }
    }
    async createOppDocument(entityManager, oppDocument) {
        try {
            const documentExists = await entityManager.findOne(entities_1.FileUpload, {
                where: { id: oppDocument.documentId },
            });
            if (!documentExists) {
                throw new Error(`Document with id ${oppDocument.documentId} does not exist in file_uploads`);
            }
            const oppDocumentData = entityManager.create(entities_1.OpportunityDocuments, {
                ...oppDocument,
                document: documentExists,
            });
            return await entityManager.save(oppDocumentData);
        }
        catch (error) {
            throw new Error(`Failed to create opportunity document: ${error.message}`);
        }
    }
    async createCompetitor(entityManager, competitor) {
        try {
            const competitorData = entityManager.create(entities_1.OpportunityCompetitors, competitor);
            return await entityManager.save(competitorData);
        }
        catch (error) {
            throw new Error(`Failed to create opportunity competitor: ${error.message}`);
        }
    }
    async createChallenge(entityManager, challenge) {
        try {
            const challengeData = entityManager.create(entities_1.OpportunityChallenges, challenge);
            return await entityManager.save(challengeData);
        }
        catch (error) {
            throw new Error(`Failed to create opportunity challenge: ${error.message}`);
        }
    }
    async storeCovers(entityManager, opportunityId, policyTypeId) {
        try {
            // Step 1: Fetch cover templates
            const coverTemplates = await entityManager.find(entities_1.MstrCoverTemplate, {
                where: { policyTypeId },
            });
            if (!coverTemplates.length) {
                throw new common_1.NotFoundException(`No cover templates found for policyTypeId: ${policyTypeId}`);
            }
            // Step 2: Map the fetched cover templates to create OpportunityCoverMap entities
            const coversData = coverTemplates.map((tpl) => {
                const record = new entities_1.OpportunityCoverMap(opportunityId, tpl.policyTypeId, tpl.refCoverId, tpl.mandatory, constants_1.DEFAULT_APPROVAL_REQUIRED, // default value for approvalRequired
                tpl.coverName, tpl.coverDescription, tpl.displaySequence, tpl.displayCategory, tpl.coverTypeLid, tpl.inputType, tpl.inputLov, tpl.coversMeta);
                return record;
            });
            // Step 3: Save the mapped covers
            await entityManager.save(entities_1.OpportunityCoverMap, coversData);
        }
        catch (error) {
            console.error("Error while storing opportunity covers:", error.message);
            throw new Error("Failed to store opportunity covers:", error.message);
        }
    }
    // Retrieves an opportunity by its ID.
    async getOpportunityById(opportunityId, userId) {
        try {
            const editValidation = await this.scopeService.validateResourceScope(userId, "opportunity", "edit", opportunityId);
            const opportunity = await this.opportunityRepository.findOne({
                where: { opportunityId },
                relations: [
                    "company",
                    "contact",
                    "owner",
                    "policyType",
                    "policyStatus",
                    "serviceLevel",
                    "opportunityType",
                    "opportunitySourceType",
                    "isPolicyMined",
                    "opportunityClaimExperiences",
                    "opportunityDocuments",
                    "opportunityRiskLocations",
                    "opportunityRiskLocations.address",
                    "opportunityRiskLocations.address.cityId",
                    "previousPlacementDetails",
                    "previousMediatorDetails",
                    "previousMediatorDetails.location",
                    "previousMediatorDetails.branch",
                    "previousMediatorDetails.company",
                    "opportunityContactMap.contact",
                    "opportunityContactMap.contact.salutation",
                    "opportunityContactMap.contact.tag",
                    "opportunityContactMap.contact.owner",
                    "opportunityContactMap.contact.status",
                    //"opportunityActivityMap",
                    // "opportunityActivityMap.leadRole",
                    // "opportunityActivityParticipants",
                    // "opportunityActivityParticipants.activity",
                    // "opportunityActivityParticipants.participant",
                    "opportunityContactMap.contact.communicationDetails",
                ],
                select: {
                    company: {
                        id: true,
                        companyName: true,
                    },
                    contact: {
                        id: true,
                        displayName: true,
                    },
                    policyType: {
                        id: true,
                        lookUpValue: true,
                    },
                    policyStatus: {
                        id: true,
                        lookUpValue: true,
                    },
                    serviceLevel: {
                        id: true,
                        lookUpValue: true,
                    },
                    stage: {
                        id: true,
                        lookUpValue: true,
                    },
                },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotFound);
            }
            const filteredData = this.transformOpportunityResponse(opportunity);
            filteredData.editable = editValidation;
            return filteredData;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new Error(error.message);
        }
    }
    // Updates an existing opportunity by its ID.
    async updateOpportunity(entityManager, opportunityId, opportunityData, userId) {
        // eslint-disable-next-line no-useless-catch
        try {
            const existingOpportunity = await entityManager.findOne(entities_1.Opportunity, {
                where: { opportunityId },
            });
            if (!existingOpportunity) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotFound);
            }
            const companyRepository = new company_repository_1.CompanyRepository(entityManager.getRepository(entities_1.Company), this.entityService, entityManager.connection);
            if (opportunityData && opportunityData.companyId) {
                const companyExists = await companyRepository.fetchByCompanyId(opportunityData.companyId);
                if (!companyExists) {
                    throw new common_1.NotFoundException(`Company with ID ${opportunityData.companyId} does not exist`);
                }
            }
            const updateResult = await entityManager.update(entities_1.Opportunity, { opportunityId }, {
                ...opportunityData,
                updatedBy: userId,
            });
            if (updateResult.affected === 0) {
                throw new Error(`Failed to update opportunity with id ${opportunityId}`);
            }
            const updatedOpportunity = await this.getOpportunityById(opportunityId);
            return updatedOpportunity;
        }
        catch (error) {
            throw error;
        }
    }
    async getClaimExperienceByIdAndOpportunityId(claimExperienceId, opportunityId) {
        try {
            return await this.opportunityRepository.manager.findOne(entities_1.OpportunityClaimExperiences, {
                where: {
                    id: claimExperienceId,
                    opportunityId,
                },
            });
        }
        catch (error) {
            throw new Error(`Failed to retrieve claim experience with id ${claimExperienceId} for opportunity id ${opportunityId}: ${error.message}`);
        }
    }
    async updateClaimExperience(entityManager, claimExperienceData) {
        const { id, ...updateData } = claimExperienceData;
        await entityManager.update(entities_1.OpportunityClaimExperiences, { id }, updateData);
    }
    async updateRiskLocations(entityManager, opportunityId, updateRiskLocations) {
        const existingRiskLocationsData = await entityManager.find(entities_1.OpportunityRiskLocations, { where: { opportunityId } });
        // Extract addressIds from the payload and existing records
        const updateRiskLocationsData = updateRiskLocations.map((location) => Number(location.addressId));
        const existingRiskLocations = existingRiskLocationsData.map((location) => Number(location.addressId));
        // Find new addressIds to create
        const createRiskLocationsData = updateRiskLocationsData.filter((id) => !existingRiskLocations.includes(id));
        if (createRiskLocationsData.length > 0) {
            await entityManager.save(entities_1.OpportunityRiskLocations, createRiskLocationsData.map((addressId) => ({
                opportunityId,
                addressId,
            })));
        }
        // Find addressIds to delete
        const deletingRiskLocationsData = existingRiskLocations.filter((id) => !updateRiskLocationsData.includes(id));
        if (deletingRiskLocationsData.length > 0) {
            for (const addressId of deletingRiskLocationsData) {
                await entityManager.delete(entities_1.OpportunityRiskLocations, {
                    opportunityId,
                    addressId,
                });
            }
        }
    }
    async getDocumentByIdAndOpportunityId(documentId, opportunityId) {
        try {
            return await this.opportunityRepository.manager.findOne(entities_1.OpportunityDocuments, {
                where: {
                    documentId,
                    opportunityId,
                },
            });
        }
        catch (error) {
            throw new Error(`Failed to retrieve document with id ${documentId} for opportunity id ${opportunityId}: ${error.message}`);
        }
    }
    async getPreviousPlacementDetailsByIdAndOpportunityId(previousPlacementId, opportunityId) {
        try {
            return await this.opportunityRepository.manager.findOne(entities_1.OpportunityPreviousPlacementDetails, {
                where: {
                    id: previousPlacementId,
                    opportunityId,
                },
            });
        }
        catch (error) {
            throw new Error(`Failed to retrieve previous placement details with id ${previousPlacementId} for opportunity id ${opportunityId}: ${error.message}`);
        }
    }
    async updatePreviousPlacementDetails(entityManager, previousPlacementData) {
        const { id, ...updateData } = previousPlacementData;
        await entityManager.update(entities_1.OpportunityPreviousPlacementDetails, { id }, updateData);
    }
    async getPreviousMediatorDetailsByIdAndOpportunityId(previousMediatorId, opportunityId) {
        try {
            return await this.opportunityRepository.manager.findOne(entities_1.OpportunityPreviousMediatorDetails, {
                where: {
                    id: previousMediatorId,
                    opportunityId,
                },
            });
        }
        catch (error) {
            throw new Error(`Failed to retrieve previous mediator details with id ${previousMediatorId} for opportunity id ${opportunityId}: ${error.message}`);
        }
    }
    async updatePreviousMediatorDetails(entityManager, previousMediatorData) {
        try {
            const { id, ...updateData } = previousMediatorData;
            await entityManager.update(entities_1.OpportunityPreviousMediatorDetails, { id }, updateData);
        }
        catch (error) {
            throw new Error(`Failed to update previous mediator details with id ${previousMediatorData.id}: ${error.message}`);
        }
    }
    async updateContactMap(entityManager, opportunityId, updateContacts) {
        try {
            const opportunity = await this.opportunityRepository.manager.findOne(entities_1.Opportunity, { where: { opportunityId } });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${opportunityId} does not exist`);
            }
            const companyId = opportunity.companyId;
            const existingContactsData = await entityManager.find(entities_1.OpportunityContactMap, { where: { opportunityId } });
            const updateContactsData = updateContacts?.map((contact) => Number(contact.contactId));
            const existingContacts = existingContactsData?.map((contact) => Number(contact.contactId));
            // Find new contactIds to create
            const createContactsData = updateContactsData.filter((id) => !existingContacts.includes(id));
            if (createContactsData.length > 0) {
                for (const contactId of createContactsData) {
                    const contactExists = await this.fetchByCompanyContactId(companyId, contactId);
                    if (!contactExists) {
                        throw new common_1.NotFoundException(`Contact with ID ${contactId} does not belong to the company with ID ${companyId}`);
                    }
                }
                await entityManager.save(entities_1.OpportunityContactMap, createContactsData.map((contactId) => ({
                    opportunityId,
                    contactId,
                })));
            }
            // Find contactIds to delete
            const deletingContactsData = existingContacts.filter((id) => !updateContactsData.includes(id));
            if (deletingContactsData.length > 0) {
                for (const contactId of deletingContactsData) {
                    await entityManager.delete(entities_1.OpportunityContactMap, {
                        opportunityId,
                        contactId,
                    });
                }
            }
        }
        catch (error) {
            console.error("Error updating contact map:", error);
            throw error instanceof common_1.NotFoundException
                ? error
                : new Error(`Failed to update contacts: ${error.message}`);
        }
    }
    async getCompetitorByIdAndOpportunityId(opportunityCompetitorId, opportunityId) {
        try {
            return await this.opportunityRepository.manager.findOne(entities_1.OpportunityCompetitors, {
                where: {
                    id: opportunityCompetitorId,
                    opportunityId,
                },
            });
        }
        catch (error) {
            throw new Error(`Failed to retrieve competitor with id ${opportunityCompetitorId} for opportunity id ${opportunityId}: ${error.message}`);
        }
    }
    async updateCompetitor(entityManager, competitorData) {
        const { id, ...updateData } = competitorData;
        await entityManager.update(entities_1.OpportunityCompetitors, { id }, updateData);
    }
    async getChallengeByIdAndOpportunityId(oppChallengeId, opportunityId) {
        try {
            return await this.opportunityRepository.manager.findOne(entities_1.OpportunityChallenges, {
                where: {
                    id: oppChallengeId,
                    opportunityId,
                },
            });
        }
        catch (error) {
            throw new Error(`Failed to retrieve challenge with id ${oppChallengeId} for opportunity id ${opportunityId}: ${error.message}`);
        }
    }
    async updateChallenge(entityManager, challengeData) {
        const { id, ...updateData } = challengeData;
        await entityManager.update(entities_1.OpportunityChallenges, { id }, updateData);
    }
    // Soft deletes an opportunity by its ID by updating the deletedAt
    async deleteOpportunityById(opportunityId) {
        const opportunity = await this.opportunityRepository.findOne({
            where: { opportunityId },
        });
        if (!opportunity) {
            throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotFound);
        }
        await this.opportunityRepository.softDelete({ opportunityId });
    }
    removeAuditFields(entity) {
        const { createdBy, updatedBy, createdAt, updatedAt, deletedAt, ...rest } = entity;
        // Rename keys as per the requirement
        if (rest.opportunityRiskLocations) {
            rest.riskLocations = rest.opportunityRiskLocations;
            delete rest.opportunityRiskLocations;
        }
        if (rest.opportunityDocuments) {
            rest.documents = rest.opportunityDocuments;
            delete rest.opportunityDocuments;
        }
        if (rest.opportunityClaimExperiences) {
            rest.claimExperiences = rest.opportunityClaimExperiences;
            delete rest.opportunityClaimExperiences;
        }
        if (rest.opportunityCompetitors) {
            rest.competitors = rest.opportunityCompetitors;
            delete rest.opportunityCompetitors;
        }
        if (rest.opportunityChallenges) {
            rest.challenges = rest.opportunityChallenges;
            delete rest.opportunityChallenges;
        }
        return rest;
    }
    async fetchByCompanyContactId(companyId, contactId) {
        const companyContactRepository = this.opportunityRepository.manager.getRepository("company_contact_map");
        const result = await companyContactRepository.findOne({
            where: {
                companyId,
                contactId,
            },
        });
        return !!result; // Returns true if a record exists, otherwise false
    }
    async getOpportunityActivityMeta(opportunityId, activityId) {
        return await (0, opportunity_utils_1.fetchActivityMeta)(this.opportunityActivityMapRepository, opportunityId, activityId);
    }
    async getOpportunityActivityById(opportunityActivityId) {
        return await (0, opportunity_utils_1.getOpportunityAndActivityIdsByOpportunityActivityId)(this.opportunityActivityMapRepository, this.activityRepository, opportunityActivityId);
    }
    transformOpportunityResponse(opportunity) {
        return {
            opportunityId: opportunity.opportunityId,
            estimatedBrokerage: opportunity.estimatedBrokerage,
            soExpireDate: opportunity.soExpireDate,
            sumInsured: opportunity.sumInsured,
            premiumPaid: opportunity.premiumPaid,
            estimatedFee: opportunity.estimatedFee,
            source: opportunity.source,
            owner: opportunity.owner
                ? `${opportunity?.owner?.firstName ?? ""} ${opportunity?.owner?.lastName ?? ""}`.trim()
                : null,
            salesPitch: opportunity.salesPitch,
            soCreatedDate: opportunity.createdAt
                ? opportunity.createdAt.toISOString().split("T")[0]
                : null,
            company: {
                companyName: opportunity.company.companyName,
                id: opportunity.company.id,
                country: {
                    name: opportunity?.company?.country?.name ?? null,
                    id: opportunity?.company?.country?.id ?? null,
                },
            },
            policyType: opportunity.policyType
                ? {
                    id: opportunity.policyType.id,
                    lookUpValue: opportunity.policyType.lookUpValue,
                }
                : null,
            policyStatus: opportunity.policyStatus
                ? {
                    id: opportunity.policyStatus.id,
                    lookUpValue: opportunity.policyStatus.lookUpValue,
                }
                : null,
            serviceLevel: opportunity.serviceLevel
                ? {
                    id: opportunity.serviceLevel.id,
                    lookUpValue: opportunity.serviceLevel.lookUpValue,
                }
                : null,
            opportunityType: opportunity.opportunityType
                ? {
                    id: opportunity.opportunityType.id,
                    lookUpValue: opportunity.opportunityType.lookUpValue,
                }
                : null,
            opportunitySource: opportunity.opportunitySourceType
                ? {
                    id: opportunity.opportunitySourceType.id,
                    lookUpValue: opportunity.opportunitySourceType.lookUpValue,
                }
                : null,
            isPolicyMined: opportunity.isPolicyMined
                ? {
                    id: opportunity.isPolicyMined.id,
                    lookUpValue: opportunity.isPolicyMined.lookUpValue,
                }
                : null,
            riskLocations: opportunity.opportunityRiskLocations.map((riskLocation) => ({
                id: riskLocation.id,
                opportunityId: riskLocation.opportunityId,
                addressId: riskLocation.addressId,
                address: {
                    id: riskLocation.address.id,
                    address1: riskLocation.address.address1,
                    address2: riskLocation.address.address2,
                    city: riskLocation.address.cityId,
                    state: riskLocation.address.stateId,
                    country: riskLocation.address.countryId,
                    pinCode: riskLocation.address.pinCode,
                },
            })),
            documents: opportunity.opportunityDocuments.map((document) => ({
                id: document.id,
                opportunityId: document.opportunityId,
                documentId: document.documentId,
            })),
            claimExperiences: opportunity.opportunityClaimExperiences.map((claimExperience) => ({
                id: claimExperience.id,
                opportunityId: claimExperience.opportunityId,
                policyFrom: claimExperience.policyFrom,
                policyTo: claimExperience.policyTo,
                natureOfLoss: claimExperience.natureOfLoss,
                premium: claimExperience.premium,
                claimAmount: claimExperience.claimAmount,
                claimPercentage: claimExperience.claimPercentage,
                remarks: claimExperience.remarks,
            })),
            previousMediatorDetails: opportunity.previousMediatorDetails.map((mediatorDetails) => ({
                id: mediatorDetails.id,
                opportunityId: mediatorDetails.opportunityId,
                companyId: mediatorDetails.companyId,
                mediator: {
                    id: mediatorDetails.mediatorTypeId,
                    name: constants_1.MEDIATOR_TYPES[mediatorDetails.mediatorTypeId],
                },
                location: mediatorDetails.location
                    ? {
                        id: mediatorDetails.location.id,
                        name: mediatorDetails.location.name,
                    }
                    : null,
                branch: mediatorDetails.branch
                    ? {
                        id: mediatorDetails.branch.id,
                        name: mediatorDetails.branch.name,
                    }
                    : null,
                company: mediatorDetails.company
                    ? {
                        id: mediatorDetails.company.id,
                        companyName: mediatorDetails.company.companyName,
                    }
                    : null,
            })) ?? [],
            previousPlacementDetails: opportunity.previousPlacementDetails.map((placementDetails) => ({
                id: placementDetails.id,
                opportunityId: placementDetails.opportunityId,
                challengesAndMitigation: placementDetails.challengesAndMitigation,
                existingCompetition: placementDetails.existingCompetition,
                remarks: placementDetails.remarks,
            })) ?? [],
            contacts: opportunity.opportunityContactMap?.map((contactMap) => ({
                id: contactMap.contact?.id,
                firstName: contactMap.contact?.firstName,
                lastName: contactMap.contact?.lastName,
                middleName: contactMap.contact?.middleName,
                displayName: contactMap.contact?.displayName,
                salutation: {
                    id: contactMap.contact?.salutation?.id,
                    lookUpValue: contactMap.contact?.salutation?.lookUpValue,
                },
                tag: {
                    id: contactMap.contact?.tag?.id,
                    lookUpValue: contactMap.contact?.tag?.lookUpValue,
                },
                status: {
                    id: contactMap.contact?.status?.id,
                    lookUpValue: contactMap.contact?.status?.lookUpValue,
                },
                communicationDetails: contactMap.contact?.communicationDetails?.map((communication) => ({
                    id: communication?.id,
                    communicationType: communication?.communicationType,
                    communicationDetails: communication?.communicationDetails,
                    isPrimary: communication?.isPrimary,
                })),
                owner: {
                    userId: contactMap.contact?.owner?.userId,
                    firstName: contactMap.contact?.owner?.firstName,
                    lastName: contactMap.contact?.owner?.lastName,
                },
                department: contactMap.contact?.department ?? null,
                designation: contactMap.contact?.designation ?? null,
            })),
            // opportunityActivities:
            //   opportunity?.opportunityActivityMap?.map((activity: any) => ({
            //     id: activity.id,
            //     activity: {
            //       id: activity.activityId,
            //       name: activity.activityName,
            //     },
            //     stage: {
            //       id: activity.stageId,
            //       name: activity.stageName,
            //     },
            //     plannedDate: activity.plannedDate,
            //     leadDays: activity.leadDays,
            //     approval: activity.approval,
            //     mandatory: activity.mandatory,
            //     activityMeta: activity.activityMeta,
            //     leadRole: {
            //       id: activity.leadRole?.id,
            //       name: activity.leadRole?.name,
            //     },
            //     dueDate: activity.dueDate,
            //     status: activity.status,
            //   })) ?? [],
            // opportunityActivityParticipants:
            //   opportunity?.opportunityActivityParticipants?.map(
            //     (optActyParpt: any) => ({
            //       id: optActyParpt.id,
            //       activity: {
            //         id: optActyParpt.activityId,
            //         name: optActyParpt.activity.name,
            //       },
            //       opportunityId: optActyParpt.opportunityId,
            //       participant: {
            //         id: optActyParpt.participantId,
            //         name: optActyParpt.participant?.firstName ?? null,
            //       },
            //     })
            //   ) ?? [],
        };
    }
    async createInsurerParticipants(participants, meetingId, manager) {
        const records = participants.map((p) => manager.create(entities_1.InsurerParticipants, {
            ...p,
            meetingSummaryId: meetingId, // Ensure meetingId is mapped to meetingSummaryId
        }));
        await manager.save(entities_1.InsurerParticipants, records);
    }
    async createStageActivityMap(entityManager, opportunityId, policyTypeId, userId) {
        try {
            // Step 1: Fetch templates
            const templateRepo = entityManager.getRepository(constants_1.TABLE_NAMES.STAGE_ACTIVITY_TEMPLATE);
            const templates = await templateRepo.find({
                where: { policyTypeLid: policyTypeId },
                order: { stageId: "ASC", activityId: "ASC" }, // Ensure consistent order
            });
            if (!templates.length) {
                throw new common_1.NotFoundException(messages_1.errorMessages.noTemplateFound(policyTypeId));
            }
            const opportunityStatus = await entityManager.findOne(entities_1.LookUp, {
                where: { lookUpKey: constants_2.OPPORTUNITY_ACTIVITY_STATUS.OPEN },
            });
            if (!opportunityStatus) {
                throw new common_1.NotFoundException(`Opportunity status with key ${constants_2.OPPORTUNITY_ACTIVITY_STATUS.OPEN} not found`);
            }
            // Step 2: Extract and deduplicate stage and activity IDs
            const stageIds = [...new Set(templates.map((t) => t.stageId))];
            const activityIds = [...new Set(templates.map((t) => t.activityId))];
            // Step 3: Batch fetch stages and activities
            const [stages, activities] = await Promise.all([
                entityManager
                    .getRepository(constants_1.TABLE_NAMES.MSTR_STAGE)
                    .find({ where: { id: (0, typeorm_2.In)(stageIds) } }),
                entityManager
                    .getRepository(constants_1.TABLE_NAMES.MSTR_ACTIVITY)
                    .find({ where: { id: (0, typeorm_2.In)(activityIds) } }),
            ]);
            // Step 4: Create lookup maps
            const stageMap = new Map(stages.map((stage) => [stage.id, stage]));
            const activityMap = new Map(activities.map((activity) => [activity.id, activity]));
            const now = new Date();
            const activityMapRepo = entityManager.getRepository(constants_1.TABLE_NAMES.OPPORTUNITY_ACTIVITY_MAP);
            // Step 5: Prepare activity map records
            let previousDueDate = new Date(); // Start with the current date
            const records = templates.map((template, index) => {
                const stage = stageMap.get(template.stageId);
                const activity = activityMap.get(template.activityId);
                if (!stage) {
                    throw new common_1.NotFoundException(messages_1.errorMessages.stageNotFound(template.stageId));
                }
                if (!activity) {
                    throw new common_1.NotFoundException(messages_1.errorMessages.activityNotFound(template.activityId));
                }
                // Calculate the original due date
                const leadDays = template.leadDays ?? 5; // Default to 5 if not specified
                const originalDueDate = new Date(previousDueDate.getTime() + leadDays * 24 * 60 * 60 * 1000);
                previousDueDate = originalDueDate; // Update for the next activity
                return {
                    opportunityId: opportunityId,
                    refStageId: stage.id, // Ensure stage ID is set
                    refActivityId: activity.id, // Ensure activity ID is set
                    opportunityTable: activity.opportunityTable,
                    activityKey: activity.activityKey,
                    activityName: activity.name,
                    stageName: stage.name,
                    roleKey: stage.refRoleKey,
                    originalDueDate, // Set the calculated due date
                    leadDays,
                    approval: template.approval,
                    mandatory: template.mandatory,
                    leadRoleId: template.leadRoleId ?? null,
                    activityMeta: activity.activityMeta ?? null,
                    dueDate: null,
                    statusLid: opportunityStatus.id,
                    ownerId: userId,
                    createdBy: userId ?? 1, // Default to 1 if null
                    updatedBy: userId ?? 1, // Default to 1 if null
                    createdAt: now,
                    updatedAt: now,
                };
            });
            // Step 6: Bulk insert into OpportunityActivityMap
            await activityMapRepo.insert(records);
        }
        catch (error) {
            throw new common_1.BadRequestException(messages_1.errorMessages.badRequestWhileActivityMapping);
        }
    }
    async updateActivityDueDate(entityManager, id, dueDate, updatedBy) {
        const record = await entityManager.findOne(entities_1.OpportunityActivityMap, {
            where: { id: id },
        });
        if (!record) {
            throw new common_1.NotFoundException(`Opportunity Activity record not found with ${id}`);
        }
        let statusLid = record.statusLid;
        if (record.opportunityTable === constants_1.OPPORTUNITY_ACTIVITY.DATA_VALIDATION ||
            record.opportunityTable === constants_1.OPPORTUNITY_ACTIVITY.BROKING_SLIP) {
            const status = await entityManager.findOne(entities_1.LookUp, {
                where: { lookUpKey: constants_2.OPPORTUNITY_ACTIVITY_STATUS.WORK_IN_PROGRESS },
            });
            if (!status) {
                throw new common_1.NotFoundException(`Opportunity status with key ${constants_2.OPPORTUNITY_ACTIVITY_STATUS.WORK_IN_PROGRESS} not found`);
            }
            statusLid = status.id;
        }
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dueDateOnly = new Date(dueDate);
        dueDateOnly.setHours(0, 0, 0, 0);
        if (dueDateOnly < today) {
            throw new common_1.BadRequestException(`Due date cannot be in the past`);
        }
        if (dueDate > record.originalDueDate) {
            throw new common_1.BadRequestException(`Due date cannot be greater than the original due date`);
        }
        const opportunityStatus = await entityManager.findOne(entities_1.LookUp, {
            where: { lookUpKey: constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED },
        });
        if (!opportunityStatus) {
            throw new common_1.NotFoundException(`Opportunity status with key ${constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED} not found`);
        }
        if (record.statusLid === opportunityStatus.id) {
            throw new common_1.BadRequestException(`Opportunity activity with ID ${id} is already submitted, you cannot change the due date or add participants`);
        }
        // Commented this for future reference
        // const minDate = addDays(opportunity.createdAt, record.leadDays);
        // if (dueDate < minDate) {
        //   throw new BadRequestException(`Due date must be at least ${minDate}`);
        // }
        await entityManager.update(entities_1.OpportunityActivityMap, { id: record.id }, {
            dueDate: dueDate,
            statusLid: statusLid,
            updatedAt: new Date(),
            updatedBy,
        });
    }
    async getParticipantDetails(entityManager, participantId) {
        const userDetails = await entityManager.findOne(entities_1.User, {
            where: {
                userId: participantId,
            },
        });
        if (!userDetails) {
            throw new common_1.NotFoundException(`User with ID ${participantId} not found`);
        }
        return userDetails;
    }
    async addParticipantsToOpportunityActivity(entityManager, id, participantId, userId) {
        const activity = await entityManager.findOne(entities_1.OpportunityActivityMap, {
            where: {
                id,
            },
        });
        if (!activity) {
            throw new common_1.NotFoundException(`Opportunity Activity with ID ${id} not found`);
        }
        const opportunity = await entityManager.findOne(entities_1.Opportunity, {
            where: { opportunityId: activity.opportunityId },
        });
        if (!opportunity) {
            throw new common_1.NotFoundException(`Opportunity with ID ${activity.opportunityId} not found`);
        }
        const existingParticipant = await entityManager.findOne(entities_1.OpportunityActivityParticipants, {
            where: {
                opportunityActivityId: id,
                participantId: participantId,
            },
        });
        if (!existingParticipant) {
            const newParticipant = entityManager.create(entities_1.OpportunityActivityParticipants, {
                opportunityId: activity.opportunityId,
                activityId: activity.refActivityId,
                participantId,
                opportunityActivityId: id,
                createdAt: new Date(),
                updatedAt: new Date(),
                createdBy: userId,
                updatedBy: userId,
            });
            await entityManager.save(entities_1.OpportunityActivityParticipants, newParticipant);
        }
    }
    async updateOpportunityActivityOwner(entityManager, id, ownerId) {
        const activity = await entityManager.findOne(entities_1.OpportunityActivityMap, {
            where: { id },
        });
        if (!activity) {
            throw new common_1.NotFoundException(`Opportunity Activity with ID ${id} not found`);
        }
        await entityManager.update(entities_1.OpportunityActivityMap, { id }, { ownerId, updatedAt: new Date() });
    }
    async getOpportunityKpis(userId, searchFilters, relations) {
        // Step 1: Fetch optyType lookup values
        const optyTypeLookUpIds = await this.lookUpRepository.find({
            where: {
                lookUpKey: (0, typeorm_2.In)(constants_1.OPPORTUNITY_TYPES),
            },
        });
        // Transform lookup values into key-value pairs
        const optyTypeKeyValuePairs = optyTypeLookUpIds.map((type) => ({
            key: type.lookUpKey,
            id: type.id,
        }));
        // Step 2: Dynamically filter opportunities based on searchFilters
        const optyQuery = this.opportunityRepository.createQueryBuilder("opportunity");
        const relationPaths = typeof relations === "string"
            ? [relations]
            : Array.isArray(relations)
                ? relations
                : [];
        for (const path of relationPaths) {
            const alias = path.replace(/\./g, "_");
            const segments = path.split(".");
            const parent = segments.length > 1 ? segments.slice(0, -1).join("_") : "opportunity";
            const relationName = segments[segments.length - 1];
            optyQuery.leftJoinAndSelect(`${parent === "opportunity" ? "opportunity" : parent}.${relationName}`, alias);
        }
        // Dynamically add filters from searchFilters
        if (Array.isArray(searchFilters) && searchFilters.length > 0) {
            searchFilters.forEach(({ searchBy, searchValue }, index) => {
                const paramKey = `param_${index}`;
                let alias, column;
                if (searchBy.includes(".")) {
                    const parts = searchBy.split(".");
                    column = parts.pop();
                    alias = parts.join("_");
                }
                else {
                    alias = "opportunity";
                    column = searchBy;
                }
                if (Array.isArray(searchValue)) {
                    optyQuery.andWhere(`${alias}.${column} IN (:...${paramKey})`, {
                        [paramKey]: searchValue,
                    });
                }
                else {
                    optyQuery.andWhere(`${alias}.${column} ILIKE :${paramKey}`, {
                        [paramKey]: `%${searchValue}%`,
                    });
                }
            });
        }
        // Step 3: Query the opportunity table for counts grouped by opportunityTypeLid
        const optyTypeCounts = await optyQuery
            .select("opportunity.opportunityTypeLid", "opportunityTypeLid")
            .addSelect("COUNT( DISTINCT opportunity.id)", "count")
            .groupBy("opportunity.opportunityTypeLid")
            .getRawMany();
        // Step 4: Map the type counts to type keys
        const result = optyTypeCounts?.map((type) => {
            const optyTypeKey = optyTypeKeyValuePairs?.find((item) => item.id === type.opportunityTypeLid)?.key;
            return {
                optyTypeKey,
                count: parseInt(type.count, 10),
            };
        });
        return result;
    }
    async getOpportunityActivitiesByOpportunityId(opportunityId) {
        try {
            // Fetch all activities for the given opportunity ID
            const activities = await this.opportunityActivityMapRepository.find({
                relations: ["status", "owner"],
                where: { opportunityId: opportunityId },
                order: { refStageId: "ASC", refActivityId: "ASC" },
            });
            if (!activities || activities.length === 0) {
                throw new Error(`No activities found for opportunity ID ${opportunityId}`);
            }
            // Extract activity IDs
            const activityIds = activities.map((activity) => activity.id);
            // Fetch participants for the activities
            const participants = await this.opportunityActivityParticipantsRepository.find({
                where: { opportunityActivityId: (0, typeorm_2.In)(activityIds) },
                relations: ["participant"],
            });
            // Group participants by activity ID
            const participantsByActivityId = participants.reduce((acc, participant) => {
                if (!acc[participant.opportunityActivityId]) {
                    acc[participant.opportunityActivityId] = [];
                }
                acc[participant.opportunityActivityId].push({
                    userId: participant.participantId,
                    userName: participant.participant?.firstName,
                });
                return acc;
            }, {});
            let owner = null;
            // Categorize activities into BD and ISG based on roleTag
            const categorizedActivities = activities.reduce((acc, activity) => {
                const stageId = activity.refStageId;
                const stageName = activity.stageName;
                const roleTag = activity.roleKey;
                // Compute owner name outside the accumulator object
                if (activity?.owner && activity?.owner?.firstName) {
                    owner = activity.owner.lastName
                        ? `${activity.owner.firstName} ${activity.owner.lastName}`
                        : activity.owner.firstName;
                }
                // Check if the category (BD or ISG) already exists in the accumulator
                const category = roleTag === "ROLE_BD_EXECUTIVE" ? "BD" : "ISG";
                if (!acc[category]) {
                    acc[category] = [];
                }
                // Check if the stage already exists in the category
                let stage = acc[category].find((s) => s.stageId === stageId);
                if (!stage) {
                    // If the stage doesn't exist, create a new one
                    stage = {
                        stageId,
                        stageName,
                        activities: [],
                        owner,
                        roleTag,
                    };
                    acc[category].push(stage);
                }
                // Add the activity to the stage's activities array
                stage.activities.push({
                    opportunityActivityId: activity.id,
                    activityId: activity.refActivityId,
                    activityName: activity.activityName,
                    activityKey: activity.activityKey,
                    activityApproval: activity.approval,
                    activityMandatory: activity.mandatory,
                    activityStatus: activity.status?.lookUpValue ?? null,
                    dueDate: activity.dueDate,
                    originalDueDate: activity.originalDueDate,
                    participants: participantsByActivityId[activity.id] || [],
                    leadDays: activity.leadDays,
                    isCoversRequired: constants_1.COVERS_REQUIRED_ACTIVITIES.includes(activity.activityName)
                        ? true
                        : false,
                    isPlanned: activity.dueDate
                        ? constants_1.DEFAULT_PLANNING.PLANNED
                        : constants_1.DEFAULT_PLANNING.NOT_PLANNED,
                    owner: activity.owner
                        ? `${activity?.owner?.firstName ?? ""} ${activity?.owner?.lastName ?? ""}`.trim()
                        : null,
                });
                return acc;
            }, { BD: [], ISG: [] });
            // Simplify the response structure
            return {
                data: categorizedActivities,
                owner: owner ?? null,
            };
        }
        catch (error) {
            throw new Error(`Failed to retrieve opportunity activities: ${error.message}`);
        }
    }
    //Check if opportunity needs approval
    async isOpportunityActivityNeedsApproval(opportunityActivityId) {
        try {
            const activity = await this.opportunityActivityMapRepository.findOne({
                where: { id: opportunityActivityId },
            });
            if (!activity) {
                throw new common_1.NotFoundException(`Opportunity Activity with ID ${opportunityActivityId} not found`);
            }
            return activity.approval.toUpperCase() === constants_2.ACTIVITY_APPROVAL_YES;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to create task.");
        }
    }
    //Create a task object for the approval task in opportunity activity;
    async createOpportunityActivityTaskObject(opportunityActivityId, taskName, taskTypeKey, //TASK_TYPE.APPROVAL
    assignedTo, //userId
    userId) {
        try {
            const activity = await this.opportunityActivityMapRepository.findOne({
                where: { id: opportunityActivityId },
            });
            if (!activity) {
                throw new common_1.NotFoundException(`Opportunity Activity with ID ${opportunityActivityId} not found`);
            }
            const opportunity = await this.opportunityRepository.findOne({
                where: { opportunityId: activity.opportunityId },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${activity.opportunityId} not found`);
            }
            const taskType = await this.lookUpRepository.findOne({
                where: { lookUpKey: taskTypeKey },
            });
            if (!taskType) {
                throw new common_1.NotFoundException(`Task type with key ${taskTypeKey} not found`);
            }
            const taskPriorityType = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_2.PRIORITY_LOOK_UP_HIGH_VALUE },
            });
            if (!taskPriorityType) {
                throw new common_1.NotFoundException(`Task type with key ${taskPriorityType} not found`);
            }
            const createTask = {
                taskName: taskName,
                opportunityId: activity.opportunityId,
                activityId: opportunityActivityId,
                companyId: opportunity.companyId,
                assigneeId: assignedTo,
                taskTypeLid: taskType.id,
                dueDate: (activity.leadDays
                    ? (0, helper_utils_1.addDays)(new Date(), activity.leadDays)
                    : new Date()).toISOString(),
                description: `${taskName} for Opportunity ID: ${activity.opportunityId}`,
                createdBy: userId ?? assignedTo,
                updatedBy: userId ?? assignedTo,
                priorityLid: taskPriorityType.id,
            };
            return createTask;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to create task.");
        }
    }
    // Creates a task object for opportunity activity based on the provided details
    async createTaskObject(statusLid, opportunityId, opportunityActivityId, taskName, leadDays, userId) {
        try {
            // Fetch the opportunity to get the companyId
            const opportunity = await this.opportunityRepository.findOne({
                where: { opportunityId },
                select: ["companyId"],
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${opportunityId} not found`);
            }
            // Set the task status based on the statusLid from activity
            const status = await this.lookUpRepository.findOne({
                where: { id: statusLid },
            });
            if (!status) {
                throw new common_1.NotFoundException(`Status with ID ${statusLid} not found`);
            }
            const taskType = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_2.TASK_TYPE.ACTIVITY },
            });
            if (!taskType) {
                throw new common_1.NotFoundException(`Task type with key ${constants_2.TASK_TYPE.ACTIVITY} not found`);
            }
            let taskStatus, taskClose;
            if (status.lookUpKey == constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                status.lookUpKey == constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                taskStatus = await this.lookUpRepository.findOne({
                    where: { lookUpKey: constants_2.TASK_STATUS_CLOSED },
                });
                taskClose = constants_2.TASK_CLOSED;
            }
            // Prepare the CreateTaskDto
            const createTask = {
                taskName,
                opportunityId,
                activityId: opportunityActivityId,
                companyId: opportunity.companyId,
                assigneeId: userId,
                taskTypeLid: taskType.id,
                dueDate: leadDays ? (0, helper_utils_1.addDays)(new Date(), leadDays) : new Date(),
                description: `${taskName} for Opportunity ID: ${opportunityId}`,
                createdBy: userId,
                updatedBy: userId,
            };
            if (taskStatus) {
                createTask.taskStatusLid = Number(taskStatus.id);
            }
            if (taskClose) {
                createTask.taskClose = taskClose;
            }
            return createTask;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to create task.");
        }
    }
    async createDataValidation(entityManager, details, userId) {
        try {
            const existingRecord = await entityManager.findOne(entities_1.DataValidation, {
                where: {
                    opportunityId: details.opportunityId,
                    activityId: details.activityId,
                },
            });
            if (existingRecord) {
                throw new common_1.BadRequestException(`Data validation record already exists for Opportunity ID: ${details.opportunityId} and Activity ID: ${details.activityId}`);
            }
            const newRecord = entityManager.create(entities_1.DataValidation, {
                opportunityId: details.opportunityId,
                activityId: details.activityId,
                opportunityActivityId: details.opportunityActivityId,
                description: details.description,
                createdBy: userId,
                updatedBy: userId,
                statusLid: details.statusLid,
                taskId: details.taskId,
            });
            const savedRecord = await entityManager.save(entities_1.DataValidation, newRecord);
            return savedRecord;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : "Failed to create data validation in the database.");
        }
    }
    async saveDataValidationDocuments(entityManager, dataValidationId, taskId, documents) {
        try {
            // Fetch existing documents
            const existingRecords = await entityManager.find(entities_1.OpportunityDataValidationDocumentMap, { where: { taskId, dataValidationId } });
            const incomingDocumentIds = documents.map((doc) => doc.documentId);
            const existingDocumentIds = existingRecords.map((doc) => doc.documentId);
            // Determine documents to add
            const documentsToAdd = documents.filter((doc) => !existingDocumentIds.includes(doc.documentId));
            // Determine documents to remove
            const documentsToDelete = existingDocumentIds.filter((docId) => !incomingDocumentIds.includes(docId));
            // Add new documents
            if (documentsToAdd.length > 0) {
                const documentRecordsToAdd = documentsToAdd.map((doc) => entityManager.create(entities_1.OpportunityDataValidationDocumentMap, {
                    dataValidationId,
                    taskId,
                    documentId: doc.documentId,
                    documentTypeLid: doc.documentTypeLid,
                }));
                await entityManager.save(entities_1.OpportunityDataValidationDocumentMap, documentRecordsToAdd);
            }
            // Remove documents that are no longer in the list
            if (documentsToDelete.length > 0) {
                await entityManager.delete(entities_1.OpportunityDataValidationDocumentMap, {
                    dataValidationId,
                    documentId: (0, typeorm_2.In)(documentsToDelete),
                    taskId,
                });
            }
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to create or update data validation documents in the database.");
        }
    }
    async getDataValidationByOpportunityActivityId(opportunityId, activityId) {
        try {
            // Fetch the data validation record
            const dataValidationRecord = await this.dataValidationRepository.findOne({
                where: { opportunityId, activityId },
                relations: ["dataValidationDocs"],
            });
            if (!dataValidationRecord) {
                throw new common_1.NotFoundException(`Data validation record not found for Opportunity ID: ${opportunityId} and Activity ID: ${activityId}`);
            }
            let documents = [];
            if (dataValidationRecord?.dataValidationDocs &&
                dataValidationRecord?.dataValidationDocs?.length > 0) {
                documents = dataValidationRecord?.dataValidationDocs?.map((doc) => ({
                    id: doc.id,
                    documentId: doc.documentId,
                    documentTypeLid: doc.documentTypeLid,
                }));
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            return {
                id: dataValidationRecord.id,
                opportunityId: dataValidationRecord.opportunityId,
                activityId: dataValidationRecord.activityId,
                opportunityActivityId: dataValidationRecord.opportunityActivityId,
                statusLid: dataValidationRecord.statusLid,
                dataActivity: {
                    remarks: {
                        description: dataValidationRecord.description,
                    },
                    documents: documents,
                },
            };
        }
        catch (error) {
            console.error("Error in OpportunityService.getDataValidationByOpportunityActivityId:", error);
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : `Failed to retrieve data validation for opportunityId: ${opportunityId} and activityId: ${activityId}`);
        }
    }
    async updateTaskObject(entityManager, id, statusLid, userId) {
        try {
            // Fetch the existing task
            const task = await entityManager.findOne(entities_1.Task, {
                where: { id },
            });
            if (!task) {
                throw new common_1.NotFoundException(messages_1.errorMessages.taskWithIdNotFound(id));
            }
            // Set the task status based on the statusLid from activity
            const status = await this.lookUpRepository.findOne({
                where: { id: statusLid },
            });
            if (!status) {
                throw new common_1.NotFoundException(`Status with ID ${statusLid} not found`);
            }
            let taskStatus, taskClose;
            if (status.lookUpKey == constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                status.lookUpKey == constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                taskStatus = await this.lookUpRepository.findOne({
                    where: { lookUpKey: constants_2.TASK_STATUS_CLOSED },
                });
                taskClose = constants_2.TASK_CLOSED;
            }
            // Prepare the UpdateTaskDto
            const updateTask = {
                updatedBy: userId,
            };
            if (taskStatus) {
                updateTask.taskStatusLid = Number(taskStatus.id);
            }
            if (taskClose) {
                updateTask.taskClose = taskClose;
            }
            return updateTask;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to update task.");
        }
    }
    async updateDataValidation(entityManager, dataValidationRecord, dataValidationDetails, userId) {
        try {
            await entityManager.update(entities_1.DataValidation, dataValidationRecord.id, {
                description: dataValidationDetails.remarks?.description
                    ? dataValidationDetails.remarks.description
                    : dataValidationRecord.description,
                statusLid: dataValidationDetails.statusLid ?? dataValidationRecord.statusLid,
                updatedBy: userId,
            });
            return await entityManager.findOne(entities_1.DataValidation, {
                where: { id: dataValidationRecord.id },
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : `Failed to update data validation record with ID ${id}: ${error.message}`);
        }
    }
    async updateBrokingSlipVersionDetails(entityManager, brokingSlipVersionData) {
        try {
            await entityManager.update(entities_1.BrokingSlipVersionDetails, { id: brokingSlipVersionData.id }, brokingSlipVersionData);
        }
        catch (error) {
            throw new Error(`Failed to update broking slip version details with ID ${brokingSlipVersionData.id}: ${error.message}`);
        }
    }
    async updateRfpDetailsEntry(entityManager, rfpDetailsId, updateRfpDetails, userId) {
        try {
            console.log(updateRfpDetails, "Updating RFP details entry with ID:", rfpDetailsId);
            const updaterfpdetails = await entityManager.update(entities_1.OpportunityRfpDetailsEntry, { id: rfpDetailsId }, { ...updateRfpDetails, updatedBy: userId });
            console.log("RFP details entry updated successfully:", updaterfpdetails);
            return updaterfpdetails;
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : `Failed to update RFP details entry with ID ${rfpDetailsId}: ${error.message}`);
        }
    }
    async updateBrokingSlipDetails(entityManager, brokingSlipVersionData) {
        try {
            await entityManager.update(entities_1.BrokingSlipVersionDetails, { opportunityId: brokingSlipVersionData.opportunityId }, brokingSlipVersionData);
        }
        catch (error) {
            throw new Error(`Failed to update broking slip version details with ID ${brokingSlipVersionData.id}: ${error.message}`);
        }
    }
    async deleteBrokingSlipVersionDetails(entityManager, opportunityId, versionId) {
        try {
            await entityManager.delete(entities_1.BrokingSlipVersionDetails, {
                id: versionId,
                opportunityId: opportunityId,
            });
        }
        catch (error) {
            throw new Error(`Failed to delete broking slip version details with ID ${versionId}}: ${error.message}`);
        }
    }
    async updateBrokingSlipVersionMappedCoversDetails(entityManager, coversData, brokingSlipVersionId) {
        try {
            const coverDetails = await this.opportunityRepository.manager.find(entities_1.BrokingSlipVersionCoverDetails, {
                where: {
                    brokingSlipVersionId,
                },
            });
            for (let coverDetail of coverDetails) {
                await entityManager.update(entities_1.BrokingSlipVersionCoverDetails, { id: coverDetail.id }, { coverResponse: coversData[coverDetail.coverMapId] });
            }
        }
        catch (error) {
            throw new Error(`Failed to update broking slip version mapped covers details with ID ${brokingSlipVersionId}: ${error.message}`);
        }
    }
    async deleteBrokingSlipVersionMappedCoversDetails(entityManager, versionId) {
        try {
            await entityManager.delete(entities_1.BrokingSlipVersionCoverDetails, {
                brokingSlipVersionId: versionId,
            });
        }
        catch (error) {
            throw new Error(`Failed to update broking slip version mapped covers details with ID ${versionId}: ${error.message}`);
        }
    }
    async updateBrokingSlipVersionMappedPreferredTPAdetails(entityManager, preferredTPAdetails, brokingSlipVersionId) {
        try {
            for (let preferredTPAdetail of preferredTPAdetails) {
                await entityManager.update(entities_1.PreferredTpaDetails, { id: preferredTPAdetail.id }, preferredTPAdetail);
            }
        }
        catch (error) {
            throw new Error(`Failed to update preferred TPA details with ID ${brokingSlipVersionId}: ${error.message}`);
        }
    }
    async deleteBrokingSlipVersionMappedPreferredTPAdetails(entityManager, versionId) {
        try {
            await entityManager.delete(entities_1.PreferredTpaDetails, {
                brokingSlipId: versionId,
            });
        }
        catch (error) {
            throw new Error(`Failed to delete preferred TPA details with broking slip version Id: ${versionId}: ${error.message}`);
        }
    }
    async updateBrokingSlipVersionMappedPreferredInsurerdetails(entityManager, preferredInsurerDetails, brokingSlipVersionId) {
        try {
            for (let preferredInsurerdetail of preferredInsurerDetails) {
                await entityManager.update(entities_1.PreferredInsurerDetails, { id: preferredInsurerdetail.id }, preferredInsurerdetail);
            }
        }
        catch (error) {
            throw new Error(`Failed to update preferred Insurer details with ID ${brokingSlipVersionId}: ${error.message}`);
        }
    }
    async updateBrokingSlipMappedPreferredInsurerDetails(entityManager, preferredInsurerDetails, opportunityId) {
        try {
            await entityManager.delete(entities_1.PreferredInsurerDetails, {
                opportunityId: opportunityId,
            });
            const preferredInsurerDetailsData = preferredInsurerDetails.map((tpaDetail) => {
                return entityManager.create(entities_1.PreferredInsurerDetails, {
                    opportunityId: opportunityId,
                    ...tpaDetail,
                });
            });
            await entityManager.save(entities_1.PreferredInsurerDetails, preferredInsurerDetailsData);
        }
        catch (error) {
            throw new Error(`Failed to update preferred Insurer details with opportunity ID ${opportunityId}: ${error.message}`);
        }
    }
    async updateBrokingSlipMappedPreferredTpaDetails(entityManager, preferredTpaDetails, opportunityId) {
        try {
            await entityManager.delete(entities_1.PreferredTpaDetails, {
                opportunityId: opportunityId,
            });
            const preferredTpaDetailsData = preferredTpaDetails.map((tpaDetail) => {
                return entityManager.create(entities_1.PreferredTpaDetails, {
                    opportunityId: opportunityId,
                    ...tpaDetail,
                });
            });
            await entityManager.save(entities_1.PreferredTpaDetails, preferredTpaDetailsData);
        }
        catch (error) {
            throw new Error(`Failed to update preferred TPA details with opportunity ID ${opportunityId}: ${error.message}`);
        }
    }
    async updateBrokingSlipMappedDocumentDetails(entityManager, documentDetails, opportunityId, opportunityActivityId) {
        try {
            await entityManager.delete(entities_1.OpportunityBrokingSlipActivityDocumentMap, {
                opportunityId: opportunityId,
            });
            const documentData = documentDetails.map((document) => {
                return entityManager.create(entities_1.OpportunityBrokingSlipActivityDocumentMap, {
                    opportunityId: opportunityId,
                    opportunityActivityMapId: opportunityActivityId,
                    documentId: parseInt(document.documentId),
                    documentTypeLid: document.documentTypeLid,
                });
            });
            await entityManager.save(entities_1.OpportunityBrokingSlipActivityDocumentMap, documentData);
        }
        catch (error) {
            throw new Error(`Failed to update preferred TPA details with opportunity ID ${opportunityId}: ${error.message}`);
        }
    }
    async updateRfpTpaDetails(entityManager, rfpDetailsEntryId, preferredTPA, excludedTPA, userId) {
        try {
            // Fetch existing TPAs from the database
            const existingTPAs = await entityManager.find(entities_1.OpportunityRfpTpaDetail, {
                where: { opportunityRfpDetailsEntryId: rfpDetailsEntryId },
            });
            // Combine preferred and excluded TPAs from the payload
            const newTPAs = [...preferredTPA, ...excludedTPA];
            const newTPAIds = newTPAs.map((tpa) => tpa.id);
            // Determine TPAs to delete, update, and create
            const toDelete = existingTPAs.filter((tpa) => !newTPAIds.includes(tpa.id));
            const toUpdate = existingTPAs.filter((tpa) => newTPAIds.includes(tpa.id));
            const toCreate = newTPAs.filter((tpa) => !existingTPAs.some((existing) => existing.id === tpa.id));
            // Delete TPAs that are no longer in the payload
            if (toDelete.length > 0) {
                await entityManager.delete(entities_1.OpportunityRfpTpaDetail, {
                    id: (0, typeorm_2.In)(toDelete.map((tpa) => tpa.id)),
                });
            }
            // Update existing TPAs
            for (const tpa of toUpdate) {
                const payloadTpa = newTPAs.find((newTpa) => newTpa.id === tpa.id);
                if (payloadTpa) {
                    await entityManager.update(entities_1.OpportunityRfpTpaDetail, { id: tpa.id }, { ...payloadTpa, updatedBy: userId });
                }
            }
            // Create new TPAs
            for (const tpa of toCreate) {
                await entityManager.insert(entities_1.OpportunityRfpTpaDetail, {
                    ...tpa,
                    opportunityRfpDetailsEntryId: rfpDetailsEntryId,
                    createdBy: userId,
                    updatedBy: userId,
                });
            }
        }
        catch (error) {
            console.error("Error in updateRfpTpaDetails:", error);
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to update RFP TPA details.");
        }
    }
    async deleteBrokingSlipVersionMappedPreferredInsurerdetails(entityManager, versionId) {
        try {
            await entityManager.delete(entities_1.PreferredInsurerDetails, {
                opportunityId: versionId,
            });
        }
        catch (error) {
            throw new Error(`Failed to delete preferred Insurer details with broking slip version Id: ${versionId}: ${error.message}`);
        }
    }
    async updateRfpInsurerDetails(entityManager, rfpDetailsEntryId, preferredInsurers, excludedInsurers, userId) {
        try {
            // Fetch existing insurer details from the database
            const existingInsurers = await entityManager.find(entities_1.OpportunityRfpInsurerDetail, {
                where: { opportunityRfpDetailsEntryId: rfpDetailsEntryId },
            });
            // Combine preferred and excluded insurers from the payload
            const newInsurers = [...preferredInsurers, ...excludedInsurers];
            const newInsurerIds = newInsurers.map((insurer) => insurer.id);
            // Determine insurers to delete, update, and create
            const toDelete = existingInsurers.filter((insurer) => !newInsurerIds.includes(insurer.id));
            const toUpdate = existingInsurers.filter((insurer) => newInsurerIds.includes(insurer.id));
            const toCreate = newInsurers.filter((insurer) => !existingInsurers.some((existing) => existing.id === insurer.id));
            // Delete insurers that are no longer in the payload
            if (toDelete.length > 0) {
                await entityManager.delete(entities_1.OpportunityRfpInsurerDetail, {
                    id: (0, typeorm_2.In)(toDelete.map((insurer) => insurer.id)),
                });
            }
            // Update existing insurers
            for (const insurer of toUpdate) {
                const payloadInsurer = newInsurers.find((newInsurer) => newInsurer.id === insurer.id);
                if (payloadInsurer) {
                    await entityManager.update(entities_1.OpportunityRfpInsurerDetail, { id: insurer.id }, { ...payloadInsurer, updatedBy: userId });
                }
            }
            // Create new insurers
            for (const insurer of toCreate) {
                await entityManager.insert(entities_1.OpportunityRfpInsurerDetail, {
                    ...insurer,
                    opportunityRfpDetailsEntryId: rfpDetailsEntryId,
                    createdBy: userId,
                    updatedBy: userId,
                });
            }
        }
        catch (error) {
            console.error("Error in updateRfpInsurerDetails:", error);
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to update RFP Insurer details.");
        }
    }
    async updateRfpClientContactDetails(entityManager, rfpDetailsEntryId, clientContactDetails, userId) {
        try {
            // Fetch existing client contact details from the database
            const existingClientContact = await entityManager.findOne(entities_1.OpportunityRfpClientContactDetail, {
                where: { opportunityRfpDetailsEntryId: rfpDetailsEntryId },
            });
            if (existingClientContact) {
                // Update client contact details
                await entityManager.update(entities_1.OpportunityRfpClientContactDetail, { id: existingClientContact.id }, {
                    contactId: clientContactDetails.contactId,
                    expectedPremium: clientContactDetails.expectedPremium,
                    updatedBy: userId,
                });
                // Handle decision influencers
                const existingInfluencers = await entityManager.find(entities_1.OpportunityRfpClientContactInfluencers, {
                    where: { clientContactId: existingClientContact.id },
                });
                const newInfluencers = clientContactDetails.decisionInfluencers || [];
                const existingInfluencerIds = existingInfluencers.map((influencer) => influencer.influencerContactId);
                // Determine influencers to delete and create
                const toDelete = existingInfluencers.filter((influencer) => !newInfluencers.includes(influencer.influencerContactId));
                const toCreate = newInfluencers.filter((influencerId) => !existingInfluencerIds.includes(influencerId));
                // Delete influencers that are no longer in the payload
                if (toDelete.length > 0) {
                    await entityManager.delete(entities_1.OpportunityRfpClientContactInfluencers, {
                        id: (0, typeorm_2.In)(toDelete.map((influencer) => influencer.id)),
                    });
                }
                // Create new influencers
                for (const influencerId of toCreate) {
                    await entityManager.insert(entities_1.OpportunityRfpClientContactInfluencers, {
                        clientContactId: existingClientContact.id,
                        influencerContactId: influencerId,
                    });
                }
            }
            else {
                // Create new client contact details
                const newClientContact = await entityManager.insert(entities_1.OpportunityRfpClientContactDetail, {
                    opportunityRfpDetailsEntryId: rfpDetailsEntryId,
                    contactId: clientContactDetails.contactId,
                    expectedPremium: clientContactDetails.expectedPremium,
                    createdBy: userId,
                    updatedBy: userId,
                });
                // Create influencers
                if (clientContactDetails.decisionInfluencers?.length > 0) {
                    for (const influencerId of clientContactDetails.decisionInfluencers) {
                        await entityManager.insert(entities_1.OpportunityRfpClientContactInfluencers, {
                            clientContactId: newClientContact.identifiers[0].id,
                            influencerContactId: influencerId,
                        });
                    }
                }
            }
        }
        catch (error) {
            console.error("Error in updateRfpClientContactDetails:", error);
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to update RFP Client Contact Details.");
        }
    }
    async updateRfpCreditSharing(entityManager, rfpDetailsEntryId, creditSharing, userId) {
        try {
            // Fetch existing credit sharing records from the database
            const existingCreditSharing = await entityManager.find(entities_1.OpportunityRfpCreditSharing, {
                where: { opportunityRfpDetailsEntryId: rfpDetailsEntryId },
            });
            const newCreditSharingIds = creditSharing
                .map((credit) => credit.id)
                .filter((id) => id !== undefined);
            // Determine records to delete, update, and create
            const toDelete = existingCreditSharing.filter((credit) => !newCreditSharingIds.includes(credit.id));
            const toUpdate = existingCreditSharing.filter((credit) => newCreditSharingIds.includes(credit.id));
            const toCreate = creditSharing.filter((credit) => !existingCreditSharing.some((existing) => existing.id === credit.id));
            // Delete records that are no longer in the payload
            if (toDelete.length > 0) {
                await entityManager.delete(entities_1.OpportunityRfpCreditSharing, {
                    id: (0, typeorm_2.In)(toDelete.map((credit) => credit.id)),
                });
            }
            // Update existing records
            for (const credit of toUpdate) {
                const payloadCredit = creditSharing.find((newCredit) => newCredit.id === credit.id);
                if (payloadCredit) {
                    await entityManager.update(entities_1.OpportunityRfpCreditSharing, { id: credit.id }, { ...payloadCredit, updatedBy: userId });
                }
            }
            // Create new records
            for (const credit of toCreate) {
                await entityManager.insert(entities_1.OpportunityRfpCreditSharing, {
                    ...credit,
                    opportunityRfpDetailsEntryId: rfpDetailsEntryId,
                    createdBy: userId,
                    updatedBy: userId,
                });
            }
        }
        catch (error) {
            console.error("Error in updateRfpCreditSharing:", error);
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to update RFP Credit Sharing.");
        }
    }
    async updateRfpDetailsEntryDocuments(entityManager, rfpDetailsEntryId, documents, userId) {
        try {
            // Fetch existing document mappings from the database
            const existingDocuments = await entityManager.find(entities_1.OpportunityRfpDetailsEntryDocumentMap, {
                where: { opportunityRfpDetailsEntryId: rfpDetailsEntryId },
            });
            // Extract IDs from the payload and existing records
            const newDocumentIds = documents
                .map((doc) => doc.id)
                .filter((id) => id !== undefined);
            // Determine records to delete, update, and create
            const toDelete = existingDocuments.filter((doc) => !newDocumentIds.includes(doc.id));
            const toUpdate = existingDocuments.filter((doc) => newDocumentIds.includes(doc.id));
            const toCreate = documents.filter((doc) => !existingDocuments.some((existing) => existing.id === doc.id));
            // Delete records that are no longer in the payload
            if (toDelete.length > 0) {
                await entityManager.delete(entities_1.OpportunityRfpDetailsEntryDocumentMap, {
                    id: (0, typeorm_2.In)(toDelete.map((doc) => doc.id)),
                });
            }
            // Update existing records
            for (const doc of toUpdate) {
                const payloadDoc = documents.find((newDoc) => newDoc.id === doc.id);
                if (payloadDoc) {
                    await entityManager.update(entities_1.OpportunityRfpDetailsEntryDocumentMap, { id: doc.id }, { ...payloadDoc });
                }
            }
            // Create new records
            for (const doc of toCreate) {
                await entityManager.insert(entities_1.OpportunityRfpDetailsEntryDocumentMap, {
                    ...doc,
                    opportunityRfpDetailsEntryId: rfpDetailsEntryId,
                });
            }
        }
        catch (error) {
            console.error("Error in updateRfpDetailsEntryDocuments:", error);
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to update RFP Details Entry Documents.");
        }
    }
    async createKDMMeeting(entityManager, meetingData) {
        try {
            const existingMeeting = await entityManager.findOne(entities_1.KdmMeeting, {
                where: {
                    opportunityActivityId: meetingData.opportunityActivityId,
                },
            });
            if (existingMeeting) {
                throw new common_1.BadRequestException(`KDM Meeting record already exists for Opportunity ID: ${meetingData.opportunityId} and Activity ID: ${meetingData.activityId}`);
            }
            const meeting = entityManager.create(entities_1.KdmMeeting, meetingData);
            return await entityManager.save(entities_1.KdmMeeting, meeting);
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException)
                throw error;
            throw new Error(`Failed to create KDM meeting: ${error.message}`);
        }
    }
    async updateKDMMeeting(entityManager, meetingId, updateKDMdetails) {
        try {
            await entityManager.update(entities_1.KdmMeeting, { meetingId: meetingId }, updateKDMdetails);
            return await entityManager.findOne(entities_1.KdmMeeting, {
                where: { meetingId: meetingId },
            });
        }
        catch (error) {
            throw new Error(`Failed to update KDM meeting record with ID ${meetingId}: ${error.message}`);
        }
    }
    async updateHandOverMeeting(entityManager, meetingId, updateHandOverData) {
        try {
            await entityManager.update(entities_1.OpportunityHandOverMeet, { meetingId: meetingId }, updateHandOverData);
            return await entityManager.findOne(entities_1.OpportunityHandOverMeet, {
                where: { meetingId: meetingId },
            });
        }
        catch (error) {
            throw new Error(`Failed to update Hand Over meeting record with ID ${meetingId}: ${error.message}`);
        }
    }
    async getMeetingDetailsById(opportunityId, activityId) {
        try {
            const meeting = await this.kdmMeetingRepository.findOne({
                where: { opportunityId: opportunityId, activityId: activityId },
                relations: ["meeting", "meeting.participants", "meeting.meetingDocs"],
            });
            if (!meeting) {
                throw new common_1.NotFoundException(`Meeting with OpportunityID ${opportunityId} and activityId ${activityId} not found`);
            }
            const participants = meeting.meeting.participants;
            const companyParticipants = participants
                ?.filter((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.COMPANY_CONTACT)
                .map((p) => p.participantId);
            const employeeParticipants = participants
                ?.filter((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.EMPLOYEE)
                .map((p) => p.participantId);
            let documents = [];
            if (meeting.meeting.meetingDocs &&
                meeting.meeting.meetingDocs?.length > 0) {
                documents = meeting.meeting.meetingDocs?.map((doc) => ({
                    id: doc.id,
                    documentId: doc.documentId,
                    documentTypeLid: doc.documentTypeLid,
                }));
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            // Return the transformed meeting object
            const data = {
                id: meeting.id,
                opportunityId: meeting.opportunityId,
                activityId: meeting.activityId,
                opportunityActivityId: meeting.opportunityActivityId,
                statusLid: meeting.statusLid,
                dataActivity: {
                    kdmMeetingFormFields: {
                        kdmMeetingTypeLid: meeting.kdmMeetingTypeLid,
                        selectMeeting: meeting.selectMeeting,
                        meetingDate: meeting.meeting.meetingDate,
                        availableFrom: meeting.meeting.startTime,
                        availableTo: meeting.meeting.endTime,
                        meetingTypeLid: meeting.meeting.meetingTypeLid,
                        locationTypeLid: meeting.meeting.locationTypeLid,
                    },
                    remarksMomSection: {
                        mom: meeting.mom,
                        remarks: meeting.remarks,
                    },
                    participants: {
                        companyContactPerson: companyParticipants.length > 0 ? companyParticipants : [],
                        employees: employeeParticipants.length > 0 ? employeeParticipants : [],
                    },
                    documents: documents,
                },
            };
            return data;
        }
        catch (error) {
            throw new Error(`Failed to retrieve kdm meeting details: ${error.message}`);
        }
    }
    async gethandOverMeetDetailsById(opportunityId, activityId) {
        try {
            const meeting = await this.handOverMeetRepository.findOne({
                where: { opportunityId: opportunityId, activityId: activityId },
                relations: ["meeting", "meeting.participants", "meeting.meetingDocs"],
            });
            if (!meeting) {
                throw new common_1.NotFoundException(`Hand over meeting with OpportunityID ${opportunityId} and activityId ${activityId} not found`);
            }
            const participants = meeting.meeting.participants;
            const companyParticipants = participants
                ?.filter((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.COMPANY_CONTACT)
                .map((p) => p.participantId);
            const employeeParticipants = participants
                ?.filter((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.EMPLOYEE)
                .map((p) => p.participantId);
            let documents = [];
            if (meeting.meeting.meetingDocs &&
                meeting.meeting.meetingDocs?.length > 0) {
                documents = meeting.meeting.meetingDocs?.map((doc) => ({
                    id: doc.id,
                    documentId: doc.documentId,
                    documentTypeLid: doc.documentTypeLid,
                }));
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            // Return the transformed meeting object
            const data = {
                id: meeting.id,
                opportunityId: meeting.opportunityId,
                activityId: meeting.activityId,
                statusLid: meeting.statusLid,
                opportunityActivityId: meeting.opportunityActivityId,
                dataActivity: {
                    handOverMeetFields: {
                        handOverMeetingTypeLid: meeting.handOverMeetingTypeLid,
                        selectMeeting: meeting.selectMeeting,
                        meetingDate: meeting.meeting.meetingDate,
                        availableFrom: meeting.meeting.startTime,
                        availableTo: meeting.meeting.endTime,
                        meetingTypeLid: meeting.meeting.meetingTypeLid,
                        locationTypeLid: meeting.meeting.locationTypeLid,
                    },
                    remarksMomSection: {
                        mom: meeting.mom,
                        remarks: meeting.remarks,
                    },
                    participants: {
                        companyContactPerson: companyParticipants.length > 0 ? companyParticipants : [],
                        employees: employeeParticipants.length > 0 ? employeeParticipants : [],
                    },
                    documents: documents,
                },
            };
            return data;
        }
        catch (error) {
            throw new Error(`Failed to retrieve hand over meeting details: ${error.message}`);
        }
    }
    async getOpportunityAndActivityIdsByOpportunityActivityId(opportunityActivityId) {
        const result = await this.opportunityActivityMapRepository.findOne({
            where: { id: opportunityActivityId },
            select: ["opportunityId", "refActivityId", "dueDate", "activityMeta"],
        });
        if (!result) {
            return null;
        }
        return {
            opportunityId: result.opportunityId,
            activityId: result.refActivityId,
            plannedDate: result.dueDate,
            activityMeta: result.activityMeta,
        };
    }
    async getOpportunityCovers(opportunityId, excludeCoverTypes) {
        try {
            const opportunity = await this.opportunityRepository.findOne({
                where: { opportunityId },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotPresent(opportunityId));
            }
            const covers = await this.opportunityRepository.manager.find(entities_1.OpportunityCoverMap, {
                where: { opportunityId, coverTypeLid: (0, typeorm_2.Not)((0, typeorm_2.In)(excludeCoverTypes)) },
            });
            if (!covers.length) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotPresent(opportunityId));
            }
            return covers.map((cover) => ({
                id: cover.id,
                opportunityId: cover.opportunityId,
                policyTypeId: cover.policyTypeId,
                coverId: cover.coverId,
                mandatory: cover.mandateType,
                approvalRequired: cover.approvalRequired,
                coverName: cover.coverName,
                coverDescription: cover.coverDescription,
                displaySequence: cover.displaySequence,
                displayCategory: cover.displayCategory,
                coverTypeLid: cover.coverTypeLid,
                inputType: cover.inputType,
                inputLov: cover.inputLov,
                coversMeta: cover.coversMeta,
            }));
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getContactDetailsByOpportunityId(opportunityId) {
        const opportunityContactMap = await this.opportunityRepository.manager.find(entities_1.OpportunityContactMap, {
            where: { opportunityId },
            relations: ["contact", "contact.communicationDetails"],
            select: {
                contact: {
                    id: true,
                    displayName: true,
                    communicationDetails: {
                        communicationType: true,
                        communicationDetails: true,
                    },
                },
            },
        });
        const contacts = opportunityContactMap.map((map) => {
            const email = map.contact.communicationDetails.find((detail) => detail.communicationType === "email")?.communicationDetails;
            const phone = map.contact.communicationDetails.find((detail) => detail.communicationType === "phone")?.communicationDetails;
            return {
                name: map.contact.displayName,
                email: email || null,
                phone: phone || null,
            };
        });
        return contacts;
    }
    async createMandateDetailsEntry(entityManager, mandateDetails) {
        try {
            const opportunity = await this.validateDates(mandateDetails);
            const existingMandate = await entityManager.findOne(entities_1.OpportunityMandateDetailsEntry, {
                where: {
                    opportunityId: mandateDetails.opportunityId,
                    activityId: mandateDetails.activityId,
                },
            });
            if (existingMandate) {
                throw new common_1.BadRequestException(`Mandate details already exist for Opportunity ID: ${mandateDetails.opportunityId}, Activity ID: ${mandateDetails.activityId}`);
            }
            const mandate = entityManager.create(entities_1.OpportunityMandateDetailsEntry, {
                opportunityId: mandateDetails.opportunityId,
                activityId: mandateDetails.activityId,
                companyId: opportunity.companyId,
                activityDate: new Date(), // Use current date as activityDate
                planDate: mandateDetails.planDate,
                mandateTypeLid: mandateDetails.mandateDetailsFromFields.mandateTypeLid,
                validFrom: mandateDetails.mandateDetailsFromFields.validFrom,
                validTo: mandateDetails.mandateDetailsFromFields.validTo,
                compensationPayable: mandateDetails.mandateDetailsFromFields.compensationPayable,
                compensationTypeLid: mandateDetails.mandateDetailsFromFields.compensationTypeLid,
                issuedOn: mandateDetails.mandateDetailsFromFields.issuedOn,
                remarks: mandateDetails.mandateDetailsFromFields.remarks,
                opportunityActivityId: mandateDetails.opportunityActivityId,
                statusLid: mandateDetails.statusLid,
                createdBy: mandateDetails.createdBy,
                updatedBy: mandateDetails.updatedBy,
            });
            return await entityManager.save(entities_1.OpportunityMandateDetailsEntry, mandate);
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to save mandate details: ${error.message}`);
        }
    }
    async validateDates(mandateDetails) {
        try {
            const opportunity = await this.opportunityRepository.findOne({
                where: { opportunityId: mandateDetails.opportunityId },
                select: ["opportunityId", "companyId", "createdAt", "soExpireDate"],
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${mandateDetails.opportunityId} not found`);
            }
            const details = mandateDetails.mandateDetailsFromFields;
            // Helper to compare only date part (ignoring time)
            const toDateOnly = (date) => {
                if (!date)
                    return NaN;
                const d = new Date(date);
                d.setHours(0, 0, 0, 0);
                return d.getTime();
            };
            const soExpireDate = toDateOnly(opportunity.soExpireDate);
            const validFrom = toDateOnly(details.validFrom);
            const validTo = toDateOnly(details.validTo);
            const issuedOn = toDateOnly(details.issuedOn);
            const today = toDateOnly(new Date());
            // as per the discussion with the team only validFrom and validTo validation is required
            // Validation: validFrom must be before validTo
            if (validFrom > validTo) {
                throw new common_1.BadRequestException("validFrom must be before validTo");
            }
            // // Validation: validFrom cannot be after opportunity close date
            // if (validFrom > soExpireDate) {
            //   throw new BadRequestException(
            //     "validFrom cannot be after opportunity close date"
            //   );
            // }
            // // Validation: validTo cannot be after opportunity close date
            // if (validTo > soExpireDate) {
            //   throw new BadRequestException(
            //     "validTo cannot be after opportunity close date"
            //   );
            // }
            // // Validation: validFrom must be before validTo
            // if (validFrom > validTo) {
            //   throw new BadRequestException("validFrom must be before validTo");
            // }
            // // Validation: issuedOn cannot be future date
            // if (issuedOn > today) {
            //   throw new BadRequestException("issuedOn cannot be in the future");
            // }
            // // Validation: validFrom must be after issuedOn
            // if (issuedOn > validFrom) {
            //   throw new BadRequestException("issuedOn cannot be after validFrom");
            // }
            return opportunity;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            if (error instanceof common_1.BadRequestException)
                throw error;
            throw new Error(`Date validation failed: ${error.message}`);
        }
    }
    async updateMandateDetails(entityManager, opportunityActivityId, updateData, userId) {
        try {
            const mandateDetails = await entityManager.findOne(entities_1.OpportunityMandateDetailsEntry, { where: { opportunityActivityId } });
            if (!mandateDetails) {
                throw new common_1.NotFoundException(`Mandate with opportunity activity ID ${opportunityActivityId} not found`);
            }
            const mandateDetailsStatus = await entityManager.findOne(entities_1.LookUp, {
                where: { id: mandateDetails.statusLid },
            });
            if (!mandateDetailsStatus) {
                throw new common_1.NotFoundException(`Status with ID ${mandateDetails.statusLid} not found`);
            }
            if (mandateDetailsStatus.lookUpKey ===
                constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED ||
                mandateDetailsStatus.lookUpKey === constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED) {
                throw new common_1.BadRequestException(`Mandate with opportunity activity ID ${opportunityActivityId} cannot be updated as it is already submitted.`);
            }
            await this.validateDates(updateData);
            // Perform the update
            await entityManager.update(entities_1.OpportunityMandateDetailsEntry, mandateDetails.id, {
                mandateTypeLid: updateData?.mandateDetailsFromFields?.mandateTypeLid ??
                    mandateDetails.mandateTypeLid,
                validFrom: updateData?.mandateDetailsFromFields?.validFrom ??
                    mandateDetails.validFrom,
                validTo: updateData?.mandateDetailsFromFields?.validTo ??
                    mandateDetails.validTo,
                compensationPayable: updateData?.mandateDetailsFromFields?.compensationPayable ??
                    mandateDetails.compensationPayable,
                compensationTypeLid: updateData?.mandateDetailsFromFields?.compensationTypeLid ??
                    mandateDetails.compensationTypeLid,
                issuedOn: updateData?.mandateDetailsFromFields?.issuedOn ??
                    mandateDetails.issuedOn,
                remarks: updateData?.mandateDetailsFromFields?.remarks ??
                    mandateDetails.remarks,
                statusLid: updateData?.statusLid ?? mandateDetails.statusLid,
                updatedBy: userId,
            });
            return await entityManager.findOne(entities_1.OpportunityMandateDetailsEntry, {
                where: { opportunityActivityId },
            });
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException)
                throw error;
            throw new Error(`Failed to update mandate details: ${error.message}`);
        }
    }
    async saveMandateDocuments(entityManager, mandateId, documents) {
        try {
            // Fetch existing documents for the mandate
            const existingDocuments = await entityManager.find(entities_1.OpportunityMandateDetailsDocumentMap, { where: { mandateId } });
            const existingDocumentIds = existingDocuments.map((doc) => doc.documentId);
            const incomingDocumentIds = documents.map((doc) => doc.documentId);
            // Determine documents to add
            const documentsToAdd = documents.filter((doc) => !existingDocumentIds.includes(doc.documentId));
            // Determine documents to remove
            const documentsToRemove = existingDocuments.filter((doc) => !incomingDocumentIds.includes(doc.documentId));
            // Add new documents
            if (documentsToAdd.length > 0) {
                const documentRecordsToAdd = documentsToAdd.map((doc) => entityManager.create(entities_1.OpportunityMandateDetailsDocumentMap, {
                    mandateId,
                    documentId: doc.documentId,
                    documentTypeLid: doc.documentTypeLid,
                }));
                await entityManager.save(entities_1.OpportunityMandateDetailsDocumentMap, documentRecordsToAdd);
            }
            // Remove documents that are no longer in the list
            if (documentsToRemove.length > 0) {
                const documentIdsToRemove = documentsToRemove.map((doc) => doc.documentId);
                await entityManager.delete(entities_1.OpportunityMandateDetailsDocumentMap, {
                    mandateId,
                    documentId: (0, typeorm_2.In)(documentIdsToRemove),
                });
            }
        }
        catch (error) {
            throw new Error(`Failed to save mandate documents: ${error.message}`);
        }
    }
    async saveMandateContacts(entityManager, mandateId, companyId, contacts) {
        try {
            // Fetch existing contacts for the mandate
            const existingContacts = await entityManager.find(entities_1.OpportunityMandateDetailsContactMap, { where: { mandateId } });
            const existingContactIds = existingContacts.map((contact) => contact.contactId);
            const incomingContactIds = contacts; // contacts is now an array of numbers
            // Determine contacts to add
            const contactsToAdd = incomingContactIds.filter((contactId) => !existingContactIds.includes(contactId));
            // Determine contacts to remove
            const contactsToRemove = existingContactIds.filter((contactId) => !incomingContactIds.includes(contactId));
            // Add new contacts
            if (contactsToAdd.length > 0) {
                const contactRecordsToAdd = await Promise.all(contactsToAdd.map(async (contactId) => {
                    // Validate if the contact exists for the given company
                    const isContactExists = await this.fetchByCompanyContactId(companyId, contactId);
                    if (!isContactExists) {
                        throw new common_1.BadRequestException(`Contact with ID ${contactId} does not exist for company ID ${companyId}`);
                    }
                    return entityManager.create(entities_1.OpportunityMandateDetailsContactMap, {
                        mandateId,
                        contactId,
                    });
                }));
                await entityManager.save(entities_1.OpportunityMandateDetailsContactMap, contactRecordsToAdd);
            }
            // Remove contacts that are no longer in the list
            if (contactsToRemove.length > 0) {
                await entityManager.delete(entities_1.OpportunityMandateDetailsContactMap, {
                    mandateId,
                    contactId: (0, typeorm_2.In)(contactsToRemove),
                });
            }
        }
        catch (error) {
            throw new Error(`Failed to save mandate contacts: ${error.message}`);
        }
    }
    // Fetch mandate details by opportunityId and activityId
    async getMandateDetailsByOpportunityAndActivity(opportunityId, activityId) {
        try {
            const mandateDetails = await this.mandateDetailsEntryRepository.findOne({
                where: { opportunityId, activityId },
                relations: ["mandateDetailsContacts", "mandateDetailsDocuments"],
            });
            if (!mandateDetails) {
                throw new common_1.NotFoundException(`Mandate details not found for Opportunity ID: ${opportunityId} and Activity ID: ${activityId}`);
            }
            let documents = [];
            if (mandateDetails?.mandateDetailsDocuments &&
                mandateDetails?.mandateDetailsDocuments?.length > 0) {
                documents = mandateDetails?.mandateDetailsDocuments.map((doc) => ({
                    id: doc.id,
                    documentId: doc.documentId,
                    documentTypeLid: doc.documentTypeLid,
                }));
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            // Format and return the result
            return {
                id: mandateDetails.id,
                opportunityId: mandateDetails.opportunityId,
                activityId: mandateDetails.activityId,
                opportunityActivityId: mandateDetails.opportunityActivityId,
                statusLid: mandateDetails.statusLid,
                dataActivity: {
                    mandateDetailsFromFields: {
                        mandateTypeLid: mandateDetails.mandateTypeLid,
                        validFrom: mandateDetails.validFrom,
                        validTo: mandateDetails.validTo,
                        compensationPayable: mandateDetails.compensationPayable,
                        compensationTypeLid: mandateDetails.compensationTypeLid,
                        issuedOn: mandateDetails.issuedOn,
                        remarks: mandateDetails.remarks,
                        mandateDetailsContacts: mandateDetails.mandateDetailsContacts.map((contactMap) => contactMap.contactId),
                    },
                    documents: documents,
                },
            };
        }
        catch (error) {
            throw new Error(`Failed to retrieve mandate details: ${error.message}`);
        }
    }
    async getExistingMandateDetails(opportunityActivityId) {
        try {
            const opportunityActivity = await this.opportunityActivityMapRepository.findOne({
                where: { id: opportunityActivityId },
            });
            const opportunity = await this.opportunityRepository.findOne({
                where: { opportunityId: opportunityActivity?.opportunityId },
                select: ["opportunityId", "companyId"],
            });
            const mandateDetails = await this.mandateDetailsEntryRepository.findOne({
                where: { companyId: opportunity?.companyId },
                order: { validTo: "DESC" },
                relations: ["mandateDetailsContacts", "mandateDetailsDocuments"],
            });
            if (!mandateDetails) {
                return null;
            }
            let documents = [];
            if (mandateDetails?.mandateDetailsDocuments &&
                mandateDetails?.mandateDetailsDocuments?.length > 0) {
                documents = mandateDetails?.mandateDetailsDocuments?.map((doc) => ({
                    id: doc.id,
                    documentId: doc.documentId,
                    documentTypeLid: doc.documentTypeLid,
                }));
            }
            else {
                documents = [
                    {
                        documentId: null,
                        documentTypeLid: null,
                    },
                ];
            }
            // Format and return the result
            return {
                id: mandateDetails?.id,
                opportunityId: mandateDetails?.opportunityId,
                activityId: mandateDetails?.activityId,
                opportunityActivityId: mandateDetails?.opportunityActivityId,
                statusLid: mandateDetails?.statusLid,
                dataActivity: {
                    mandateDetailsFromFields: {
                        mandateTypeLid: mandateDetails?.mandateTypeLid,
                        validFrom: mandateDetails?.validFrom,
                        validTo: mandateDetails?.validTo,
                        compensationPayable: mandateDetails?.compensationPayable,
                        compensationTypeLid: mandateDetails?.compensationTypeLid,
                        issuedOn: mandateDetails?.issuedOn,
                        remarks: mandateDetails?.remarks,
                        mandateDetailsContacts: mandateDetails?.mandateDetailsContacts?.map((contactMap) => contactMap.contactId),
                    },
                    documents: documents,
                },
            };
        }
        catch (error) {
            throw new Error(`Failed to retrieve mandate details: ${error.message}`);
        }
    }
    async getOpportunityActivity(opportunityActivityId) {
        return await this.opportunityActivityMapRepository.findOne({
            where: { id: opportunityActivityId },
        });
    }
    async getOpportunityRfpCovers(opportunityId) {
        return await this.opportunityRepository.manager.find(entities_1.OpportunityCoverMap, {
            where: { opportunityId },
        });
    }
    async saveRfpCoverDetails(opportunityId, opportunityActivityId, rfpCoverDetails, remarks, documents, createdBy, statusLid) {
        await this.opportunityRepository.manager.transaction(async (transactionalEntityManager) => {
            try {
                // Save RFP cover details
                await transactionalEntityManager.save(entities_1.OpportunityRfpCoverDetail, rfpCoverDetails);
                // Save opportunity_rfp_detail data
                const opportunityRfpDetails = transactionalEntityManager.create(entities_1.OpportunityRfpDetail, {
                    opportunityId,
                    opportunityActivityId,
                    remarks,
                    statusLid: statusLid,
                    createdBy,
                    updatedBy: createdBy,
                });
                const savedRfpDetail = await transactionalEntityManager.save(entities_1.OpportunityRfpDetail, opportunityRfpDetails);
                // Save document records if present
                if (documents) {
                    const documentRecords = documents.map((doc) => transactionalEntityManager.create(entities_1.OpportunityRfpActivityDocumentMap, {
                        opportunityActivityMapId: opportunityActivityId,
                        rfpDetailId: savedRfpDetail.id,
                        documentId: doc.documentId,
                        documentTypeLid: doc.documentTypeLid, // Assuming documentTypeLid is not provided
                    }));
                    await transactionalEntityManager.save(entities_1.OpportunityRfpActivityDocumentMap, documentRecords);
                }
            }
            catch (error) {
                if (error instanceof common_1.NotFoundException ||
                    error instanceof common_1.BadRequestException) {
                    throw error; // Re-throw known exceptions
                }
                console.error("Error in saveRfpCoverDetails transaction:", error);
                throw new common_1.BadRequestException(`Failed to save RFP cover details: ${error.message}`);
            }
        });
    }
    async updateRfpCoverDetails(opportunityId, opportunityActivityId, rfpCoverDetails, remarks, documents, updatedBy, statusLid) {
        await this.opportunityRepository.manager.transaction(async (transactionalEntityManager) => {
            try {
                for (const detail of rfpCoverDetails) {
                    const existing = await transactionalEntityManager.findOne(entities_1.OpportunityRfpCoverDetail, {
                        where: { opportunityId, coverMapId: detail.coverMapId },
                    });
                    if (existing) {
                        await transactionalEntityManager.update(entities_1.OpportunityRfpCoverDetail, { id: existing.id }, { coverResponse: detail.coverResponse, updatedBy });
                    }
                    else {
                        await transactionalEntityManager.insert(entities_1.OpportunityRfpCoverDetail, detail);
                    }
                }
                let rfpDetail = await transactionalEntityManager.findOne(entities_1.OpportunityRfpDetail, { where: { opportunityActivityId } });
                if (rfpDetail) {
                    await transactionalEntityManager.update(entities_1.OpportunityRfpDetail, { id: rfpDetail.id }, { remarks, statusLid, updatedBy });
                }
                else {
                    rfpDetail = await transactionalEntityManager.save(entities_1.OpportunityRfpDetail, transactionalEntityManager.create(entities_1.OpportunityRfpDetail, {
                        opportunityId,
                        opportunityActivityId,
                        remarks,
                        statusLid,
                        createdBy: updatedBy,
                        updatedBy,
                    }));
                }
                if (documents) {
                    await transactionalEntityManager.delete(entities_1.OpportunityRfpActivityDocumentMap, { opportunityActivityMapId: opportunityActivityId });
                    const documentRecords = documents.map((doc) => transactionalEntityManager.create(entities_1.OpportunityRfpActivityDocumentMap, {
                        opportunityActivityMapId: opportunityActivityId,
                        rfpDetailId: rfpDetail.id,
                        documentId: doc.documentId,
                        documentTypeLid: doc.documentTypeLid,
                    }));
                    if (documentRecords.length) {
                        await transactionalEntityManager.save(entities_1.OpportunityRfpActivityDocumentMap, documentRecords);
                    }
                }
            }
            catch (error) {
                if (error instanceof common_1.NotFoundException ||
                    error instanceof common_1.BadRequestException) {
                    throw error;
                }
                console.error("Error in updateRfpCoverDetails transaction:", error);
                throw new common_1.BadRequestException(`Failed to update RFP cover details: ${error.message}`);
            }
        });
    }
    async getRfpCoverDetailsByOpportunityId(opportunityId) {
        try {
            const rfpCoverDetails = await this.rfpCoverDetailRepository.find({
                where: { opportunityId },
                // relations: ["coverMap"],
            });
            if (!rfpCoverDetails.length) {
                throw new common_1.NotFoundException(messages_1.errorMessages.rfpCoverDetailsNotFound(opportunityId));
            }
            return rfpCoverDetails;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async createPremiumCalculation(entityManager, dto, userId) {
        try {
            const newRecord = entityManager.create(entities_1.OpportunityPremiumCalculation, {
                ...dto,
                createdBy: userId,
                updatedBy: userId,
                createdAt: new Date(),
                updatedAt: new Date(),
            });
            const savedRecord = await entityManager.save(entities_1.OpportunityPremiumCalculation, newRecord);
            return savedRecord;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.premiumCalculationError);
        }
    }
    async createHeldCoverNote(entityManager, dto, userId) {
        try {
            const newRecord = entityManager.create(entities_1.OpportunityHeldCoverNote, {
                ...dto,
                createdBy: userId,
                updatedBy: userId,
                createdAt: new Date(),
                updatedAt: new Date(),
            });
            const savedRecord = await entityManager.save(entities_1.OpportunityHeldCoverNote, newRecord);
            return savedRecord;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.heldCoverNoteError);
        }
    }
    async saveHeldCoverNoteDocuments(heldCoverNoteId, documents, entityManager) {
        try {
            const documentRecords = documents.map((doc) => entityManager.create(entities_1.HeldCoverNoteDocumentMap, {
                heldCoverNoteId,
                documentId: doc.documentId,
                documentTypeLid: doc.documentTypeLid,
            }));
            await entityManager.save(entities_1.HeldCoverNoteDocumentMap, documentRecords);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.heldCoverNoteDocumentsError);
        }
    }
    async getHeldCoverNoteByOpportunityActivityId(opportunityActivityId) {
        try {
            const heldCoverNote = await this.opportunityRepository.manager.findOne(entities_1.OpportunityHeldCoverNote, {
                where: { opportunityActivityId: opportunityActivityId },
                relations: [
                    "documents",
                    "opportunity",
                    "placementSlipDeviations",
                    "deviationsAddressed",
                    "revisedHeldCoverNote",
                    "resolution",
                    "status",
                ],
            });
            if (heldCoverNote) {
                (0, response_utils_1.removeMetadataFields)(heldCoverNote);
                (0, response_utils_1.removeLookUpDataFields)(heldCoverNote);
            }
            return heldCoverNote || null;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getRfpActivityDetailsByOpportunityId(opportunityId) {
        try {
            const rfpActivityDetails = await this.opportunityRepository.manager.find(entities_1.OpportunityRfpDetail, {
                where: { opportunityId },
                // relations: ["opportunityActivity"],
            });
            if (!rfpActivityDetails.length) {
                return [];
            }
            return rfpActivityDetails;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getRfpActivityDocumentsByOpportunityId(opportunityActivityMapId) {
        try {
            const rfpActivityDocuments = await this.opportunityRepository.manager.find(entities_1.OpportunityRfpActivityDocumentMap, {
                where: { opportunityActivityMapId },
                relations: ["document"],
            });
            if (!rfpActivityDocuments.length) {
                return [];
            }
            return rfpActivityDocuments;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async createPolicyConfirmation(entityManager, dto, userId) {
        try {
            const newRecord = entityManager.create(entities_1.OpportunityPolicyConfirmation, {
                ...dto,
                createdBy: userId,
                updatedBy: userId,
                createdAt: new Date(),
                updatedAt: new Date(),
            });
            const savedRecord = await entityManager.save(entities_1.OpportunityPolicyConfirmation, newRecord);
            return savedRecord;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.policyConfirmationDataFailed);
        }
    }
    async savePolicyConfirmationDocuments(policyConfirmationId, documents, entityManager) {
        const documentRecords = documents.map((doc) => entityManager.create(entities_1.PolicyConfirmationDocumentMap, {
            policyConfirmationId,
            documentId: doc.documentId,
            documentTypeLid: doc.documentTypeLid,
        }));
        await entityManager.save(entities_1.PolicyConfirmationDocumentMap, documentRecords);
    }
    async createPolicyHardCopy(entityManager, dto, userId) {
        try {
            const newRecord = entityManager.create(entities_1.OpportunityPolicyHardCopy, {
                ...dto,
                createdBy: userId,
                updatedBy: userId,
                createdAt: new Date(),
                updatedAt: new Date(),
            });
            const savedRecord = await entityManager.save(entities_1.OpportunityPolicyHardCopy, newRecord);
            return savedRecord;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.policyConfirmationDataFailed);
        }
    }
    async savePolicyHardCopyDocuments(policyHardCopyId, documents, entityManager) {
        const documentRecords = documents.map((doc) => entityManager.create(entities_1.PolicyHardCopyDocumentMap, {
            policyHardCopyId,
            documentId: doc.documentId,
            documentTypeLid: doc.documentTypeLid,
        }));
        await entityManager.save(entities_1.PolicyHardCopyDocumentMap, documentRecords);
    }
    createQuoteEntity(opportunity_activity_id, dto, userId) {
        return this.quoteRepo.create({
            opportunityId: dto.opportunityId,
            opportunityActivityId: opportunity_activity_id,
            brokingSlipId: dto.brokingSlipId,
            insurerId: dto.quoteDetails?.insurerId,
            quoteReceivedOn: dto.quoteDetails?.quoteReceivedOn,
            basicPremium: dto.quoteDetails?.basicPremium,
            terrorismCover: dto.quoteDetails?.terrorismCover,
            netPremium: dto.netPremiumDetails?.netPremium,
            brokeragePercent: dto.netPremiumDetails?.brokeragePercent,
            insurerRemarks: dto.netPremiumDetails?.insurerRemarks,
            attachmentUrl: dto.attachmentUrl,
            statusId: dto.statusId,
            createdBy: userId,
            updatedBy: userId,
        });
    }
    async saveQuote(quote, manager) {
        return manager.save(entities_1.OpportunityQuoteEntry, quote);
    }
    createDocumentMappings(quoteId, documents) {
        if (!quoteId) {
            throw new Error("quoteId is required to create document mappings.");
        }
        if (!documents || !Array.isArray(documents)) {
            throw new Error("documents array is required and cannot be empty.");
        }
        return documents.map((doc) => {
            if (!doc.documentId) {
                throw new Error("documentId is required for each document.");
            }
            return this.quoteEntryDocumentMapRepo.create({
                opportunityQuoteEntryId: quoteId,
                documentId: doc.documentId,
            });
        });
    }
    async saveDocumentMappings(documentMaps, manager) {
        await manager.save(entities_1.OpportunityQuoteEntryDocumentMap, documentMaps);
    }
    async findOpportunityById(opportunityId, entityManager) {
        try {
            const opportunity = await entityManager.findOne(entities_1.Opportunity, {
                where: { opportunityId },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${opportunityId} not found.`);
            }
            return opportunity;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to fetch opportunity with ID ${opportunityId}.`);
        }
    }
    async findQuoteById(quoteId, manager) {
        return manager.findOne(entities_1.OpportunityQuoteEntry, { where: { id: quoteId } });
    }
    async deleteDocumentMappings(quoteId, manager) {
        await manager.delete(entities_1.OpportunityQuoteEntryDocumentMap, {
            opportunityQuoteEntryId: quoteId,
        });
    }
    async findQuotesByBrokingSlipAndActivity(brokingSlipId, opportunityActivityId) {
        try {
            // Validate input parameters
            if (!brokingSlipId || !opportunityActivityId) {
                throw new common_1.BadRequestException("Both brokingSlipId and opportunityActivityId are required.");
            }
            // Fetch quotes using the repository's `find` method
            const quotes = await this.quoteRepo.find({
                where: {
                    brokingSlipId,
                    opportunityActivityId,
                },
                relations: [
                    "coverDetails", // Include coverDetails relation
                    "opportunity",
                    "insurer",
                    "status",
                    "documentMappings",
                ],
            });
            console.log("Fetched quotes:", quotes);
            // Check if quotes were found
            if (!quotes || quotes.length === 0) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityQuoteNotFound);
            }
            // Return the fetched quotes
            return quotes;
        }
        catch (error) {
            console.error("Error fetching quotes:", error);
            // Handle specific exceptions
            if (error instanceof common_1.BadRequestException ||
                error instanceof common_1.NotFoundException) {
                throw error;
            }
            // Log and rethrow unexpected errors
            throw new common_1.BadRequestException(messages_1.errorMessages.quoteRetrievalFailed);
        }
    }
    async findQuotesByBrokingSlip(brokingSlipId) {
        try {
            if (!brokingSlipId) {
                throw new common_1.BadRequestException("brokingSlipId is required.");
            }
            return this.quoteRepo
                .createQueryBuilder("entry")
                .leftJoinAndMapOne("entry.opportunityQuote", entities_1.OpportunityQuote, "quote", "quote.id = entry.id")
                .leftJoinAndMapMany("entry.quoteDocuments", entities_1.OpportunityQuoteDocumentMap, "quoteDoc", "quoteDoc.opportunity_activity_id = quote.id")
                .leftJoinAndMapMany("entry.taxDetails", entities_1.OpportunityQuoteTaxMap, "tax", "tax.opportunity_quote_entry_id = entry.id")
                .leftJoinAndSelect("entry.coverDetails", "coverDetails")
                .leftJoinAndSelect("entry.documentMappings", "entryDocs")
                .leftJoinAndSelect("entry.insurer", "insurer")
                .where("entry.broking_slip_id = :brokingSlipId", { brokingSlipId })
                .andWhere("entry.deleted_at IS NULL")
                .getMany();
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException ||
                error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.BadRequestException(messages_1.errorMessages.quoteRetrievalFailed);
        }
    }
    async createPolicyDocket(entityManager, dto, userId) {
        try {
            const newRecord = entityManager.create(entities_1.OpportunityPolicyDocket, {
                ...dto,
                createdBy: userId,
                updatedBy: userId,
                createdAt: new Date(),
                updatedAt: new Date(),
            });
            const savedRecord = await entityManager.save(entities_1.OpportunityPolicyDocket, newRecord);
            return savedRecord;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.policyDocketDataFailed);
        }
    }
    async savePolicyDocketDocuments(policyDocketId, documents, entityManager) {
        const documentRecords = documents.map((doc) => entityManager.create(entities_1.PolicyDocketDocumentMap, {
            policyDocketId,
            documentId: doc.documentId,
            documentTypeLid: doc.documentTypeLid,
        }));
        await entityManager.save(entities_1.PolicyDocketDocumentMap, documentRecords);
    }
    async getPolicyDocketByOpportunityActivityId(opportunityActivityId) {
        try {
            const policyDocket = await this.opportunityRepository.manager.findOne(entities_1.OpportunityPolicyDocket, {
                where: { opportunityActivityId: opportunityActivityId },
                relations: ["documents", "status", "opportunity"],
            });
            if (policyDocket) {
                (0, response_utils_1.removeMetadataFields)(policyDocket);
                (0, response_utils_1.removeLookUpDataFields)(policyDocket);
            }
            return policyDocket || null;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.policyDocketNotFound);
        }
    }
    async updatePolicyDocket(entityManager, policyDocketId, updateData, userId) {
        try {
            // Exclude documents from the update
            const fieldsToUpdate = {
                ...updateData,
                updatedBy: userId,
                updatedAt: new Date(),
            };
            // Perform the update
            await entityManager.update(entities_1.OpportunityPolicyDocket, { id: policyDocketId }, fieldsToUpdate);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to update policy docket: ${error.message}`);
        }
    }
    async updateHeldCoverNoteActivity(entityManager, heldCoverNoteId, updateData, userId) {
        try {
            await entityManager.update(entities_1.OpportunityHeldCoverNote, { id: heldCoverNoteId }, {
                ...updateData,
                updatedBy: userId,
                updatedAt: new Date(),
            });
            return updateData;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to update held cover note: ${error.message}`);
        }
    }
    async getEntityTableMapIds(entity, select, whereCondition) {
        try {
            const data = await this.entityService.getEntityMapByIds(entity, select, whereCondition);
            return data;
        }
        catch (error) {
            return [];
        }
    }
    async deleteEntityTableMapIds(entity, deleteIds, select, deletionType) {
        try {
            await this.entityService.deleteEntityMapByIds(entity, deleteIds, select, deletionType);
        }
        catch (error) {
            throw new common_1.BadRequestException(error);
        }
    }
    async deleteFileUploadByIds(fileUploadEntity, entity, select, whereCondition, deletionType) {
        try {
            await this.entityService.deleteFileUploadByIds(fileUploadEntity, entity, select, whereCondition, deletionType);
        }
        catch (error) {
            throw new common_1.BadRequestException(error);
        }
    }
    async updateDocument(entityManager, id, documentId, documentTypeLid, entityName) {
        try {
            await entityManager.update(entityName, { id }, {
                documentId,
                documentTypeLid,
            });
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to update document: ${error.message}`);
        }
    }
    async getPolicyConfirmationByOpportunityActivityId(opportunityActivityId) {
        try {
            const policyConfirmation = await this.opportunityRepository.manager.findOne(entities_1.OpportunityPolicyConfirmation, {
                where: { opportunityActivityId: opportunityActivityId },
                relations: [
                    "documents",
                    "opportunity",
                    "policyDataWrong",
                    "deviationResolved",
                    "resolution",
                    "policyDataRectified",
                    "status",
                ],
            });
            if (policyConfirmation) {
                (0, response_utils_1.removeMetadataFields)(policyConfirmation);
                (0, response_utils_1.removeLookUpDataFields)(policyConfirmation);
            }
            return policyConfirmation || null;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getPolicyHardCopyByOpportunityActivityId(opportunityActivityId) {
        try {
            const policyHardCopy = await this.opportunityRepository.manager.findOne(entities_1.OpportunityPolicyHardCopy, {
                where: { opportunityActivityId: opportunityActivityId },
                relations: [
                    "documents",
                    "opportunity",
                    "status",
                    "deviations",
                    "deviationCoverages",
                    "deviationsAddressed",
                    "resolution",
                    "revisedPolicyHardCopyReceived",
                ],
            });
            if (policyHardCopy) {
                (0, response_utils_1.removeMetadataFields)(policyHardCopy);
                (0, response_utils_1.removeLookUpDataFields)(policyHardCopy);
            }
            return policyHardCopy || null;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async createPlacementSlip(data, userId, entityManager) {
        const { tpaMaps = [], insurerMaps = [], sharingDetails = [], cdDetails = [], coverDetails = {}, installmentDetails = [], documents = [], ...placementData } = data;
        const activity = await this.opportunityActivityMapRepository.findOne({
            where: { id: placementData.opportunityActivityId },
            select: ["opportunityId"],
        });
        const opportunityId = activity?.opportunityId;
        const placement = this.placementRepo.create({
            ...placementData,
            createdBy: userId,
            updatedBy: userId,
        });
        const savedPlacement = await this.placementRepo.save(placement);
        // Save child records with placementSlipId
        const placementSlipId = savedPlacement.id;
        // Get all cover entities for the provided coverTemplateIds
        const covers = await this.getOpportunityQuoteCoverByIds(entityManager, Object.keys(coverDetails).map(Number));
        // Create a map for quick lookup of coverName by coverTemplateId
        const coverNameMap = new Map();
        covers.forEach((cover) => {
            coverNameMap.set(cover.id, cover.coverName ?? "");
        });
        await Promise.all([
            // Save covers with correct coverName
            ...Object.entries(coverDetails).map(([coverTemplateId, coverResponse]) => this.coverRepo.save({
                placementSlipId,
                opportunityId,
                coverTemplateId: Number(coverTemplateId),
                coverName: coverNameMap.get(Number(coverTemplateId)) ?? "",
                coverResponse: String(coverResponse),
                createdBy: userId,
                updatedBy: userId,
                createdAt: new Date(),
                updatedAt: new Date(),
            })),
            ...tpaMaps.map((tpaData) => this.tpaRepo.save({
                ...tpaData,
                placementSlipId,
                createdBy: userId,
                updatedBy: userId,
            })),
            ...insurerMaps.map((insurerData) => this.insurerRepo.save({
                ...insurerData,
                placementSlipId,
                createdBy: userId,
                updatedBy: userId,
            })),
            ...sharingDetails.map((detail) => this.sharingRepo.save({
                ...detail,
                placementSlipId,
                createdBy: userId,
                updatedBy: userId,
            })),
            ...cdDetails.map((cd) => this.cdRepo.save({
                ...cd,
                placementSlipId,
                createdBy: userId,
                updatedBy: userId,
            })),
            ...installmentDetails.map((installment) => this.installemnetRepo.save({
                ...installment,
                placementSlipId,
                createdBy: userId,
                updatedBy: userId,
            })),
        ]);
        await this.savePlacementSlipDocuments(placementSlipId, documents, entityManager);
        return savedPlacement;
    }
    async createPolicyWithDetails(placementSlipId, userId, entityManager) {
        // Fetch placement slip details with relations
        const placementSlip = await this.placementRepo.findOne({
            where: { id: placementSlipId },
            relations: [
                "tpaMaps",
                "insurerMaps",
                "coverDetails",
                "installmentDates",
                "cdDetails",
            ],
        });
        const enrollmentStatus = await this.lookUpRepository.find({
            where: { lookUpKey: constants_1.ENROLLMENT_STATUS_NOT_READY },
        });
        const policyConfigStatus = await this.lookUpRepository.find({
            where: { lookUpKey: constants_1.POLICY_CONFIG_STATUS_IN_PROGRESS },
        });
        const policyStatus = await this.lookUpRepository.find({
            where: { lookUpKey: constants_1.OPPORTUNITY_POLICY_STATUS_CREATED },
        });
        // Fetch the opportunityActivityMap record using the provided opportunityActivityId
        const opportunityActivityMap = await this.opportunityActivityMapRepository.findOne({
            where: { id: placementSlip?.opportunityActivityId },
            select: ["opportunityId"],
        });
        if (!opportunityActivityMap) {
            throw new common_1.NotFoundException(`Opportunity Activity Map with ID ${placementSlip?.opportunityActivityId} not found`);
        }
        // Use the opportunityId from the opportunityActivityMap to fetch the opportunity details
        const opportunity = await this.opportunityRepository.findOne({
            where: { opportunityId: opportunityActivityMap.opportunityId },
            relations: ["company", "policyType", "policyStatus", "opportunityType"],
        });
        if (!opportunity) {
            throw new common_1.NotFoundException(`Opportunity with ID ${opportunityActivityMap.opportunityId} not found`);
        }
        if (!placementSlip) {
            throw new common_1.NotFoundException(`Placement slip not found for ID: ${placementSlipId}`);
        }
        console.log("Creating policy with the following details:", {
            opportunity,
            userId,
        });
        console.log("Placement Slip Details:", placementSlip);
        // Extract data for the Policy table
        const policyPayload = {
            policyName: opportunity.policyType?.lookUpValue,
            policyType: opportunity.policyTypeLid, // Example, replace with actual logic
            opportunityId: opportunity.opportunityId,
            companyId: opportunity.companyId,
            policyFrom: placementSlip.policyFromDate,
            policyTo: placementSlip.policyToDate,
            provisionalPolicyNo: "XYZXYZ1234",
            sumInsured: placementSlip.sumInsured,
            premiumAtInception: placementSlip.basicPremium,
            serviceTax: placementSlip.serviceTaxAmount,
            gst: placementSlip.serviceTaxPercentage,
            insurerPolicyNumber: null,
            commissionTerrorism: placementSlip.terrorismCommissionPercentage,
            policyConfiguration: null,
            configurationStatusLid: policyConfigStatus[0]?.id,
            enrollmentStatusLid: enrollmentStatus[0]?.id,
            policyStatusLid: policyStatus[0]?.id,
            createdBy: userId,
            createdAt: new Date(),
            updatedBy: userId,
            updatedAt: new Date(),
        };
        console.log("Policy Payload:", policyPayload);
        // Save the policy
        const policy = await entityManager.save("Policy", policyPayload);
        // Save TPA details
        if (placementSlip.tpaMaps?.length) {
            const tpaPayloads = placementSlip.tpaMaps.map((tpa) => ({
                policyId: policy.id,
                tpaId: tpa.tpaId,
                tpaBranchId: tpa.tpaBranchId,
                createdAt: new Date(),
                updatedAt: new Date(),
            }));
            await entityManager.save("PolicyTpaMap", tpaPayloads);
        }
        // Save Insurer details
        if (placementSlip.leadInsurerId) {
            // Insert the lead insurer
            const leadInsurerPayload = {
                policyId: policy.id,
                insurerParticipationTypeLid: 486, // Lead Insurer
                insurerId: placementSlip.leadInsurerId,
                insurerBranchId: null,
                insurerContactId: null,
                createdAt: new Date(),
                updatedAt: new Date(),
            };
            await entityManager.save("PolicyInsurerMap", leadInsurerPayload);
        }
        if (placementSlip.insurerMaps?.length) {
            // Insert co-insurers
            const coInsurerPayloads = placementSlip.insurerMaps.map((insurer) => ({
                policyId: policy.id,
                insurerParticipationTypeLid: 487, // Co-Insurer
                insurerId: insurer.insurerId,
                insurerBranchId: insurer.insurerBranchId,
                insurerContactId: insurer.insurerContactId,
                createdAt: new Date(),
                updatedAt: new Date(),
            }));
            await entityManager.save("PolicyInsurerMap", coInsurerPayloads);
        }
        // Save Cover details
        if (placementSlip.coverDetails?.length) {
            const coverPayloads = placementSlip.coverDetails.map((cover) => ({
                policyId: policy.id,
                coverTemplateId: cover.coverTemplateId,
                coverName: cover.coverName,
                coverResponse: cover.coverResponse,
                createdAt: new Date(),
                updatedAt: new Date(),
            }));
            await entityManager.save("PolicyCoverMap", coverPayloads);
        }
        if (placementSlip.installmentDates?.length) {
            const installmentPayloads = placementSlip.installmentDates.map((installment) => ({
                policyId: policy.id,
                installment1: installment.firstInstallmentDate || null,
                installment2: installment.secondInstallmentDate || null,
                createdAt: new Date(),
                updatedAt: new Date(),
            }));
            await entityManager.save("PolicyPremiumInstallmentSchedule", installmentPayloads);
        }
        if (placementSlip.cdDetails?.length) {
            const cdPayloads = placementSlip.cdDetails.map((cd) => ({
                policyId: policy.id,
                cdId: cd.id,
                createdAt: new Date(),
                updatedAt: new Date(),
            }));
            await entityManager.save("PolicyCdNumberMap", cdPayloads);
        }
        return policy;
    }
    async updatePlacementSlip(id, data) {
        const placement = await this.placementRepo.findOne({ where: { id } });
        if (!placement) {
            throw new common_1.NotFoundException(`Placement slip with ID ${id} not found`);
        }
        const activity = await this.opportunityActivityMapRepository.findOne({
            where: { id: placement.opportunityActivityId },
            select: ["opportunityId"],
        });
        const opportunityId = activity?.opportunityId;
        const { tpaMaps = [], insurerMaps = [], sharingDetails = [], cdDetails = [], coverDetails = [], ...placementData } = data;
        await this.placementRepo.update(id, placementData);
        await Promise.all([
            this.tpaRepo.delete({ placementSlipId: id }),
            this.insurerRepo.delete({ placementSlipId: id }),
            this.sharingRepo.delete({ placementSlipId: id }),
            this.cdRepo.delete({ placementSlipId: id }),
            this.coverRepo.delete({ placementSlipId: id }),
        ]);
        await Promise.all([
            ...tpaMaps.map((tpa) => this.tpaRepo.save({ ...tpa, placementSlipId: id })),
            ...insurerMaps.map((ins) => this.insurerRepo.save({ ...ins, placementSlipId: id })),
            ...sharingDetails.map((detail) => this.sharingRepo.save({ ...detail, placementSlipId: id })),
            ...cdDetails.map((cd) => this.cdRepo.save({ ...cd, placementSlipId: id })),
            ...coverDetails.map((cover) => this.coverRepo.save({ ...cover, placementSlipId: id, opportunityId })),
        ]);
        return await this.placementRepo.findOne({
            where: { id },
            relations: [
                "tpaMaps",
                "insurerMaps",
                "sharingDetails",
                "cdDetails",
                "coverDetails",
            ],
        });
    }
    async getPlacementSlipData(opportunityActivityId) {
        const placement = await this.placementRepo.findOne({
            where: { opportunityActivityId },
            relations: [
                "tpaMaps",
                "insurerMaps",
                "sharingDetails",
                "cdDetails",
                "coverDetails",
                "installmentDates",
                "documents",
            ],
        });
        if (!placement) {
            throw new common_1.NotFoundException(`Placement slip with ID ${opportunityActivityId} not found`);
        }
        else {
            (0, response_utils_1.removeMetadataFields)(placement);
            (0, response_utils_1.removeLookUpDataFields)(placement);
        }
        return placement;
    }
    async getCoverPrefillData(opportunityActivityId, opportunityId) {
        const placement = await this.placementRepo.findOne({
            where: { opportunityActivityId },
            relations: ["coverDetails"],
        });
        if (placement &&
            placement?.coverDetails &&
            placement.coverDetails?.length > 0) {
            return placement.coverDetails;
        }
        return this.opportunityRepository.manager.find(entities_1.OpportunityFinalNegotiationQuoteCoverDetail, { where: { opportunityId } });
    }
    async softDeletePlacementSlip(id) {
        const placement = await this.placementRepo.findOne({ where: { id } });
        if (!placement) {
            throw new common_1.NotFoundException(`Placement slip with ID ${id} not found`);
        }
        const deletedAt = new Date();
        await this.placementRepo.update(id, { deletedAt });
        await Promise.all([
            this.tpaRepo.update({ placementSlipId: id }, { deletedAt }),
            this.insurerRepo.update({ placementSlipId: id }, { deletedAt }),
            this.sharingRepo.update({ placementSlipId: id }, { deletedAt }),
            this.cdRepo.update({ placementSlipId: id }, { deletedAt }),
            this.coverRepo.update({ placementSlipId: id }, { deletedAt }),
        ]);
    }
    async softDeleteQuoteEntry(id) {
        try {
            const quote = await this.quoteRepo.findOne({ where: { id } });
            if (!quote) {
                throw new common_1.NotFoundException(`Quote entry with ID ${id} not found`);
            }
            const deletedAt = new Date();
            await this.quoteRepo.update(id, { deletedAt });
            // await Promise.all([
            //   this.quoteEntryDocumentMapRepo.update(
            //     { opportunityQuoteEntryId: id },
            //     { deletedAt }
            //   ),
            //   this.coverRepo.update({ quoteId: id }, { deletedAt }),
            //   this.quoteTaxRepo.update(
            //     { opportunityQuoteEntryId: id },
            //     { deletedAt }
            //   ),
            // ]);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to soft delete quote entry: ${error.message}`);
        }
    }
    async createOpportunityRfpDetailsEntry(dto, userId, entityManager) {
        const rfpDetailsEntry = entityManager.create(entities_1.OpportunityRfpDetailsEntry, {
            ...dto,
            createdBy: userId,
            updatedBy: userId,
        });
        return await entityManager.save(rfpDetailsEntry);
    }
    async createRfpTpaDetails(rfpDetailsEntryId, dto, userId, entityManager) {
        const tpaDetails = entityManager.create(entities_1.OpportunityRfpTpaDetail, {
            ...dto,
            opportunityRfpDetailsEntryId: rfpDetailsEntryId,
            createdBy: userId,
            updatedBy: userId,
        });
        return await entityManager.save(tpaDetails);
    }
    async createRfpInsurerDetails(rfpDetailsEntryId, dto, userId, entityManager) {
        const insurerDetails = entityManager.create(entities_1.OpportunityRfpInsurerDetail, {
            ...dto,
            opportunityRfpDetailsEntryId: rfpDetailsEntryId,
            createdBy: userId,
            updatedBy: userId,
        });
        return await entityManager.save(insurerDetails);
    }
    async createRfpClientContactDetails(rfpDetailsEntryId, dto, userId, entityManager) {
        const clientContactDetails = entityManager.create(entities_1.OpportunityRfpClientContactDetail, {
            ...dto,
            opportunityRfpDetailsEntryId: rfpDetailsEntryId,
            createdBy: userId,
            updatedBy: userId,
        });
        return await entityManager.save(clientContactDetails);
    }
    async createRfpClientContactInfluencers(clientContactId, influencerContactId, userId, entityManager) {
        const influencers = entityManager.create(entities_1.OpportunityRfpClientContactInfluencers, {
            clientContactId,
            influencerContactId,
            createdBy: userId,
            updatedBy: userId,
        });
        return await entityManager.save(influencers);
    }
    async createRfpCreditSharing(rfpDetailsEntryId, dto, userId, entityManager) {
        const creditSharing = entityManager.create(entities_1.OpportunityRfpCreditSharing, {
            ...dto,
            opportunityRfpDetailsEntryId: rfpDetailsEntryId,
            createdBy: userId,
            updatedBy: userId,
        });
        return await entityManager.save(creditSharing);
    }
    async createRfpDetailsEntryDocumentMap(rfpDetailsEntryId, dto, userId, entityManager) {
        const documentMap = entityManager.create(entities_1.OpportunityRfpDetailsEntryDocumentMap, {
            ...dto,
            opportunityRfpDetailsEntryId: rfpDetailsEntryId,
            createdBy: userId,
            updatedBy: userId,
        });
        return await entityManager.save(documentMap);
    }
    async getBrokingSlipVersionsByOpportunityId(opportunityId) {
        try {
            const brokingSlipVersions = await this.opportunityRepository.manager.find(entities_1.BrokingSlipVersionDetails, {
                where: { opportunityId },
            });
            if (!brokingSlipVersions || brokingSlipVersions.length == 0) {
                throw new common_1.NotFoundException("errorMessages.brokingSlipNotFound(opportunityId)");
            }
            let brokingSlipVersionDetailsResponse = brokingSlipVersions.map((brokingSlipVersion) => ({
                id: brokingSlipVersion.id,
                version: brokingSlipVersion.brokingSlipVersion,
                name: brokingSlipVersion.brokingSlipName,
            }));
            return brokingSlipVersionDetailsResponse;
        }
        catch (error) {
            console.log(error);
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getBrokingSlipByOpportunityId(opportunityId) {
        try {
            const brokingSlipVersions = await this.opportunityRepository.manager.find(entities_1.BrokingSlipVersionDetails, {
                where: { opportunityId },
                relations: [
                    "preferredInsurerDetails",
                    "preferredInsurerDetails.insurer",
                    "preferredInsurerDetails.contact",
                    "preferredTpaDetails",
                    "preferredTpaDetails.tpa",
                    "preferredTpaDetails.contact",
                    "opportunity",
                    "coverDetails",
                ],
            });
            if (!brokingSlipVersions) {
                throw new common_1.NotFoundException("errorMessages.brokingSlipNotFound(opportunityId)");
            }
            return brokingSlipVersions;
        }
        catch (error) {
            console.log(error);
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    //updated repository call for getting the data of the opportunity
    async getBrokingSlipDetailsByOpportunityId(opportunityId) {
        let brokingSlipVersionDetails;
        try {
            const brokingSlipVersions = await this.opportunityRepository.manager.findOne(entities_1.BrokingSlipVersionDetails, {
                where: { opportunityId: opportunityId },
            });
            if (!brokingSlipVersions) {
                brokingSlipVersionDetails = {
                    defaultCovers: {},
                    formData: {
                        documents: [],
                        others: {
                            clauses: "",
                            insurerRemarks: "",
                            remarks: "",
                            riskMitigationFeatures: "",
                        },
                        preferredInsurerDetails: [],
                        preferredTPADetails: [],
                    },
                };
            }
            else {
                brokingSlipVersionDetails = {
                    defaultCovers: {},
                    formData: {
                        documents: [],
                        others: {
                            clauses: brokingSlipVersions.clauses,
                            insurerRemarks: brokingSlipVersions.insurerRemarks,
                            remarks: brokingSlipVersions.remarks,
                            riskMitigationFeatures: brokingSlipVersions.riskMitigationFeatures,
                        },
                        preferredInsurerDetails: brokingSlipVersions.preferredInsurerDetails?.map((x) => ({
                            branchId: x.branchId,
                            contactId: x.contactId,
                            id: x.id,
                            insurerId: x.insurerId,
                            locationId: x.locationId,
                        })) ?? [],
                        preferredTPADetails: brokingSlipVersions.preferredTpaDetails?.map((x) => ({
                            branchId: x.branchId,
                            contactId: x.contactId,
                            id: x.id,
                            tpaId: x.tpaId,
                            locationId: x.locationId,
                        })) ?? [],
                    },
                };
            }
            // updating the preferred Insurer details
            const insurerDetails = await this.opportunityRepository.manager.find(entities_1.PreferredInsurerDetails, {
                where: { opportunityId: opportunityId },
            });
            if (insurerDetails && insurerDetails.length) {
                brokingSlipVersionDetails.formData.preferredInsurerDetails =
                    insurerDetails.map((x) => ({
                        branchId: x.branchId,
                        contactId: x.contactId,
                        insurerId: x.insurerId,
                        locationId: x.locationId,
                    }));
            }
            //updating preferrred tpa details
            const tpaDetails = await this.opportunityRepository.manager.find(entities_1.PreferredTpaDetails, {
                where: { opportunityId: opportunityId },
            });
            if (tpaDetails && tpaDetails.length) {
                brokingSlipVersionDetails.formData.preferredTPADetails =
                    tpaDetails.map((x) => ({
                        branchId: x.branchId,
                        contactId: x.contactId,
                        tpaId: x.tpaId,
                        locationId: x.locationId,
                    }));
            }
            //updating document details
            const documentDetails = await this.opportunityRepository.manager.find(entities_1.OpportunityBrokingSlipActivityDocumentMap, {
                where: { opportunityId: opportunityId },
            });
            if (documentDetails && documentDetails.length) {
                brokingSlipVersionDetails.formData.documents = documentDetails.map((x) => ({
                    documentId: x.documentId,
                    documentTypeLid: x.documentTypeLid,
                }));
            }
            // Update the covers details here;
            const coversDetails = await this.opportunityRepository.manager.find(entities_1.BrokingSlipVersionCoverDetails, {
                where: { opportunityId: opportunityId },
            });
            if (coversDetails.length) {
                brokingSlipVersionDetails.defaultCovers = coversDetails.reduce((acc, coverDetails) => {
                    if (coverDetails.coverMapId && coverDetails.coverResponse) {
                        acc[coverDetails.coverMapId] = coverDetails.coverResponse;
                    }
                    return acc;
                }, {});
            }
            else {
                const CoversDetails = await this.getCoverDetailsForBrokingSlip(opportunityId);
                brokingSlipVersionDetails.defaultCovers = CoversDetails?.reduce((acc, coverDetails) => {
                    if (coverDetails.coverMapId && coverDetails.coverResponse) {
                        acc[coverDetails.coverMapId] = coverDetails.coverResponse;
                    }
                    return acc;
                }, {});
            }
            return brokingSlipVersionDetails;
        }
        catch (error) {
            console.log(error);
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getCoverDetailsForBrokingSlip(opportunityId) {
        try {
            const rfpCoverDetails = await this.rfpCoverDetailRepository.find({
                where: { opportunityId },
            });
            if (rfpCoverDetails.length) {
                return rfpCoverDetails.map((x) => ({
                    brokingSlipVersionId: 0,
                    coverMapId: x.coverMapId,
                    coverName: x.coverName,
                    coverResponse: x.coverResponse,
                    opportunityId: opportunityId,
                    policyTypeId: x.policyTypeId,
                    id: 0,
                }));
            }
            else {
                const covers = await this.opportunityRepository.manager.find(entities_1.OpportunityCoverMap, {
                    where: { opportunityId },
                });
                if (covers.length) {
                    return covers.map((x) => ({
                        brokingSlipVersionId: 0,
                        coverMapId: x.id,
                        coverName: x.coverName ?? "",
                        coverResponse: x.coverDescription ?? "",
                        opportunityId: opportunityId,
                        policyTypeId: x.policyTypeId,
                        id: 0,
                    }));
                }
                else {
                    return null;
                }
            }
        }
        catch (error) {
            console.log(error);
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getBrokingSlipByVersionId(versionId, opportunityId) {
        try {
            const brokingSlipVersions = await this.opportunityRepository.manager.findOne(entities_1.BrokingSlipVersionDetails, {
                where: { opportunityId, id: versionId },
                relations: [
                    "preferredInsurerDetails",
                    "preferredInsurerDetails.insurer",
                    "preferredInsurerDetails.contact",
                    "preferredTpaDetails",
                    "preferredTpaDetails.tpa",
                    "preferredTpaDetails.contact",
                    "opportunity",
                    "coverDetails",
                ],
            });
            if (!brokingSlipVersions) {
                throw new common_1.NotFoundException("errorMessages.brokingSlipNotFound(opportunityId)");
            }
            let coversDetails = {};
            if (brokingSlipVersions.coverDetails) {
                coversDetails = brokingSlipVersions.coverDetails.reduce((acc, coverDetails) => {
                    if (coverDetails.coverMapId && coverDetails.coverResponse) {
                        acc[coverDetails.coverMapId] = coverDetails.coverResponse;
                    }
                    return acc;
                }, {});
            }
            const brokingSlipVersionDetails = {
                versionName: brokingSlipVersions.brokingSlipName,
                formData: {
                    versionDetails: {
                        brokeragePercentage: brokingSlipVersions.brokeragePercentage.toString(),
                        businessActivity: brokingSlipVersions.businessActivity,
                        policyFrom: brokingSlipVersions.policyFrom.toString(),
                        policyTo: brokingSlipVersions.policyTo.toString(),
                        quoteReceiptTimeline: brokingSlipVersions.quoteReceiptTimeline.toString(),
                        renewalDate: brokingSlipVersions.renewalDate.toString(),
                        sumInsured: parseInt(brokingSlipVersions.sumInsured.toString()),
                    },
                    coversConfig: coversDetails,
                },
            };
            if (brokingSlipVersionDetails) {
                (0, response_utils_1.removeMetadataFields)(brokingSlipVersionDetails);
                (0, response_utils_1.removeLookUpDataFields)(brokingSlipVersionDetails);
            }
            return brokingSlipVersionDetails;
        }
        catch (error) {
            console.log(error);
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getOpportunityActivityStatus(opportunityActivityId) {
        try {
            return await this.opportunityRepository.manager.transaction(async (transactionalEntityManager) => {
                const opportunityActivityDetails = await transactionalEntityManager.findOne(entities_1.OpportunityActivityMap, {
                    where: { id: opportunityActivityId },
                });
                if (!opportunityActivityDetails) {
                    throw new common_1.NotFoundException("Opportunity activity Id not found");
                }
                const opportunityStatus = await transactionalEntityManager.findOne(entities_1.LookUp, {
                    where: { lookUpKey: constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED },
                });
                return opportunityActivityDetails.statusLid === opportunityStatus?.id;
            });
        }
        catch (error) {
            console.log(error);
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async updateOpportunityActivityStatus(opportunityActivityId, statusLid) {
        try {
            await this.opportunityRepository.manager.transaction(async (transactionalEntityManager) => {
                try {
                    const opportunityActivityDetails = await transactionalEntityManager.findOne(entities_1.OpportunityActivityMap, {
                        where: { id: opportunityActivityId },
                    });
                    if (!opportunityActivityDetails) {
                        throw new common_1.NotFoundException("Opportunity activity Id not found");
                    }
                    else {
                        await transactionalEntityManager.update(entities_1.OpportunityActivityMap, { id: opportunityActivityId }, { ...opportunityActivityDetails, statusLid: statusLid });
                    }
                }
                catch (error) {
                    console.error("Error in generateBrokingSlipVersion transaction:", error);
                    throw new common_1.BadRequestException(`Failed to update opportunity activity details: ${error?.message}`);
                }
            });
        }
        catch (error) {
            console.log(error);
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    // This function updates the activity status of an opportunity activity.
    async updateActivityStatus(opportunityActivityId, opportunityTable, currentActivityStatusLid, entityManager) {
        try {
            const updateActivityStatus = async (manager) => {
                const currentActivityStatus = await manager.findOne(entities_1.LookUp, {
                    where: { id: currentActivityStatusLid },
                });
                if (currentActivityStatus?.lookUpKey !==
                    constants_2.OPPORTUNITY_ACTIVITY_STATUS.WORK_IN_PROGRESS) {
                    const opportunity = await manager.findOne(entities_1.OpportunityActivityMap, {
                        where: { id: opportunityActivityId },
                        select: ["opportunityId"],
                    });
                    const opportunityActivityDetails = await manager.findOne(entities_1.OpportunityActivityMap, {
                        where: {
                            opportunityId: opportunity?.opportunityId,
                            opportunityTable,
                        },
                    });
                    if (!opportunityActivityDetails) {
                        throw new common_1.NotFoundException(`Opportunity activity not found for opportunity with id: ${opportunity?.opportunityId}`);
                    }
                    else {
                        const status = await manager.findOne(entities_1.LookUp, {
                            where: {
                                lookUpKey: constants_2.OPPORTUNITY_ACTIVITY_STATUS.WORK_IN_PROGRESS,
                            },
                        });
                        if (!status) {
                            throw new common_1.NotFoundException("Opportunity activity status not found");
                        }
                        await manager.update(entities_1.OpportunityActivityMap, { id: opportunityActivityDetails.id }, { statusLid: status.id });
                    }
                }
            };
            if (entityManager) {
                return await updateActivityStatus(entityManager); // Use the provided transaction
            }
            else {
                return await this.opportunityRepository.manager.transaction(updateActivityStatus); // Start a new transaction
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    async generateBrokingSlipVersion(brokingSlipData, createdBy, opportunityId) {
        try {
            return await this.opportunityRepository.manager.transaction(async (transactionalEntityManager) => {
                try {
                    const opportunity = await transactionalEntityManager.findOne(entities_1.Opportunity, { where: { opportunityId } });
                    if (!opportunity) {
                        throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotPresent(opportunityId));
                    }
                    const latestSlipVersion = await transactionalEntityManager.find(entities_1.BrokingSlipVersionDetails, {
                        where: { opportunityId },
                        order: { brokingSlipVersion: "DESC" },
                    });
                    const maxId = (latestSlipVersion[0]?.brokingSlipVersion ?? 0) + 1;
                    const brokingSlipDTO = transactionalEntityManager.create(entities_1.BrokingSlipVersionDetails, {
                        brokeragePercentage: parseFloat(brokingSlipData.formData.versionDetails.brokeragePercentage),
                        brokingSlipName: brokingSlipData.versionName,
                        brokingSlipVersion: maxId,
                        businessActivity: brokingSlipData.formData.versionDetails.businessActivity,
                        sumInsured: brokingSlipData.formData.versionDetails.sumInsured,
                        renewalDate: brokingSlipData.formData.versionDetails.renewalDate,
                        quoteReceiptTimeline: brokingSlipData.formData.versionDetails.quoteReceiptTimeline,
                        policyFrom: brokingSlipData.formData.versionDetails.policyFrom,
                        policyTo: brokingSlipData.formData.versionDetails.policyTo,
                        riskMitigationFeatures: "",
                        insurerRemarks: "",
                        remarks: "",
                        clauses: "",
                        opportunityId: opportunityId,
                        createdBy: createdBy,
                        updatedBy: createdBy,
                    });
                    const brokingSlip = await transactionalEntityManager.save(entities_1.BrokingSlipVersionDetails, brokingSlipDTO);
                    const brokingSlipId = brokingSlip.id;
                    const coverDetails = await this.opportunityRepository.manager.find(entities_1.OpportunityCoverMap, {
                        where: {
                            id: (0, typeorm_2.In)(Object.keys(brokingSlipData.formData.coversConfig)),
                        },
                    });
                    const coversDetailsDto = coverDetails.map((coverDetail) => {
                        return transactionalEntityManager.create(entities_1.BrokingSlipVersionCoverDetails, {
                            opportunityId: opportunityId,
                            coverMapId: coverDetail.id,
                            coverName: coverDetail.coverName,
                            coverResponse: brokingSlipData.formData.coversConfig[coverDetail.id],
                            createdAt: new Date(),
                            createdBy: createdBy,
                            updatedBy: createdBy,
                            updatedAt: new Date(),
                            policyTypeId: coverDetail.policyTypeId,
                            brokingSlipVersionId: brokingSlipId,
                        });
                    });
                    await transactionalEntityManager.save(entities_1.BrokingSlipVersionCoverDetails, coversDetailsDto);
                    return brokingSlipId;
                }
                catch (error) {
                    console.error("Error in generate BrokingSlip Version transaction:", error);
                    throw new common_1.BadRequestException(`Failed to generate broking slip: ${error?.message}`);
                }
            });
        }
        catch (error) {
            // If transaction fails, return null to satisfy the return type
            return null;
        }
    }
    async getPremiumCalculationByOpportunityActivityId(opportunityActivityId) {
        try {
            const premiumCalculation = await this.opportunityRepository.manager.findOne(entities_1.OpportunityPremiumCalculation, {
                where: { opportunityActivityId },
            });
            if (!premiumCalculation)
                return null;
            if (premiumCalculation) {
                (0, response_utils_1.removeMetadataFields)(premiumCalculation);
                (0, response_utils_1.removeLookUpDataFields)(premiumCalculation);
            }
            return premiumCalculation;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getOpportunityQuoteActivityById(manager, opportunityActivityId) {
        return manager.findOne(entities_1.OpportunityActivityMap, {
            where: { id: opportunityActivityId },
        });
    }
    async getOpportunityQuoteCovers(manager, opportunityId) {
        return manager.find(entities_1.OpportunityCoverMap, {
            where: { opportunityId },
        });
    }
    async getOpportunityQuoteCoverByIds(manager, coverIds) {
        return manager.find(entities_1.OpportunityCoverMap, {
            where: { id: (0, typeorm_2.In)(coverIds) },
        });
    }
    prepareQuoteCoverDetails(covers, coverMaps, opportunityId, createdBy) {
        return covers.map((cover) => {
            const coverMap = coverMaps.find((map) => map.id === cover.id);
            if (!coverMap) {
                throw new common_1.NotFoundException(`Cover with ID ${cover.id} not found in Opportunity Cover Map.`);
            }
            return {
                opportunityId,
                quoteId: cover.quoteId,
                coverMapId: coverMap.id,
                policyTypeId: coverMap.policyTypeId,
                coverName: coverMap.coverName,
                insurerCoverResponse: cover.response,
                createdBy,
                updatedBy: createdBy,
            };
        });
    }
    async saveQuoteCoverDetails(manager, quoteCoverDetails) {
        await manager.save(entities_1.OpportunityQuoteCoverDetail, quoteCoverDetails);
    }
    async deleteQuoteCoverDetails(quoteId, manager) {
        await manager.delete(entities_1.OpportunityQuoteCoverDetail, { quoteId });
    }
    prepareQuoteTaxDetails(taxDetails, quoteEntryId, createdBy) {
        return taxDetails.map((tax) => {
            return this.quoteTaxRepo.create({
                opportunityQuoteEntryId: quoteEntryId,
                taxLid: tax.tax,
                taxValue: tax.taxValue,
                createdBy,
                updatedBy: createdBy,
            });
        });
    }
    async saveQuoteTaxDetails(manager, taxRecords) {
        await manager.save(entities_1.OpportunityQuoteTaxMap, taxRecords);
    }
    async deleteQuoteTaxDetails(quoteEntryId, manager) {
        await manager.delete(entities_1.OpportunityQuoteTaxMap, {
            opportunityQuoteEntryId: quoteEntryId,
        });
    }
    async updatePolicyConfirmationActivity(entityManager, heldCoverNoteId, updateData, userId) {
        try {
            const fieldsToUpdate = {
                ...updateData,
                updatedBy: userId,
                updatedAt: new Date(),
            };
            // Perform the update
            await entityManager.update(entities_1.OpportunityPolicyConfirmation, { id: heldCoverNoteId }, fieldsToUpdate);
            return fieldsToUpdate;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to update policy confirmation note: ${error.message}`);
        }
    }
    async updatePolicyHardCopyActivity(entityManager, heldCoverNoteId, updateData, userId) {
        try {
            const fieldsToUpdate = {
                ...updateData,
                updatedBy: userId,
                updatedAt: new Date(),
            };
            // Perform the update
            await entityManager.update(entities_1.OpportunityPolicyHardCopy, { id: heldCoverNoteId }, fieldsToUpdate);
            return fieldsToUpdate;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to update policy hard copy: ${error.message}`);
        }
    }
    async createHandOveMeet(entityManager, meetingData) {
        try {
            const existingMeeting = await entityManager.findOne(entities_1.OpportunityHandOverMeet, {
                where: {
                    opportunityActivityId: meetingData.opportunityActivityId,
                },
            });
            if (existingMeeting) {
                throw new common_1.BadRequestException(`Hand Over Meeting record already exists for Opportunity ID: ${meetingData.opportunityId} and Activity ID: ${meetingData.activityId}`);
            }
            const meeting = entityManager.create(entities_1.OpportunityHandOverMeet, meetingData);
            return await entityManager.save(entities_1.OpportunityHandOverMeet, meeting);
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException)
                throw error;
            throw new Error(`Failed to create Hand Over meeting: ${error.message}`);
        }
    }
    async checkActivityExists(opportunityActivityId) {
        try {
            const existingActivity = await this.opportunityRfpDetailsEntryRepository.findOne({
                where: { opportunityActivityId },
            });
            return existingActivity;
        }
        catch (error) {
            console.error("Error checking activity existence:", error);
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : "Failed to check activity existence.");
        }
    }
    async getQuotesBasedOnOpportunityActivityId(opportunityId, page, limit) {
        try {
            const { data, count } = await this.entityService.fetchEntityList(entities_1.OpportunityQuoteEntry, page, limit, undefined, undefined, { opportunityId } // Filter by opportunityId
            );
            if (!data || data.length === 0) {
                return { data: [], count: 0 };
            }
            return data;
        }
        catch (error) {
            console.error("Error fetching quotes:", error);
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : "Failed to fetch quotes based on opportunity activity ID.");
        }
    }
    async getQuoteById(quoteId) {
        try {
            const quote = await this.quoteRepo.findOne({
                where: { id: quoteId },
                relations: ["taxMappings", "documentMappings", "coverDetails"],
            });
            if (!quote) {
                throw new common_1.NotFoundException(`Quote with ID ${quoteId} not found.`);
            }
            const covers = {};
            if (Array.isArray(quote.coverDetails)) {
                quote.coverDetails?.forEach((cover) => {
                    if (cover.coverMapId !== undefined &&
                        cover.insurerCoverResponse !== undefined) {
                        covers[cover.coverMapId] = cover.insurerCoverResponse;
                    }
                });
            }
            const data = {
                selectFinalisedQuote: {
                    finalizedQuoteId: quote.id,
                    isQuoteEdited: null,
                    insurerId: quote.insurerId,
                    quoteReceivedOn: quote.quoteReceivedOn,
                    basicPremium: Number(quote.basicPremium),
                    terrorism: Number(quote.terrorismCover),
                },
                quoteTaxDetails: quote.taxMappings?.map((tax) => ({
                    tax: tax.taxLid,
                    taxValue: Number(tax.taxValue),
                })),
                netPremiumDetails: {
                    netPremium: Number(quote.netPremium),
                    brokeragePercentage: Number(quote.brokeragePercent),
                    insurerRemarks: quote.insurerRemarks,
                },
                quoteDocuments: quote.documentMappings?.map((doc) => ({
                    documentId: doc.documentId,
                })),
                covers: covers,
            };
            return data;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to fetch quote by ID.");
        }
    }
    async createFinalNegotiationActivity(manager, data) {
        try {
            const existingFinalNeg = await manager.findOne(entities_1.OpportunityFinalNegotiation, {
                where: {
                    opportunityId: data.opportunityId,
                    activityId: data.activityId,
                },
            });
            if (existingFinalNeg) {
                throw new common_1.BadRequestException(`Final Negotiation details already exist for Opportunity ID: ${data.opportunityId}, Activity ID: ${data.activityId}`);
            }
            const record = manager.create(entities_1.OpportunityFinalNegotiation, data);
            return await manager.save(entities_1.OpportunityFinalNegotiation, record);
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException ||
                error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.BadRequestException(`Failed to create final negotiation activity: ${error.message}`);
        }
    }
    async getRfpDetailsEntryByOpportunityActivityId(opportunityActivityId) {
        try {
            const rfpDetailsEntry = await this.opportunityRfpDetailsEntryRepository.findOne({
                where: { opportunityActivityId },
                relations: [
                    "tpaDetails",
                    "insurerDetails",
                    "clientContacts",
                    "clientContacts.clientContactInfluencers", // Include influencers relation
                    "creditSharing",
                    "documents",
                ],
            });
            if (!rfpDetailsEntry) {
                throw new common_1.NotFoundException(`RFP Details Entry not found for ID: ${opportunityActivityId}`);
            }
            return rfpDetailsEntry;
        }
        catch (error) {
            console.error("Query error:", error);
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : "Failed to fetch RFP details entry.");
        }
    }
    async saveFinalNegotiationSharingDetails(manager, finalNegotiationId, details) {
        try {
            // Fetch existing sharing details for this negotiation
            const existingDetails = await manager.find(entities_1.OpportunityFinalNegotiationSharingDetail, {
                where: { opportunityFinalNegotiationId: finalNegotiationId },
            });
            const existingInsurerIds = existingDetails?.map((d) => d.insurerId);
            const incomingInsurerIds = details?.map((d) => d.insurerId);
            // Determine which to add
            const detailsToAdd = details?.filter((d) => !existingInsurerIds.includes(d.insurerId));
            // Determine which to remove
            const detailsToRemove = existingDetails?.filter((d) => !incomingInsurerIds.includes(d.insurerId));
            // Add new sharing details
            if (detailsToAdd.length > 0) {
                const recordsToAdd = detailsToAdd?.map((details) => manager.create(entities_1.OpportunityFinalNegotiationSharingDetail, {
                    ...details,
                    opportunityFinalNegotiationId: finalNegotiationId,
                }));
                await manager.save(entities_1.OpportunityFinalNegotiationSharingDetail, recordsToAdd);
            }
            // Remove obsolete sharing details
            if (detailsToRemove.length > 0) {
                const idsToRemove = detailsToRemove?.map((d) => d.id);
                await manager.delete(entities_1.OpportunityFinalNegotiationSharingDetail, {
                    id: (0, typeorm_2.In)(idsToRemove),
                });
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(`Failed to save final negotiation sharing details: ${error.message}`);
        }
    }
    async saveFinalNegotiationVariations(manager, finalNegotiationId, variations) {
        try {
            // Fetch existing variations for this negotiation
            const existingVariationsDetails = await manager.find(entities_1.OpportunityFinalNegotiationQcrVariation, { where: { opportunityFinalNegotiationId: finalNegotiationId } });
            const existingIssueIds = existingVariationsDetails?.map((v) => v.issue);
            const incomingIssueIds = variations?.map((v) => v.issue);
            // Determine which to add
            const variationsToAdd = variations?.filter((v) => !existingIssueIds.includes(v.issue));
            // Determine which to remove
            const variationsToRemove = existingVariationsDetails?.filter((v) => !incomingIssueIds.includes(v.issue));
            // Add new variations
            if (variationsToAdd.length > 0) {
                const recordsToAdd = variationsToAdd?.map((variation) => manager.create(entities_1.OpportunityFinalNegotiationQcrVariation, {
                    opportunityFinalNegotiationId: finalNegotiationId,
                    ...variation,
                }));
                await manager.save(entities_1.OpportunityFinalNegotiationQcrVariation, recordsToAdd);
            }
            // Remove obsolete variations
            if (variationsToRemove.length > 0) {
                const idsToRemove = variationsToRemove?.map((v) => v.id);
                await manager.delete(entities_1.OpportunityFinalNegotiationQcrVariation, {
                    id: (0, typeorm_2.In)(idsToRemove),
                });
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(`Failed to save final negotiation variations: ${error.message}`);
        }
    }
    async saveFinalNegotiationSla(manager, finalNegotiationId, sla) {
        try {
            // Fetch existing SLA records for this negotiation
            const existingSlaRecords = await manager.find(entities_1.OpportunityFinalNegotiationServiceLevelAgreement, { where: { opportunityFinalNegotiationId: finalNegotiationId } });
            const existingSlaKeys = existingSlaRecords?.map((s) => s.serviceTypeId);
            const incomingSlaKeys = sla?.map((s) => s.serviceTypeId);
            // Determine which to add
            const slaToAdd = sla?.filter((s) => !existingSlaKeys.includes(s.serviceTypeId));
            // Determine which to remove
            const slaToRemove = existingSlaRecords?.filter((s) => !incomingSlaKeys.includes(s.serviceTypeId));
            // Add new SLA records
            if (slaToAdd.length > 0) {
                const recordsToAdd = slaToAdd?.map((sla) => manager.create(entities_1.OpportunityFinalNegotiationServiceLevelAgreement, {
                    opportunityFinalNegotiationId: finalNegotiationId,
                    ...sla,
                }));
                await manager.save(entities_1.OpportunityFinalNegotiationServiceLevelAgreement, recordsToAdd);
            }
            // Remove obsolete SLA records
            if (slaToRemove.length > 0) {
                const idsToRemove = slaToRemove?.map((s) => s.id);
                await manager.delete(entities_1.OpportunityFinalNegotiationServiceLevelAgreement, {
                    id: (0, typeorm_2.In)(idsToRemove),
                });
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(`Failed to save final negotiation SLA details: ${error.message}`);
        }
    }
    async saveFinalNegotiationQuoteTax(manager, finalNegotiationId, taxDetails) {
        try {
            // Fetch existing tax records for this negotiation
            const existingTaxRecords = await manager.find(entities_1.OpportunityFinalNegotiationTaxMap, { where: { opportunityFinalNegotiationId: finalNegotiationId } });
            const existingTaxIds = existingTaxRecords?.map((t) => t.tax);
            const incomingTaxIds = taxDetails?.map((t) => t.tax);
            // Determine which to add
            const taxToAdd = taxDetails?.filter((t) => !existingTaxIds.includes(t.tax));
            // Determine which to remove
            const taxToRemove = existingTaxRecords?.filter((t) => !incomingTaxIds.includes(t.tax));
            // Add new tax records
            if (taxToAdd.length > 0) {
                const recordsToAdd = taxToAdd?.map((tax) => manager.create(entities_1.OpportunityFinalNegotiationTaxMap, {
                    opportunityFinalNegotiationId: finalNegotiationId,
                    ...tax,
                }));
                await manager.save(entities_1.OpportunityFinalNegotiationTaxMap, recordsToAdd);
            }
            // Remove obsolete tax records
            if (taxToRemove.length > 0) {
                const idsToRemove = taxToRemove?.map((t) => t.id);
                await manager.delete(entities_1.OpportunityFinalNegotiationTaxMap, {
                    id: (0, typeorm_2.In)(idsToRemove),
                });
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(`Failed to save final negotiation quote tax details: ${error.message}`);
        }
    }
    async saveFinalNegotiationCovers(manager, finalNegotiationId, quoteId, opportunityId, covers) {
        try {
            //OpportunityFinalNegotiationQuoteCoverDetail
            const existingCovers = await manager.find(entities_1.OpportunityFinalNegotiationQuoteCoverDetail, {
                where: { opportunityFinalNegotiationId: finalNegotiationId },
            });
            const existingCoverIds = existingCovers?.map((c) => c.coverMapId);
            const incomingCoverIds = Object.keys(covers).map(Number);
            // Determine which to add
            const coversToAdd = incomingCoverIds.filter((id) => !existingCoverIds.includes(id));
            // Determine which to remove
            const coversToRemove = existingCovers?.filter((c) => !incomingCoverIds.includes(c.coverMapId));
            // Add new covers
            if (coversToAdd.length > 0) {
                const recordsToAdd = coversToAdd.map((coverId) => manager.create(entities_1.OpportunityFinalNegotiationQuoteCoverDetail, {
                    opportunityFinalNegotiationId: finalNegotiationId,
                    opportunityId,
                    coverMapId: coverId,
                    insurerCoverResponse: covers[coverId],
                    quoteId: quoteId,
                }));
                await manager.save(entities_1.OpportunityFinalNegotiationQuoteCoverDetail, recordsToAdd);
            }
            // Remove obsolete covers
            if (coversToRemove.length > 0) {
                const idsToRemove = coversToRemove?.map((c) => c.id);
                await manager.delete(entities_1.OpportunityFinalNegotiationQuoteCoverDetail, {
                    id: (0, typeorm_2.In)(idsToRemove),
                });
            }
            // update which are in both
            const coversToUpdate = existingCovers?.filter((c) => incomingCoverIds.includes(c.coverMapId));
            if (coversToUpdate.length > 0) {
                // Update existing covers with new insurerCoverResponse based on coverMapId
                for (const cover of coversToUpdate) {
                    const updatedCover = {
                        ...cover,
                        insurerCoverResponse: covers[cover.coverMapId],
                        opportunityId,
                    };
                    await manager.update(entities_1.OpportunityFinalNegotiationQuoteCoverDetail, { id: cover.id }, updatedCover);
                }
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(`Failed to save final negotiation covers: ${error.message}`);
        }
    }
    async saveFinalNegotiationQuoteDocuments(manager, finalNegotiationId, documents) {
        try {
            // Fetch existing documents for this negotiation
            const existingDocuments = await manager.find(entities_1.OpportunityFinalNegotiationQuoteDocuments, { where: { opportunityFinalNegotiationId: finalNegotiationId } });
            const existingDocIds = existingDocuments?.map((d) => d.documentId);
            const incomingDocIds = documents?.map((d) => d.documentId);
            // Determine which to add
            const documentsToAdd = documents?.filter((d) => !existingDocIds.includes(d.documentId));
            // Determine which to remove
            const documentsToRemove = existingDocuments?.filter((d) => !incomingDocIds.includes(d.documentId));
            // Add new documents
            if (documentsToAdd.length > 0) {
                const recordsToAdd = documentsToAdd?.map((doc) => manager.create(entities_1.OpportunityFinalNegotiationQuoteDocuments, {
                    opportunityFinalNegotiationId: finalNegotiationId,
                    ...doc,
                }));
                await manager.save(entities_1.OpportunityFinalNegotiationQuoteDocuments, recordsToAdd);
            }
            // Remove obsolete documents
            if (documentsToRemove.length > 0) {
                const idsToRemove = documentsToRemove?.map((d) => d.id);
                await manager.delete(entities_1.OpportunityFinalNegotiationQuoteDocuments, {
                    id: (0, typeorm_2.In)(idsToRemove),
                });
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(`Failed to save final negotiation quote documents: ${error.message}`);
        }
    }
    // Updates the main Final Negotiation Step record
    async updateFinalNegotiationActivity(manager, opportunityActivityId, data) {
        try {
            await manager.update(entities_1.OpportunityFinalNegotiation, { opportunityActivityId: opportunityActivityId }, data);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException) {
                throw error;
            }
            throw new common_1.BadRequestException(`Failed to update final negotiation activity: ${error.message}`);
        }
    }
    async getFinalNegotiationActivity(opportunityActivityId) {
        const finalNegMeet = await this.opportunityRepository.manager.findOne(entities_1.OpportunityFinalNegotiation, {
            where: { opportunityActivityId },
            relations: [
                "sharingDetails",
                "qcrVariations",
                "slaDetails",
                "meeting",
                "meeting.meetingDocs",
                "meeting.participants",
                "taxDetails",
                "quoteDocs",
                "quoteCovers",
            ],
        });
        if (!finalNegMeet) {
            throw new common_1.NotFoundException(`Final Negotiation activity not found for Opportunity Activity ID: ${opportunityActivityId}`);
        }
        const participants = finalNegMeet.meeting.participants;
        const tpaParticipants = participants
            ?.filter((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.TPA_CONTACT)
            .map((p) => p.participantId);
        const insurerParticipants = participants
            ?.filter((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.INSURER_CONTACT)
            .map((p) => p.participantId);
        const companyParticipants = participants
            ?.filter((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.COMPANY_CONTACT)
            .map((p) => p.participantId);
        const employeeParticipants = participants
            ?.filter((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.EMPLOYEE)
            .map((p) => p.participantId);
        // Remove 'id' and 'opportunityFinalNegotiationId' from objects in arrays
        const cleanArray = (arr) => Array.isArray(arr)
            ? arr.map(({ id, opportunityFinalNegotiationId, ...rest }) => rest)
            : [];
        const covers = {};
        if (Array.isArray(finalNegMeet.quoteCovers)) {
            finalNegMeet.quoteCovers?.forEach((cover) => {
                if (cover.coverMapId !== undefined &&
                    cover.insurerCoverResponse !== undefined) {
                    covers[cover.coverMapId] = cover.insurerCoverResponse;
                }
            });
        }
        return {
            id: finalNegMeet.id,
            opportunityActivityId: finalNegMeet.opportunityActivityId,
            statusLid: finalNegMeet.statusLid,
            dataActivity: {
                meetingDetails: {
                    isFinalNegotiationTypeLid: finalNegMeet.isFinalNegotiationTypeLid,
                    selectMeeting: finalNegMeet.selectMeeting,
                    meetingTypeLid: finalNegMeet.meeting.meetingTypeLid,
                    meetingDate: finalNegMeet.meeting.meetingDate,
                    availableFrom: finalNegMeet.meeting.startTime,
                    availableTo: finalNegMeet.meeting.endTime,
                    locationTypeLid: finalNegMeet.meeting.locationTypeLid,
                },
                policyDetails: {
                    policyPlacedTypeLid: finalNegMeet.policyPlacedTypeLid,
                    leadInsurerId: finalNegMeet.leadInsurerId,
                    isLeadInsurerPayCommissionLid: finalNegMeet.isLeadInsurerPayCommissionLid,
                },
                selectFinalisedQuote: {
                    finalizedVersionId: finalNegMeet.finalizedVersionId,
                    finalizedQuoteId: finalNegMeet.finalizedQuoteId,
                    insurerId: finalNegMeet.insurerId,
                    isQuoteEdited: finalNegMeet.isQuoteEdited,
                    quoteReceivedOn: finalNegMeet.quoteReceivedOn,
                    basicPremium: finalNegMeet.basicPremium,
                    terrorism: finalNegMeet.terrorism,
                },
                netPremiumDetails: {
                    netPremium: finalNegMeet.netPremium,
                    brokeragePercentage: finalNegMeet.brokeragePercentage,
                    insurerRemarks: finalNegMeet.insurerRemarks,
                },
                covers: covers,
                quoteDocuments: cleanArray(finalNegMeet.quoteDocs ?? []),
                participants: {
                    companyContactPerson: companyParticipants.length > 0 ? companyParticipants : [],
                    employees: employeeParticipants.length > 0 ? employeeParticipants : [],
                },
                tpaParticipants: tpaParticipants.length > 0
                    ? {
                        tpaId: participants.find((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.TPA_CONTACT)?.participantCompanyId,
                        tpaContactPerson: tpaParticipants,
                    }
                    : {},
                insurerParticipants: insurerParticipants.length > 0
                    ? {
                        insurerId: participants.find((p) => p.participantRecordType === constants_1.PARTICIPANT_TYPE.INSURER_CONTACT)?.participantCompanyId,
                        insurerContactPerson: insurerParticipants,
                    }
                    : {},
                quoteTaxDetails: cleanArray(finalNegMeet.taxDetails),
                insurerAndBrokeragePercentage: cleanArray(finalNegMeet.sharingDetails),
                variationIssuesFromQCR: cleanArray(finalNegMeet.qcrVariations),
                otherCommentsFromInsurer: {
                    remarks: finalNegMeet.otherInsurerComments,
                },
                remarks: { remarks: finalNegMeet.remarks },
                meetingSummary: { mom: finalNegMeet.mom },
                insurerServiceLevelAgreement: cleanArray(finalNegMeet.slaDetails),
                documents: cleanArray(finalNegMeet.meeting.meetingDocs ?? []),
            },
        };
    }
    async getOpportunityByCompanyId(companyId, page, limit) {
        try {
            if (!companyId) {
                throw new common_1.BadRequestException("Company ID is required.");
            }
            const { data, count } = await this.entityService.fetchEntityList("Opportunity", // Entity name
            page, limit, undefined, // Sort options
            ["policyType"], { companyId }, // Filter by companyId
            undefined, // Select fields
            undefined, // Search array
            undefined, // Search string
            undefined, // Search on fields
            undefined, // Date filter
            undefined, // Period filter
            undefined // Additional conditions
            );
            if (!data || data.length === 0) {
                throw new common_1.NotFoundException(`No opportunities found for company ID: ${companyId}`);
            }
            return { data, count };
        }
        catch (error) {
            throw new Error(`Failed to fetch opportunities for company ID: ${companyId}. ${error.message}`);
        }
    }
    async getPremiumCalculationCovers(opportunityId, policyTypeId, coverTypeLid) {
        return await this.opportunityRepository.manager.find(entities_1.OpportunityCoverMap, {
            where: { opportunityId, policyTypeId, coverTypeLid },
        });
    }
    async getPolicyDetailsByOpportunityId(opportunityId) {
        try {
            const opportunityData = await this.opportunityRepository.findOne({
                where: { opportunityId },
                relations: ["policyType"],
            });
            return opportunityData;
        }
        catch (error) {
            throw new Error(`Failed to fetch opportunity data for id: ${opportunityId}. ${error?.message}`);
        }
    }
    async savePremiumCalculationDetails(opportunityId, activityId, opportunityActivityId, premiumCalculationDetails, remarks, documents, createdBy, statusLid) {
        try {
            const premiumCalculationDetailsRecord = await this.opportunityRepository.manager.transaction(async (transactionalEntityManager) => {
                // Save premium cover details
                await this.savePremiumCoverDetails(transactionalEntityManager, premiumCalculationDetails);
                // Save OpportunityPremiumCalculation summary
                const premiumCalculationSummary = transactionalEntityManager.create(entities_1.OpportunityPremiumCalculation, {
                    opportunityId,
                    activityId,
                    opportunityActivityId,
                    remarks,
                    statusLid,
                    createdBy,
                    updatedBy: createdBy,
                });
                const savedPremiumCalculation = await this.savePremiumCalculation(transactionalEntityManager, premiumCalculationSummary);
                // Save document records if present
                if (documents && documents.length > 0) {
                    const documentRecords = documents.map((doc) => transactionalEntityManager.create(entities_1.OpportunityPremiumCalculationDocumentMap, {
                        opportunityActivityId,
                        documentId: doc.documentId,
                        documentTypeLid: doc.documentTypeLid,
                    }));
                    await this.savePremiumCalculationDocuments(transactionalEntityManager, documentRecords);
                }
                return {
                    ...savedPremiumCalculation,
                    premiumCalculationDetails: premiumCalculationDetails,
                    documents: documents,
                };
            });
            return premiumCalculationDetailsRecord;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException) {
                throw error; // Re-throw known exceptions
            }
            throw new common_1.BadRequestException(`Failed to save premium calculation details: ${error.message}`);
        }
    }
    async getPremiumCalculationCoverDetailsByActivityId(opportunityid) {
        try {
            const premiumCalculationCoverDetails = await this.opportunityRepository.manager.find(entities_1.OpportunityPremiumCoverDetail, {
                where: { opportunityId: opportunityid },
                relations: ["coverMap"],
            });
            if (!premiumCalculationCoverDetails ||
                premiumCalculationCoverDetails.length === 0) {
                return [];
            }
            return premiumCalculationCoverDetails.map((detail) => ({
                id: detail.id,
                coverMapId: detail.coverMapId,
                coverName: detail.coverMap?.coverName,
                policyTypeId: detail.policyTypeLid,
                coverResponse: detail.coverResponse,
            }));
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to fetch premium calculation cover details: ${error.message}`);
        }
    }
    async getPremiumCalculationDocumentsByActivityId(opportunityActivityId) {
        try {
            const documents = await this.opportunityRepository.manager.find(entities_1.OpportunityPremiumCalculationDocumentMap, {
                where: { opportunityActivityId },
            });
            if (!documents || documents.length === 0) {
                return [];
            }
            return documents.map((doc) => ({
                id: doc.id,
                documentId: doc.documentId,
                documentTypeLid: doc.documentTypeLid,
            }));
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to fetch premium calculation documents: ${error.message}`);
        }
    }
    async createOpportunityLostActivity(entityManager, opportunityLostData) {
        try {
            const opportunityLost = entityManager.create(entities_1.OpportunityLost, opportunityLostData);
            return await entityManager.save(entities_1.OpportunityLost, opportunityLost);
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to create Opportunity Lost Activity: ${error.message}`);
        }
    }
    async updateOpportunityStatus(entityManager, opportunityId, opportunityStatus) {
        try {
            const taskType = await this.lookUpRepository.findOne({
                where: { lookUpKey: opportunityStatus },
            });
            if (!taskType) {
                throw new common_1.NotFoundException(`Task type with key ${opportunityStatus} not found`);
            }
            const opportunity = await entityManager.findOne(entities_1.Opportunity, {
                where: { opportunityId: opportunityId },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${opportunityId} not found.`);
            }
            await entityManager.update(entities_1.Opportunity, { opportunityId: opportunityId }, { statusLid: taskType.id });
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to update Opportunity status for opportunity: ${error.message}`);
        }
    }
    async updateOpportunityLostActivity(entityManager, opportunityActivityId, opportunityLostData) {
        try {
            const existingOpportunityLost = await entityManager.findOne(entities_1.OpportunityLost, { where: { opportunityActivityId } });
            if (!existingOpportunityLost) {
                throw new common_1.NotFoundException(`Opportunity Lost Activity with opportunity activity ID ${opportunityActivityId} not found`);
            }
            const status = await this.lookUpRepository.findOne({
                where: { id: existingOpportunityLost.statusLid },
            });
            if (!status) {
                throw new common_1.NotFoundException(`Status with ID ${existingOpportunityLost.statusLid} not found`);
            }
            if (status.lookUpKey == constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED) {
                throw new common_1.BadRequestException(`Opportunity lost with opportunity activity ID ${opportunityActivityId} is already submitted, you cannot modify it.`);
            }
            await entityManager.update(entities_1.OpportunityLost, { id: existingOpportunityLost.id }, opportunityLostData);
            return await entityManager.findOne(entities_1.OpportunityLost, {
                where: { id: existingOpportunityLost.id },
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to update Opportunity Lost Activity: ${error.message}`);
        }
    }
    async getOpportunityLostActivity(opportunityId, activityId) {
        try {
            const opportunityLostActivity = await this.opportunityRepository.manager.findOne(entities_1.OpportunityLost, {
                where: { opportunityId, activityId },
            });
            if (!opportunityLostActivity) {
                throw new common_1.NotFoundException(`Opportunity Lost Activity not found for Opportunity ID: ${opportunityId} and Activity ID: ${activityId}`);
            }
            return {
                id: opportunityLostActivity.id,
                opportunityId: opportunityLostActivity.opportunityId,
                activityId: opportunityLostActivity.activityId,
                opportunityActivityId: opportunityLostActivity.opportunityActivityId,
                statusLid: opportunityLostActivity.statusLid,
                dataActivity: {
                    opportunityLost: {
                        reasonForLossLid: opportunityLostActivity.reasonForLossLid,
                        remarks: opportunityLostActivity.remarks,
                    },
                },
            };
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(`Failed to fetch Opportunity Lost Activity: ${error.message}`);
        }
    }
    async getBrokingSlipAndQuoteDetailsData(opportunityActivityMapData) {
        try {
            const brokingSlipVersionDetails = await this.opportunityRepository.manager.find(entities_1.BrokingSlipVersionDetails, {
                where: { opportunityId: opportunityActivityMapData.opportunityId },
                relations: ["quoteEntry", "quoteEntry.insurer"],
                select: [
                    "id",
                    "brokingSlipVersion",
                    "brokingSlipName",
                    "opportunityId",
                ],
            });
            if (brokingSlipVersionDetails) {
                (0, response_utils_1.removeMetadataFields)(brokingSlipVersionDetails);
                (0, response_utils_1.removeLookUpDataFields)(brokingSlipVersionDetails);
            }
            return brokingSlipVersionDetails;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async createQuoteComparisonReport(entityManager, dto, userId) {
        try {
            const newRecord = entityManager.create(entities_1.OpportunityQuoteComparisonReport, {
                ...dto,
                createdBy: userId,
                updatedBy: userId,
                createdAt: new Date(),
                updatedAt: new Date(),
            });
            const savedRecord = await entityManager.save(entities_1.OpportunityQuoteComparisonReport, newRecord);
            return savedRecord;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.quoteComparisonReportCreationFailed);
        }
    }
    async saveQuoteComparisonReportDocuments(quoteComparisonReportId, documents, entityManager) {
        const documentRecords = documents.map((doc) => entityManager.create(entities_1.OpportunityQuoteComparisonReportDocumentMap, {
            quoteComparisonReportId,
            documentId: doc.documentId,
            documentTypeLid: doc.documentTypeLid,
        }));
        await entityManager.save(entities_1.OpportunityQuoteComparisonReportDocumentMap, documentRecords);
    }
    async getQuoteComparisonReportByOpportunityActivityId(opportunityActivityId) {
        try {
            const quoteComparisonReport = await this.opportunityRepository.manager.findOne(entities_1.OpportunityQuoteComparisonReport, {
                where: { opportunityActivityId: opportunityActivityId },
                relations: ["documents", "opportunity", "status"],
            });
            if (quoteComparisonReport) {
                (0, response_utils_1.removeMetadataFields)(quoteComparisonReport);
                (0, response_utils_1.removeLookUpDataFields)(quoteComparisonReport);
            }
            return quoteComparisonReport || null;
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async getActivityById(activityId) {
        return this.opportunityRepository.manager.findOne(entities_1.MstrActivity, {
            where: { id: activityId },
        });
    }
    async getAllPremiumCalculationCovers(opportunityId, coverTypeLid) {
        try {
            const opportunityData = await this.opportunityRepository.findOne({
                where: { opportunityId },
            });
            if (!opportunityData) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotPresent(opportunityId));
            }
            const covers = await this.getPremiumCalculationCovers(opportunityId, opportunityData.policyTypeLid, coverTypeLid);
            if (!covers.length) {
                throw new common_1.NotFoundException(messages_1.errorMessages.opportunityNotPresent(opportunityId));
            }
            return covers.map((cover) => ({
                id: cover.id,
                opportunityId: cover.opportunityId,
                policyTypeId: cover.policyTypeId,
                coverId: cover.coverId,
                mandatory: cover.mandateType,
                approvalRequired: cover.approvalRequired,
                coverName: cover.coverName,
                coverDescription: cover.coverDescription,
                displaySequence: cover.displaySequence,
                displayCategory: cover.displayCategory,
                coverTypeLid: cover.coverTypeLid,
                inputType: cover.inputType,
                inputLov: cover.inputLov,
                coversMeta: cover.coversMeta,
            }));
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error);
        }
    }
    async updateQuoteComparisonReportActivity(entityManager, quoteComparisonReportId, updateData, userId) {
        try {
            const fieldsToUpdate = {
                ...updateData,
                updatedBy: userId,
                updatedAt: new Date(),
            };
            // Perform the update
            await entityManager.update(entities_1.OpportunityQuoteComparisonReport, { id: quoteComparisonReportId }, fieldsToUpdate);
            return fieldsToUpdate;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to update quote comparison report: ${error.message}`);
        }
    }
    async fetchQuoteCoverDetails(brokingSlipVersion, quoteEntryIds) {
        // Input validation
        if (typeof brokingSlipVersion !== "number" ||
            !Array.isArray(quoteEntryIds) ||
            quoteEntryIds.length === 0) {
            throw new common_1.BadRequestException("brokingSlipVersion (number) and quoteEntryIds (non-empty array) are required.");
        }
        // Fetch quotes with required relations and filters
        const quotes = await this.quoteRepo.find({
            where: {
                brokingSlipId: brokingSlipVersion,
                id: (0, typeorm_2.In)(quoteEntryIds),
            },
            relations: ["coverDetails", "insurer", "status"],
        });
        if (!quotes || quotes.length === 0) {
            throw new common_1.NotFoundException(`No quotes found for brokingSlipVersion ${brokingSlipVersion} and provided quoteEntryIds.`);
        }
        if (quotes && quotes.length > 0) {
            quotes.forEach((quote) => {
                (0, response_utils_1.removeMetadataFields)(quote);
                (0, response_utils_1.removeLookUpDataFields)(quote);
            });
        }
        return quotes;
    }
    async getOpportunityCoverDetailsById(ids) {
        try {
            const opportunityCoverData = await this.opportunityRepository.manager.find(entities_1.OpportunityCoverMap, {
                where: { id: (0, typeorm_2.In)(ids) },
                select: ["id", "coverId", "coverName", "coverTypeLid"],
            });
            if (opportunityCoverData) {
                (0, response_utils_1.removeMetadataFields)(opportunityCoverData);
                (0, response_utils_1.removeLookUpDataFields)(opportunityCoverData);
            }
            return opportunityCoverData || null;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : messages_1.errorMessages.opportunityCoverNotFound);
        }
    }
    async fetchOpportunityById(id) {
        try {
            const opportunity = await this.opportunityRepository.findOne({
                where: { opportunityId: id },
            });
            if (!opportunity) {
                throw new common_1.NotFoundException(`Opportunity with ID ${id} not found.`);
            }
            return opportunity;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException(`Failed to fetch opportunity with ID ${id}.`);
        }
    }
    async fetchOpportunityContacts(companyId) {
        try {
            const opportunityContacts = await this.companyContactMapRepo.find({
                where: { companyId: companyId },
                relations: ["contact"],
            });
            if (!opportunityContacts || opportunityContacts.length === 0) {
                return [];
            }
            return opportunityContacts;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException(`Failed to fetch contacts for opportunity with ID ${opportunityId}.`);
        }
    }
    async savePlacementSlipDocuments(placementSlipId, documents, entityManager) {
        const documentRecords = documents.map((doc) => entityManager.create(entities_1.OpportunityPlacementSlipDocumentMap, {
            placementSlipId,
            documentId: doc.documentId,
            documentTypeLid: doc.documentTypeLid,
        }));
        await entityManager.save(entities_1.OpportunityPlacementSlipDocumentMap, documentRecords);
    }
    async findOpportunityQuoteById(id, manager) {
        return manager.findOne(entities_1.OpportunityQuoteEntry, { where: { id } });
    }
    async createOpportunityQuote(manager, id, payload) {
        const record = manager.create(entities_1.OpportunityQuote, {
            id,
            remarks: payload.remarks ?? null,
            statusLid: payload.statusLid ?? null,
            opportunityActivityId: payload.opportunityActivityId ?? null,
        });
        return manager.save(entities_1.OpportunityQuote, record);
    }
    async getQuoteDetailsByOpportunityActivityId(entityManager, opportunityActivityId) {
        if (!opportunityActivityId) {
            throw new common_1.BadRequestException("opportunityActivityId is required.");
        }
        return entityManager.findOne(entities_1.OpportunityQuote, {
            where: { opportunityActivityId: opportunityActivityId },
        });
    }
    async upsertOpportunityQuote(manager, id, payload) {
        console.log("Upserting Opportunity Quote with ID:", id, "Payload:", payload);
        const existingQuote = await manager.findOne(entities_1.OpportunityQuote, {
            where: { opportunityActivityId: payload.opportunityActivityId },
        });
        if (existingQuote) {
            console.log("Existing Opportunity Quote found. Updating...");
            await manager.update(entities_1.OpportunityQuote, { id }, {
                remarks: payload.remarks ?? null,
                statusLid: payload.statusLid ?? null,
                opportunityActivityId: payload.opportunityActivityId ?? null,
            });
        }
        else {
            console.log("No existing Opportunity Quote found. Creating new...");
            const newQuote = manager.create(entities_1.OpportunityQuote, {
                id,
                remarks: payload.remarks ?? null,
                statusLid: payload.statusLid ?? null,
                opportunityActivityId: payload.opportunityActivityId ?? null,
            });
            await manager.save(entities_1.OpportunityQuote, newQuote);
        }
    }
    createOpportunityQuoteDocumentMappings(quoteId, documents) {
        return documents.map((doc) => this.quoteDocRepo.create({
            opportunityActivityId: quoteId,
            documentId: doc.documentId,
            documentTypeLid: doc.documentTypeLid ?? null,
        }));
    }
    async saveOpportunityQuoteDocumentMappings(manager, records) {
        await manager.save(entities_1.OpportunityQuoteDocumentMap, records);
    }
    async upsertOpportunityQuoteDocumentMapping(quoteId, mainDocuments, manager) {
        for (const document of mainDocuments) {
            const { documentId, documentTypeLid } = document;
            // Check if the combination of quoteId and documentId already exists
            const existingMapping = await manager.findOne(entities_1.OpportunityQuoteDocumentMap, {
                where: { opportunityActivityId: quoteId, documentId: documentId },
            });
            // If the combination doesn't exist, insert a new record
            if (!existingMapping) {
                const newMapping = manager.create(entities_1.OpportunityQuoteDocumentMap, {
                    opportunityActivityId: quoteId,
                    documentId: documentId,
                    documentTypeLid: documentTypeLid ?? null,
                });
                await manager.save(entities_1.OpportunityQuoteDocumentMap, newMapping);
            }
        }
    }
    async getBrokingSlipDetailsById(brokingSlipId) {
        try {
            if (!brokingSlipId) {
                throw new common_1.BadRequestException("brokingSlipId is required.");
            }
            const brokingSlipDetails = await this.opportunityRepository.manager.findOne(entities_1.BrokingSlipVersionDetails, {
                where: { id: brokingSlipId },
                select: ["sumInsured", "policyFrom", "policyTo", "createdAt"],
            });
            if (!brokingSlipDetails) {
                throw new common_1.NotFoundException(`Broking slip with ID ${brokingSlipId} not found.`);
            }
            return brokingSlipDetails;
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException ||
                error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException(`Failed to fetch broking slip details: ${error.message}`);
        }
    }
    async findQuoteEntryDetailsByOpportunityActivityId(opportunityActivityId) {
        try {
            if (!opportunityActivityId) {
                throw new common_1.BadRequestException("opportunityActivityId is required.");
            }
            return await this.quoteRepo
                .createQueryBuilder("entry")
                .leftJoinAndMapOne("entry.opportunityQuote", entities_1.OpportunityQuote, "quote", "quote.opportunityActivityId = entry.opportunityActivityId")
                .leftJoinAndMapMany("entry.quoteDocuments", entities_1.OpportunityQuoteDocumentMap, "quoteDoc", "quoteDoc.opportunityActivityId = entry.opportunityActivityId")
                .where("entry.opportunityActivityId = :opportunityActivityId", {
                opportunityActivityId,
            })
                .andWhere("entry.deleted_at IS NULL")
                .getOne();
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException ||
                error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.BadRequestException(messages_1.errorMessages.quoteRetrievalFailed);
        }
    }
    async savePremiumCalculation(entityManager, premiumCalculation) {
        return await entityManager.save(entities_1.OpportunityPremiumCalculation, premiumCalculation);
    }
    async savePremiumCoverDetails(entityManager, coverDetails) {
        return await entityManager.save(entities_1.OpportunityPremiumCoverDetail, coverDetails);
    }
    async savePremiumCalculationDocuments(entityManager, documents) {
        return await entityManager.save(entities_1.OpportunityPremiumCalculationDocumentMap, documents);
    }
    async getActivityData(entity, id) {
        return this.entityService.getDataById(entity, id);
    }
    async createOpportunityQuoteData(payload, opportunityActivityId) {
        try {
            const newQuote = this.opportunityQuoteRepo.create({
                // Initialize with default values or leave empty for now
                remarks: payload?.remarks ?? null,
                statusLid: payload?.statusLid ?? null,
                opportunityActivityId: opportunityActivityId,
            });
            return this.opportunityQuoteRepo.save(newQuote);
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to create Opportunity Quote: ${error.message}`);
        }
    }
    async getPolicyById(policyId) {
        try {
            const policy = await this.opportunityRepository.manager.findOne(entities_1.Policy, {
                where: { id: policyId },
                relations: [
                    "company",
                    "company.companyContactMaps",
                    "company.priority",
                    "opportunity",
                    "opportunity.serviceLevel",
                    "opportunity.stage",
                    "tpaMappings",
                    "tpaMappings.tpa",
                    "tpaMappings.tpaBranch",
                    "insurerMappings",
                    "insurerMappings.insurer",
                    "insurerMappings.insurerBranch",
                    "insurerMappings.insurerContact",
                    "insurerMappings.insurerParticipationType",
                    "coverMappings",
                    "premiumInstallments",
                    "cdMappings",
                    "cdMappings.cdDetail",
                    "configurationStatus",
                    "enrollmentStatus",
                    "policyStatus",
                ],
            });
            if (!policy) {
                throw new common_1.NotFoundException(`Policy with ID ${policyId} not found.`);
            }
            if (policy) {
                (0, response_utils_1.removeMetadataFields)(policy);
                (0, response_utils_1.removeLookUpDataFields)(policy);
            }
            console.log("Policy fetched successfully:", policy);
            const tranformedPolicy = this.transformPolicyResponse(policy);
            return tranformedPolicy;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to fetch policy with ID ${policyId}: ${error.message}`);
        }
    }
    async updateOpportunityQuote(entityManager, id, updateData) {
        // Validate required fields
        // Find the existing OpportunityQuote
        const opportunityQuote = await entityManager.findOne(entities_1.OpportunityQuote, {
            where: { id },
        });
        if (!opportunityQuote) {
            throw new Error(`OpportunityQuote with ID ${id} not found.`);
        }
        // Update fields
        opportunityQuote.remarks = updateData?.remarks ?? null;
        opportunityQuote.statusLid = updateData?.statusLid;
        opportunityQuote.opportunityActivityId = updateData.opportunityActivityId;
        // Save and return the updated entity
        return await entityManager.save(entities_1.OpportunityQuote, opportunityQuote);
    }
    async getQuoteByOpportunityActivityId(opportunityActivityId) {
        if (!opportunityActivityId) {
            throw new common_1.BadRequestException("opportunityActivityId is required.");
        }
        const quote = await this.opportunityQuoteRepo.findOne({
            where: { opportunityActivityId: opportunityActivityId },
        });
        const documents = await this.getQuoteDocuments(opportunityActivityId);
        return { ...quote, documents: documents || [] };
    }
    async getQuoteDocuments(opportunityActivityId) {
        const documents = await this.quoteDocRepo.find({
            where: { opportunityActivityId: opportunityActivityId },
        });
        if (documents?.length > 0) {
            (0, response_utils_1.removeMetadataFields)(documents);
            (0, response_utils_1.removeLookUpDataFields)(documents);
        }
        return documents;
    }
    async fetchBrokingSlipCoverDetails(brokingSlipVersion, opportunityId) {
        // Input validation
        if (typeof opportunityId !== "number") {
            throw new common_1.BadRequestException("Opportunity Id is required.");
        }
        if (typeof brokingSlipVersion !== "number") {
            throw new common_1.BadRequestException("BrokingSlipVersion is required.");
        }
        const brokingSlipCoverDetails = await this.opportunityRepository.manager.find(entities_1.BrokingSlipVersionCoverDetails, {
            where: {
                brokingSlipVersionId: brokingSlipVersion,
                opportunityId: opportunityId,
            },
        });
        if (brokingSlipCoverDetails && brokingSlipCoverDetails.length > 0) {
            brokingSlipCoverDetails.forEach((brokingSlipCoverDetail) => {
                (0, response_utils_1.removeMetadataFields)(brokingSlipCoverDetail);
                (0, response_utils_1.removeLookUpDataFields)(brokingSlipCoverDetail);
            });
        }
        return brokingSlipCoverDetails;
    }
    async getPlacementSlipCoverDetailsByOpportunityId(opportunityId) {
        try {
            const covers = await this.coverRepo.find({ where: { opportunityId } });
            if (covers && covers.length > 0) {
                (0, response_utils_1.removeMetadataFields)(covers);
                (0, response_utils_1.removeLookUpDataFields)(covers);
            }
            return covers;
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to fetch placement slip covers: ${error instanceof Error ? error.message : error}`);
        }
    }
    async opportunityActivityApproval(opportunityActivityId, userId) {
        try {
            const opportunityActivity = await this.opportunityActivityMapRepository.findOne({
                where: { id: opportunityActivityId },
            });
            if (!opportunityActivity) {
                throw new common_1.NotFoundException(`Opportunity activity with ID ${opportunityActivityId} not found.`);
            }
            const status = await this.lookUpRepository.findOne({
                where: { id: opportunityActivity.statusLid },
            });
            if (!status) {
                throw new common_1.NotFoundException(`Status with ID ${opportunityActivity.statusLid} not found.`);
            }
            if (status.lookUpKey !== constants_2.OPPORTUNITY_ACTIVITY_STATUS.SUBMITTED) {
                throw new common_1.BadRequestException(`Opportunity activity with ID ${opportunityActivityId} is not submitted.`);
            }
            // Update the status to APPROVED
            const approvedStatus = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED },
            });
            if (!approvedStatus) {
                throw new common_1.NotFoundException(`Approved status not found for key ${constants_2.OPPORTUNITY_ACTIVITY_STATUS.CLOSED}.`);
            }
            // Update the task status to closed
            const taskStatus = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_2.TASK_STATUS_CLOSED },
            });
            if (!taskStatus) {
                throw new common_1.NotFoundException(`Task status not found for key ${constants_2.TASK_STATUS_CLOSED}.`);
            }
            const activityTable = opportunityActivity.opportunityTable;
            switch (activityTable) {
                case "opportunity_rfp_details_entry":
                    await this.updateRfpDetails(opportunityActivity, userId, taskStatus.id, approvedStatus.id);
                    break;
                case "opportunity_placement_slip_generation":
                    await this.updatePlacementSlipData(opportunityActivity, userId, taskStatus.id, approvedStatus.id);
                    break;
                default:
                    throw new common_1.BadRequestException(`This activity ${opportunityActivity.activityName} is not supported for approval.`);
            }
            await this.opportunityActivityMapRepository.update({ id: opportunityActivityId }, {
                statusLid: approvedStatus.id,
                updatedBy: userId,
            });
            return await this.opportunityActivityMapRepository.findOne({
                where: { id: opportunityActivityId },
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to approve opportunity activity: ${error instanceof Error ? error.message : error}`);
        }
    }
    async createPolicyFromPlacementSlip(placementSlipId, userId) {
        try {
            return await this.opportunityRepository.manager.transaction(async (manager) => {
                // Call repository to create policy and related details
                const policy = await this.createPolicyWithDetails(placementSlipId, userId, manager);
                return policy;
            });
        }
        catch (error) {
            console.error("Error in createPolicyFromPlacementSlip:", error);
            throw new common_1.BadRequestException(error instanceof Error ? error.message : "Failed to create policy.");
        }
    }
    async getAllPolicies() {
        try {
            const policies = await this.opportunityRepository.manager.find(entities_1.Policy, {
                relations: [
                    "company",
                    "company.companyContactMaps",
                    "company.priority",
                    "opportunity",
                    "opportunity.serviceLevel",
                    "tpaMappings",
                    "tpaMappings.tpa",
                    "tpaMappings.tpaBranch",
                    "insurerMappings",
                    "insurerMappings.insurer",
                    "insurerMappings.insurerBranch",
                    "insurerMappings.insurerContact",
                    "coverMappings",
                    "premiumInstallments",
                    "cdMappings",
                    "cdMappings.cdDetail",
                    "configurationStatus",
                    "enrollmentStatus",
                    "policyStatus",
                ],
            });
            let tranformedPolicy = [];
            if (policies && policies.length > 0) {
                tranformedPolicy = policies.map((policy) => {
                    (0, response_utils_1.removeMetadataFields)(policy);
                    (0, response_utils_1.removeLookUpDataFields)(policy);
                    return this.transformPolicyResponse(policy);
                });
            }
            return tranformedPolicy;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to fetch policies: ${error.message}`);
        }
    }
    async updateRfpDetails(opportunityActivity, userId, taskStatusId, activityStatusId) {
        try {
            await this.opportunityRepository.manager.transaction(async (manager) => {
                const rfpCoverDetails = await manager.find(entities_1.OpportunityRfpDetailsEntry, {
                    where: { opportunityActivityId: opportunityActivity.id },
                });
                if (!rfpCoverDetails) {
                    throw new common_1.NotFoundException(`No RFP data found for opportunity ID ${opportunityActivity.opportunityId}.`);
                }
                await manager.update(entities_1.OpportunityRfpDetailsEntry, { opportunityActivityId: opportunityActivity.id }, {
                    statusLid: activityStatusId,
                    updatedBy: userId,
                });
                await manager.update(entities_1.Task, { activityId: opportunityActivity.id }, {
                    taskStatusLid: taskStatusId,
                    taskClose: constants_2.TASK_CLOSED,
                    updatedBy: userId,
                });
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to update RFP data: ${error instanceof Error ? error.message : error}`);
        }
    }
    async updatePlacementSlipData(opportunityActivity, userId, taskStatusId, activityStatusId) {
        try {
            await this.opportunityRepository.manager.transaction(async (manager) => {
                const placementSlipDetails = await manager.find(entities_1.OpportunityPlacementSlipGeneration, { where: { opportunityActivityId: opportunityActivity.id } });
                if (!placementSlipDetails || placementSlipDetails.length === 0) {
                    throw new common_1.NotFoundException(`No Placement Slip data found for opportunity ID ${opportunityActivity.opportunityId}.`);
                }
                await manager.update(entities_1.OpportunityPlacementSlipGeneration, { opportunityActivityId: opportunityActivity.id }, {
                    statusLid: activityStatusId,
                    updatedBy: userId,
                });
                await manager.update(entities_1.Task, { activityId: opportunityActivity.id }, {
                    taskStatusLid: taskStatusId,
                    taskClose: constants_2.TASK_CLOSED,
                    updatedBy: userId,
                });
                this.createPolicyFromPlacementSlip(placementSlipDetails[0].id, userId);
            });
        }
        catch (error) {
            throw new common_1.BadRequestException(`Failed to update Placement Slip data: ${error instanceof Error ? error.message : error}`);
        }
    }
};
exports.OpportunityRepository = OpportunityRepository;
exports.OpportunityRepository = OpportunityRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(entities_1.Opportunity)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(entities_1.OpportunityContactMap)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(entities_1.LookUp)),
    tslib_1.__param(3, (0, typeorm_1.InjectRepository)(entities_1.OpportunityActivityMap)),
    tslib_1.__param(4, (0, typeorm_1.InjectRepository)(entities_1.OpportunityActivityParticipants)),
    tslib_1.__param(5, (0, typeorm_1.InjectRepository)(entities_1.DataValidation)),
    tslib_1.__param(6, (0, typeorm_1.InjectRepository)(entities_1.KdmMeeting)),
    tslib_1.__param(7, (0, typeorm_1.InjectRepository)(entities_1.OpportunityHandOverMeet)),
    tslib_1.__param(8, (0, typeorm_1.InjectRepository)(entities_1.MstrActivity)),
    tslib_1.__param(9, (0, typeorm_1.InjectRepository)(entities_1.OpportunityMandateDetailsEntry)),
    tslib_1.__param(10, (0, typeorm_1.InjectRepository)(entities_1.OpportunityRfpCoverDetail)),
    tslib_1.__param(11, (0, typeorm_1.InjectRepository)(entities_1.OpportunityQuoteEntry)),
    tslib_1.__param(12, (0, typeorm_1.InjectRepository)(entities_1.OpportunityQuote)),
    tslib_1.__param(13, (0, typeorm_1.InjectRepository)(entities_1.OpportunityQuoteEntryDocumentMap)),
    tslib_1.__param(14, (0, typeorm_1.InjectRepository)(entities_1.OpportunityQuoteTaxMap)),
    tslib_1.__param(15, (0, typeorm_1.InjectRepository)(entities_1.OpportunityQuoteDocumentMap)),
    tslib_1.__param(16, (0, typeorm_1.InjectRepository)(entities_1.OpportunityPlacementSlipGeneration)),
    tslib_1.__param(17, (0, typeorm_1.InjectRepository)(entities_1.OpportunityPlacementSlipTpaMap)),
    tslib_1.__param(18, (0, typeorm_1.InjectRepository)(entities_1.OpportunityPlacementSlipInstallementDetail)),
    tslib_1.__param(19, (0, typeorm_1.InjectRepository)(entities_1.OpportunityPlacementSlipInsurerMap)),
    tslib_1.__param(20, (0, typeorm_1.InjectRepository)(entities_1.OpportunityPlacementSlipSharingDetail)),
    tslib_1.__param(21, (0, typeorm_1.InjectRepository)(entities_1.OpportunityPlacementSlipCDDetail)),
    tslib_1.__param(22, (0, typeorm_1.InjectRepository)(entities_1.OpportunityPlacementSlipCoverDetail)),
    tslib_1.__param(23, (0, typeorm_1.InjectRepository)(entities_1.CompanyContactMap)),
    tslib_1.__param(24, (0, typeorm_1.InjectRepository)(entities_1.OpportunityRfpDetailsEntry)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object, typeof (_d = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _d : Object, typeof (_e = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _e : Object, typeof (_f = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _f : Object, typeof (_g = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _g : Object, typeof (_h = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _h : Object, typeof (_j = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _j : Object, typeof (_k = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _k : Object, typeof (_l = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _l : Object, typeof (_m = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _m : Object, typeof (_o = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _o : Object, typeof (_p = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _p : Object, typeof (_q = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _q : Object, typeof (_r = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _r : Object, typeof (_s = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _s : Object, typeof (_t = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _t : Object, typeof (_u = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _u : Object, typeof (_v = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _v : Object, typeof (_w = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _w : Object, typeof (_x = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _x : Object, typeof (_y = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _y : Object, typeof (_z = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _z : Object, typeof (_0 = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _0 : Object, typeof (_1 = typeof entity_service_utils_1.EntityService !== "undefined" && entity_service_utils_1.EntityService) === "function" ? _1 : Object, typeof (_2 = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _2 : Object])
], OpportunityRepository);
